import memoizeOne from 'memoize-one';
import PhoneInput from 'react-phone-input-2';
import QRCode from 'qrcode.react';
import ReactDOM from 'react-dom';
import { hsl, parseToHsl, parseToRgb, readableColor } from 'polished';
import { FormattedMessage, FormattedHTMLMessage, defineMessages, injectIntl } from 'react-intl';
import Responsive from 'semantic-ui-react/dist/commonjs/addons/Responsive';
import Dropdown from 'semantic-ui-react/dist/commonjs/modules/Dropdown';
import Menu from 'semantic-ui-react/dist/commonjs/collections/Menu';
import Sidebar from 'semantic-ui-react/dist/commonjs/modules/Sidebar';
import Transition from 'semantic-ui-react/dist/commonjs/modules/Transition';
import React, { Component, Children, Fragment, createRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes, withTheme } from 'styled-components';
import { union, symmetricDifference, isEmpty, equals, reduce, filter, mapObjIndexed, complement, keys, isNil, pickBy } from 'ramda';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var logo = "data:image/svg+xml;base64,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";

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 18px;\n  line-height: 1.67;\n  margin: 0 40px 40px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 18px;\n  margin: 40px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 30px;\n  line-height: normal;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  padding: 35px;\n  max-width: 250px;\n  width: 50%;\n  vertical-align: middle;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #1a1919;\n  padding: 20px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ErrorWrapper = styled.div(_templateObject());
var Image = styled.img(_templateObject2());
var ErrorHeader = styled.div(_templateObject3());
var ErrorMessage = styled.div(_templateObject4());
var ErrorHelp = styled.div(_templateObject5());

var FatalError = function FatalError(_ref) {
  var message = _ref.message;
  return React.createElement(ErrorWrapper, null, React.createElement(Image, {
    src: logo
  }), React.createElement(ErrorHeader, null, React.createElement(FormattedMessage, {
    id: "2244720377",
    defaultMessage: "An unexpected error seems to have occurred."
  })), React.createElement(ErrorMessage, null, message), React.createElement(ErrorHelp, null, React.createElement(FormattedHTMLMessage, {
    id: "2800896234",
    defaultMessage: "We're investigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>."
  })));
};

FatalError.propTypes = {
  message: PropTypes.string.isRequired
};

var SingleValueForm =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(SingleValueForm, _Component);

  function SingleValueForm(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.onChange = function (value) {
      _this.setState({
        value: value,
        invalid: false
      });
    };

    _this.onSubmit = function (event) {
      event.preventDefault();
      var value = _this.state.value;

      if (_this.props.trim === true) {
        value = value.trim();
      }

      if (value.length > 0) {
        _this.props.onSubmit(value);
      } else {
        _this.setState({
          invalid: true
        });
      }
    };

    _this.render = function () {
      return React.createElement("form", {
        onSubmit: _this.onSubmit
      }, _this.props.render(_objectSpread({}, _this.state, {
        onChange: _this.onChange
      })));
    };

    _this.state = {
      value: props.value,
      invalid: false
    };
    return _this;
  }

  return SingleValueForm;
}(Component);

SingleValueForm.defaultProps = {
  value: ""
};
SingleValueForm.displayName = "SingleValueForm";
SingleValueForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  trim: PropTypes.bool,
  value: PropTypes.string
};
var CHALLENGES = {
  lower: /[a-z]/,
  upper: /[A-Z]/,
  numbers: /[0-9]/,
  specials: /[^a-zA-Z0-9]/,
  letters: /[a-zA-Z]/
};

var passwordValidator = function passwordValidator(rules) {
  var _rules$complexity = rules.complexity,
      challenges = _rules$complexity.challenges,
      min = _rules$complexity.min,
      required = _rules$complexity.required;
  var requiredPasswordLength = rules.length;
  return function (password) {
    var errors = challengesMet(challenges, password, min);
    var requiredErrors = challengesMet(required, password);

    if (password.length < requiredPasswordLength) {
      requiredErrors.unshift("length");
    }

    if (requiredErrors.length) {
      return union(requiredErrors, errors);
    } else {
      return errors;
    }
  };
};

var challengesMet = function challengesMet(challenges, password, min) {
  if (min === void 0) {
    min = Infinity;
  }

  var errors = challenges.filter(function (name) {
    return !CHALLENGES[name].test(password);
  });
  var minSatisfied = challenges.length - errors.length >= min;
  return minSatisfied ? [] : errors;
};

var incompleteChallenges = memoizeOne(function (value, rules) {
  var validator = passwordValidator(rules);
  return validator(value);
}, equals);
var requiredChallenges = memoizeOne(function (rules) {
  var validator = passwordValidator(rules);
  return validator("");
}, equals);

var PasswordComplexity = function PasswordComplexity(_ref) {
  var value = _ref.value,
      rules = _ref.rules,
      render = _ref.render,
      restProps = _objectWithoutPropertiesLoose(_ref, ["value", "rules", "render"]);

  var incomplete = incompleteChallenges(value, rules);
  var required = requiredChallenges(rules);
  return render(_objectSpread({
    invalid: !isEmpty(incomplete),
    challenges: required,
    completedChallenges: symmetricDifference(incomplete, required)
  }, restProps));
};

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: 24px;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var Content = styled.div(_templateObject$1());
Content.displayName = "Content";
/**
 *  Primary colors
 *
 *  They are mostly used on Call to Action and brand centric elements
 */
// Black and White

var WHITE = "#FFFFFF";
var BLACK = "#000000"; // Action color

var ACTION_COLORS = {
  ONELOGIN_BLUE: "#00A9E0",
  BLUE_MAIN: "#00779E",
  BLUE_LIGHT: "#00BBFA",
  BLUE_MID: "#008FBF",
  BLUE_DARK: "#005E7D",
  BLUE_DARKER: "#00455C",
  // States of BLUE_MAIN
  BLUE_MAIN_HOVER: "#0891BF",
  BLUE_MAIN_ACTIVE: "#005875"
};
/**
 *  Secondary colors
 */
// OneLogin gray colors

var ONELOGIN_GRAY_COLORS = {
  ONELOGIN_BLACK: "#1C1F2A",
  ONELOGIN_GRAY_DARK: "#494B54",
  ONELOGIN_GRAY_MID: "#76787F",
  ONELOGIN_GRAY: "#A4A5A9",
  ONELOGIN_SILVER: "#D1D2D4",
  ONELOGIN_GRAY_LIGHT: "#F3F3F4"
}; // Grayscale (the number affixed is from the Brightness value of HSB in Sketch app)

var GRAY_COLORS = {
  GRAY_99: "#FAFCFC",
  GRAY_98: "#F7F9FA",
  GRAY_97: "#F5F7F7",
  GRAY_96: "#F2F4F5",
  GRAY_94: "#EDEFF0",
  GRAY_92: "#E8EAEB",
  GRAY_90: "#E3E5E6",
  GRAY_88: "#DEE0E0",
  GRAY_84: "#D4D6D6",
  GRAY_78: "#C5C6C7",
  GRAY_68: "#ACADAD",
  GRAY_55: "#8B8C8C",
  GRAY_45: "#727273",
  GRAY_35: "#585959",
  GRAY_25: "#3F4040",
  GRAY_18: "#2D2E2E"
};
/**
 *  Colors for status
 */

var STATUS_COLORS = {
  ERROR: "#D6291A",
  WARNING: "#F29B05",
  SUCCESS: "#5DA30D",
  INFO: ACTION_COLORS.BLUE_MID,
  PROGRESS: ACTION_COLORS.BLUE_MID,
  WHITE: WHITE,
  DARK_GRAY: GRAY_COLORS.GRAY_25
};
/**
 *  Typegraphy colors
 */

var TEXT_COLORS = {
  DEFAULT: GRAY_COLORS.GRAY_35,
  TITLE: GRAY_COLORS.GRAY_25,
  EMPHASIZED: GRAY_COLORS.GRAY_25,
  LINK: ACTION_COLORS.BLUE_MAIN,
  LABEL: GRAY_COLORS.GRAY_45,
  PLACEHOLDER: GRAY_COLORS.GRAY_68,
  DISABLE: GRAY_COLORS.GRAY_78,
  DESCRIPTION_SMALL: GRAY_COLORS.GRAY_55
};
/**
 *  Separator colors
 */

var SEPARATOR_COLORS = {
  REGULAR: GRAY_COLORS.GRAY_94,
  MEDIUM: GRAY_COLORS.GRAY_92,
  STRONG: GRAY_COLORS.GRAY_90,
  LIGHT: GRAY_COLORS.GRAY_84
};
/**
 *  Icon colors
 */

var ICON_COLORS = {
  NORMAL: GRAY_COLORS.GRAY_55,
  HOVER: ACTION_COLORS.BLUE_MAIN_HOVER,
  ACTIVE: ACTION_COLORS.BLUE_MAIN_ACTIVE,
  SELECTED: ACTION_COLORS.ONELOGIN_BLUE,
  WHITE: WHITE,
  DARK_GRAY: GRAY_COLORS.GRAY_25,
  PLACEHOLDER: GRAY_COLORS.GRAY_84
};
/**
 *  Form colors
 */

var TEXTFIELD_COLORS = {
  BORDER: GRAY_COLORS.GRAY_88,
  BORDER_HOVER: GRAY_COLORS.GRAY_78,
  BORDER_ACTIVE: ACTION_COLORS.ONELOGIN_BLUE,
  BORDER_DISABLED: GRAY_COLORS.GRAY_94,
  BACKGROUND_DISABLED: GRAY_COLORS.GRAY_96,
  BACKGROUND_LOCKED: GRAY_COLORS.GRAY_94
};
/* ----------------------------------------------------- */

/**
 *   Group all settings and export as single constant
 */

var COLORS = {
  WHITE: WHITE,
  BLACK: BLACK,
  ACTION_COLORS: ACTION_COLORS,
  ONELOGIN_GRAY_COLORS: ONELOGIN_GRAY_COLORS,
  GRAY_COLORS: GRAY_COLORS,
  STATUS_COLORS: STATUS_COLORS,
  TEXT_COLORS: TEXT_COLORS,
  SEPARATOR_COLORS: SEPARATOR_COLORS,
  ICON_COLORS: ICON_COLORS,
  TEXTFIELD_COLORS: TEXTFIELD_COLORS
};

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n      text-align: center;\n      align-items: center;\n    "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: 16px 0;\n  color: ", ";\n\n  ", ";\n\n  &:first-child {\n    margin-top: 0px;\n  }\n\n  &:last-child {\n    margin-bottom: 0px;\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var ContentBlock = styled.div(_templateObject$2(), COLORS.TEXT_COLORS.DEFAULT, function (props) {
  return props.centered && css(_templateObject2$1());
});
ContentBlock.displayName = "ContentBlock";
/**
 *  Font family
 */

var FONT_FAMILY = {
  DEFAULT: 'Roboto, "Helvetica Neue", Helvetica, "Segoe UI", Arial, sans-serif',
  MONOSPACE: '"Roboto Mono", monospace'
};
/* ----------------------------------------------------- */

/**
 *  Group all settings and export as single constant
 */

var FONTS = {
  FONT_FAMILY: FONT_FAMILY
}; // sizes for inputs, buttons, etc.

var MEDIUM = "medium";
var LARGE = "large";
var BIG = "big";
var SIZES = {
  MEDIUM: MEDIUM,
  LARGE: LARGE,
  BIG: BIG
};

var _heightMap;

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  background-color: transparent;\n  padding: 0;\n  border: none;\n  border-radius: 2px;\n  color: ", ";\n  cursor: pointer;\n  font-family: ", ";\n  line-height: 1;\n  box-sizing: content-box;\n  text-align: left;\n  padding: 4px 0;\n\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n\n  &:active {\n    color: ", ";\n  }\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n      font-size: 14px;\n      height: 28px;\n    "]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n      font-size: 16px;\n      height: 38px;\n    "]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var heightMap = (_heightMap = {}, _heightMap[SIZES.MEDIUM] = 28, _heightMap[SIZES.LARGE] = 38, _heightMap);

var getSizingDefinitions = function getSizingDefinitions(size) {
  if (size === SIZES.LARGE) {
    return css(_templateObject$3());
  } else {
    // medium (default)
    return css(_templateObject2$2());
  }
};

var StyledButton = styled.button(_templateObject3$1(), function (props) {
  return getSizingDefinitions(props.size);
}, COLORS.TEXT_COLORS.LINK, FONTS.FONT_FAMILY.DEFAULT, COLORS.ACTION_COLORS.BLUE_MAIN_HOVER, COLORS.ACTION_COLORS.BLUE_MAIN_ACTIVE);

var LinkButton = function LinkButton(props) {
  return React.createElement(StyledButton, _extends({
    type: "button"
  }, props));
};

LinkButton.defaultProps = {
  size: SIZES.MEDIUM
};
LinkButton.propTypes = {
  /** onClick handler function */
  onClick: PropTypes.func.isRequired,

  /** link button text size */
  size: PropTypes.oneOf([SIZES.MEDIUM, SIZES.LARGE])
};

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  flex: 1 0 auto;\n  text-align: right;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  flex: 1 0 auto;\n  text-align: right;\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-weight: 400;\n  font-family: ", ";\n  letter-spacing: 0.4px;\n  margin-right: 8px;\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  margin: 0 0 8px 0;\n  display: flex;\n  align-items: center;\n  line-height: 20px;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var LabelWrapper = styled.div(_templateObject$4());
var LabelText = styled.label(_templateObject2$3(), COLORS.TEXT_COLORS.LABEL, FONTS.FONT_FAMILY.DEFAULT);
var InfoText = styled.div(_templateObject3$2(), COLORS.TEXT_COLORS.LABEL);
var RequiredInfo = styled.div(_templateObject4$1(), COLORS.STATUS_COLORS.ERROR);

var Label = function Label(_ref) {
  var forId = _ref.forId,
      action = _ref.action,
      isRequired = _ref.isRequired,
      infoText = _ref.infoText,
      children = _ref.children;
  return React.createElement(LabelWrapper, null, React.createElement(LabelText, {
    htmlFor: forId
  }, children), action && React.createElement(LinkButton, {
    onClick: action.handler
  }, action.title), infoText && React.createElement(InfoText, null, infoText), isRequired && React.createElement(RequiredInfo, null, React.createElement(FormattedMessage, {
    id: "1935535842",
    defaultMessage: "Required"
  })));
};

Label.propTypes = {
  forId: PropTypes.string,
  action: PropTypes.shape({
    title: PropTypes.string.isRequired,
    handler: PropTypes.func.isRequired
  }),
  isRequired: PropTypes.bool,
  infoText: PropTypes.string
};

var _heightMap$1;

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  box-sizing: border-box;\n  width: 100%;\n  border: 1px solid ", ";\n  transition: border-color 0.2s;\n  border-radius: 2px;\n  font-family: ", ";\n  color: ", ";\n  letter-spacing: 0.2px;\n  padding: 0 12px;\n  line-height: normal;\n  background-color: ", ";\n\n  ", ";\n\n  &::-ms-clear {\n    display: none;\n  }\n\n  &::-webkit-credentials-auto-fill-button {\n    visibility: hidden;\n  }\n\n  &::placeholder {\n    color: #acadad;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n    &:hover {\n      border-color: #acadad;\n    }\n\n    &:focus {\n      border-color: ", ";\n    }\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n      border-color: #edeff0;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteralLoose(["\n      border-color: ", ";\n    "]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteralLoose(["\n      border-color: ", ";\n    "]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteralLoose(["\n      font-size: 14px;\n      height: ", "px;\n    "]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n      font-size: 16px;\n      height: ", "px;\n    "]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n      font-size: 18px;\n      height: ", "px;\n    "]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var heightMap$1 = (_heightMap$1 = {}, _heightMap$1[SIZES.MEDIUM] = 38, _heightMap$1[SIZES.LARGE] = 48, _heightMap$1[SIZES.BIG] = 48, _heightMap$1);

var getHeight$1 = function getHeight(size) {
  return heightMap$1[size];
};

var getSizingDefinitions$1 = function getSizingDefinitions(size) {
  if (size === SIZES.BIG) {
    return css(_templateObject$5(), getHeight$1(size));
  } else if (size === SIZES.LARGE) {
    return css(_templateObject2$4(), getHeight$1(size));
  } else {
    // medium (default)
    return css(_templateObject3$3(), getHeight$1(size));
  }
};

var getBorderColorDefinition = function getBorderColorDefinition(_ref) {
  var focused = _ref.focused,
      disabled = _ref.disabled,
      invalid = _ref.invalid;

  if (invalid) {
    return css(_templateObject4$2(), COLORS.STATUS_COLORS.ERROR);
  }

  if (focused) {
    return css(_templateObject5$1(), COLORS.ACTION_COLORS.ONELOGIN_BLUE);
  }

  if (disabled) {
    return css(_templateObject6());
  }

  return css(_templateObject7(), COLORS.ACTION_COLORS.ONELOGIN_BLUE);
};

var getBackgroundColor = function getBackgroundColor(_ref2) {
  var locked = _ref2.locked,
      disabled = _ref2.disabled;

  if (locked) {
    return "#edfaff";
  }

  if (disabled) {
    return "#f2f4f5";
  }

  return COLORS.STATUS_COLORS.WHITE;
};

var Input = styled.input(_templateObject8(), function (props) {
  return getSizingDefinitions$1(props.size);
}, COLORS.GRAY_COLORS.GRAY_88, FONTS.FONT_FAMILY.DEFAULT, COLORS.TEXT_COLORS.EMPHASIZED, function (props) {
  return getBackgroundColor(props);
}, function (props) {
  return getBorderColorDefinition(props);
});
Input.defaultProps = {
  type: "text",
  autoFocus: false,
  disabled: false,
  invalid: false,
  autoComplete: "off",
  autoCorrect: "off",
  spellCheck: "false",
  large: false,
  maxLength: 255,
  focused: false,
  locked: false,
  size: SIZES.MEDIUM
};
Input.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string,
  onBlur: PropTypes.func,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  autoComplete: PropTypes.string,
  autoCorrect: PropTypes.string,
  spellCheck: PropTypes.string,
  maxLength: PropTypes.number,
  name: PropTypes.string,
  autoCapitalize: PropTypes.string,
  size: PropTypes.oneOf([SIZES.MEDIUM, SIZES.LARGE, SIZES.BIG]),
  focused: PropTypes.bool,
  locked: PropTypes.bool
};

function _templateObject4$3() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  line-height: normal;\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteralLoose(["\n  -webkit-text-security: ", ";\n  line-height: ", "px;\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteralLoose(["\n  line-height: ", "px;\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: ", "px; //to avoid bumping in IE\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var revealLinkSize = SIZES.MEDIUM;
var PasswordInputContainer = styled.div(_templateObject$6(), function (props) {
  return getHeight$1(props.size);
});
var PasswordInputStyled = styled(Input)(_templateObject2$5(), function (props) {
  return getHeight$1(props.size);
});
var PasswordPlaceholder = styled(Input)(_templateObject3$4(), function (props) {
  return props.revealed ? "initial" : "disc";
}, function (props) {
  return getHeight$1(props.size);
});
var RevealContainer = styled.div(_templateObject4$3());

var PasswordInput =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(PasswordInput, _Component);

  function PasswordInput(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.toggleInputVisibility = function () {
      if (!_this.props.disabled) {
        _this.setState({
          inputVisible: !_this.state.inputVisible
        });
      }
    };

    _this.toggleReveal = function (event) {
      if (!_this.props.disabled) {
        _this.setState({
          revealed: !_this.state.revealed
        });
      }
    };

    _this.onBlur = function (event) {
      _this.toggleInputVisibility();

      typeof _this.props.onBlur === "function" && _this.props.onBlur(event.target.value);
    };

    _this.state = {
      inputVisible: props.autoFocus,
      revealed: false
    };
    return _this;
  }

  var _proto = PasswordInput.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        value = _this$props.value,
        disabled = _this$props.disabled; // you can override revealed from outside (use-case: reveal password on generate password)

    var revealed = this.props.revealed || this.state.revealed;
    var showRevealToggle = !disabled && value && !this.props.revealed;
    return React.createElement(PasswordInputContainer, {
      size: this.props.size
    }, this.state.inputVisible ? React.createElement(PasswordInputStyled, _extends({}, this.props, {
      type: revealed ? "text" : "password",
      onBlur: this.onBlur,
      autoFocus: true
    })) : React.createElement(PasswordPlaceholder, {
      as: "div",
      id: this.props.id,
      tabIndex: this.props.disabled ? undefined : 0,
      onClick: this.toggleInputVisibility,
      onFocus: this.toggleInputVisibility,
      revealed: revealed,
      disabled: disabled,
      size: this.props.size,
      invalid: this.props.invalid
    }, revealed ? value : value.replace(/./g, "•")), showRevealToggle && React.createElement(RevealContainer, {
      size: this.props.size
    }, React.createElement(LinkButton, {
      onClick: this.toggleReveal,
      size: revealLinkSize
    }, revealed ? React.createElement(FormattedMessage, {
      id: "2600324508",
      defaultMessage: "Hide"
    }) : React.createElement(FormattedMessage, {
      id: "1242107845",
      defaultMessage: "Show"
    }))));
  };

  return PasswordInput;
}(Component);

PasswordInput.defaultProps = {
  autoFocus: false,
  disabled: false,
  invalid: false,
  autoComplete: "off",
  autoCorrect: "off",
  spellCheck: "false",
  maxLength: 255,
  revealed: false,
  size: SIZES.MEDIUM
};
PasswordInput.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  autoComplete: PropTypes.string,
  autoCorrect: PropTypes.string,
  spellCheck: PropTypes.string,
  maxLength: PropTypes.number,
  name: PropTypes.string,
  autoCapitalize: PropTypes.string,
  revealed: PropTypes.bool,
  size: PropTypes.oneOf([SIZES.MEDIUM, SIZES.LARGE, SIZES.BIG])
};
var Avatar_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8Y2lyY2xlIGlkPSJhdmF0YXItMjQtYSIgY3g9IjEyIiBjeT0iMTIiIHI9IjEyIi8+CiAgICA8cGF0aCBpZD0iYXZhdGFyLTI0LWMiIGQ9Ik01LjM5MjQxMzM5LDExIEM2LjQ0NTk1NjE5LDExLjYzNDgxOTggNy42ODAzMzE4OSwxMiA5LDEyIEMxMC4zMTk2NjgxLDEyIDExLjU1NDA0MzgsMTEuNjM0ODE5OCAxMi42MDc1ODY2LDExIEwxMywxMSBDMTUuNzYxNDIzNywxMSAxOCwxMy4yMzg1NzYzIDE4LDE2IEwxOCwxOCBMMCwxOCBMMCwxNiBDLTMuMzgxNzY4NzZlLTE2LDEzLjIzODU3NjMgMi4yMzg1NzYyNSwxMSA1LDExIEw1LjM5MjQxMzM5LDExIFogTTksMTAgQzYuMjM4NTc2MjUsMTAgNCw3Ljc2MTQyMzc1IDQsNSBDNCwyLjIzODU3NjI1IDYuMjM4NTc2MjUsMCA5LDAgQzExLjc2MTQyMzcsMCAxNCwyLjIzODU3NjI1IDE0LDUgQzE0LDcuNzYxNDIzNzUgMTEuNzYxNDIzNywxMCA5LDEwIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPG1hc2sgaWQ9ImF2YXRhci0yNC1iIiBmaWxsPSIjZmZmIj4KICAgICAgPHVzZSB4bGluazpocmVmPSIjYXZhdGFyLTI0LWEiLz4KICAgIDwvbWFzaz4KICAgIDx1c2UgZmlsbD0iI0YzRjNGNCIgeGxpbms6aHJlZj0iI2F2YXRhci0yNC1hIi8+CiAgICA8ZyBtYXNrPSJ1cmwoI2F2YXRhci0yNC1iKSI+CiAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgNikiPgogICAgICAgIDxtYXNrIGlkPSJhdmF0YXItMjQtZCIgZmlsbD0iI2ZmZiI+CiAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhdmF0YXItMjQtYyIvPgogICAgICAgIDwvbWFzaz4KICAgICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNhdmF0YXItMjQtYyIvPgogICAgICAgIDxnIG1hc2s9InVybCgjYXZhdGFyLTI0LWQpIj4KICAgICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgZmlsbD0iIzhCOEM4QyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM5IC00MikiLz4KICAgICAgICA8L2c+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var Alert = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGg0OHY0OEgweiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNGMjlCMDUiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTQzLjIgNDNINC43ODlhMi43OTMgMi43OTMgMCAwIDEtMi40MTUtMS40IDIuODE1IDIuODE1IDAgMCAxIDAtMi44TDIxLjU3OCA1LjRBMi43OTUgMi43OTUgMCAwIDEgMjMuOTk0IDRjLjk5MyAwIDEuOTE4LjUzNiAyLjQxNiAxLjRsMTkuMDY4IDMzLjE2MmMuMzU4LjUzMS41MjIgMS4wNzUuNTIyIDEuNjM4YTIuODAyIDIuODAyIDAgMCAxLTIuOCAyLjh6TTIyIDM0djRoNHYtNGgtNHptMC0xOXYxNmg0VjE1aC00eiIvPgogICAgPC9nPgo8L3N2Zz4K";
var Checkmark_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hlY2ttYXJrLTE2LWEiIHBvaW50cz0iNC45OTggMTAgMCA1IDEuNDk4IDMuNSA0Ljk5OCA3IDExLjk5OCAwIDEzLjQ5OCAxLjUiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAzKSI+CiAgICAgIDxtYXNrIGlkPSJjaGVja21hcmstMTYtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjY2hlY2ttYXJrLTE2LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNjaGVja21hcmstMTYtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2NoZWNrbWFyay0xNi1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDEgLTQ0KSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
var Checkmark_16_thick = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iYSIgZD0iTTQuOTk4IDEwTDAgNWwxLjQ5OC0xLjUgMy41IDMuNSA3LTcgMS41IDEuNXoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMTZ2MTZIMHoiLz4KICAgIDx1c2UgZmlsbD0iI0ZGRiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAzKSIgeGxpbms6aHJlZj0iI2EiLz4KICA8L2c+Cjwvc3ZnPgo=";
var Checkmark_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hlY2ttYXJrLTI0LWEiIHBvaW50cz0iNS45OTggMTMuNTcyIDAgNy41NzIgMS40OTggNi4wNzIgNS45OTggMTAuNTcyIDE1Ljk5OCAuNTcyIDE3LjQ5OCAyLjA3MiIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ii8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzIDUpIj4KICAgICAgPG1hc2sgaWQ9ImNoZWNrbWFyay0yNC1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNjaGVja21hcmstMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzVEQTMwRCIgeGxpbms6aHJlZj0iI2NoZWNrbWFyay0yNC1hIi8+CiAgICAgIDxnIGZpbGw9IiM1REEzMEQiIG1hc2s9InVybCgjY2hlY2ttYXJrLTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zOSAtMzkpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var CheckmarkCheckbox = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ii8+CiAgICA8cG9seWdvbiB4PSIxIiB5PSIzIiB3aWR0aD0iMTQiIGhlaWdodD0iMTAiIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0ibm9uemVybyIgcG9pbnRzPSI1Ljk5OCAxMyAxIDggMi40OTggNi41IDUuOTk4IDEwIDEyLjk5OCAzIDE0LjQ5OCA0LjUiLz4KICA8L2c+Cjwvc3ZnPgo=";
var ChevronDown_12 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl9kb3duLTEyLWEiIHBvaW50cz0iNC45NzggNC4xMSA4LjkyMyAwIDEwIDEuMDMzIDQuOTcxIDYuMjczIDAgMS4wMjcgMS4wODMgMCIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIi8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDMpIj4KICAgICAgPG1hc2sgaWQ9ImNoZXZyb25fZG93bi0xMi1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNjaGV2cm9uX2Rvd24tMTItYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2NoZXZyb25fZG93bi0xMi1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjY2hldnJvbl9kb3duLTEyLWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MSAtNDMpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var ChevronDown_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl9kb3duLTE2LWEiIHBvaW50cz0iNi45NjkgNS43NTQgMTIuNDkzIDAgMTQgMS40NDcgNi45NTkgOC43ODIgMCAxLjQzNyAxLjUxNyAwIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgNCkiPgogICAgICA8bWFzayBpZD0iY2hldnJvbl9kb3duLTE2LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2NoZXZyb25fZG93bi0xNi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjY2hldnJvbl9kb3duLTE2LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNjaGV2cm9uX2Rvd24tMTYtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQxIC00NCkiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
var ChevronLeft_12 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl9sZWZ0LTEyLWEiIHBvaW50cz0iMi44OTIgNS4wMjIgNy4wMDIgOC45MTcgNS45NzYgMTAgLjczIDUuMDI5IDUuOTY5IDAgNy4wMDMgMS4wNzciLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMiAxMSkiPgogICAgICA8bWFzayBpZD0iY2hldnJvbl9sZWZ0LTEyLWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2NoZXZyb25fbGVmdC0xMi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjY2hldnJvbl9sZWZ0LTEyLWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNjaGV2cm9uX2xlZnQtMTItYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQyIC00MikiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
var ChevronLeft_12_white = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl9sZWZ0LTEyLWEiIHBvaW50cz0iMi44OTIgNS4wMjIgNy4wMDIgOC45MTcgNS45NzYgMTAgLjczIDUuMDI5IDUuOTY5IDAgNy4wMDMgMS4wNzciLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMiAxMSkiPgogICAgICA8bWFzayBpZD0iY2hldnJvbl9sZWZ0LTEyLWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2NoZXZyb25fbGVmdC0xMi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjZmZmZmZmIiB4bGluazpocmVmPSIjY2hldnJvbl9sZWZ0LTEyLWEiLz4KICAgICAgPGcgZmlsbD0iI2ZmZmZmZiIgbWFzaz0idXJsKCNjaGV2cm9uX2xlZnQtMTItYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQyIC00MikiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
var ChevronLeft_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTUuNzU0IDYuOTY5TDAgMS41MTcgMS40MzcgMGw3LjM0NSA2Ljk2TDEuNDQ3IDE0IDAgMTIuNDkzeiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNMCAwaDE2djE2SDB6Ii8+CiAgICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAxMS43ODIgMSkiIHhsaW5rOmhyZWY9IiNhIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";
var ChevronLeft_16_white = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTUuNzU0IDYuOTY5TDAgMS41MTcgMS40MzcgMGw3LjM0NSA2Ljk2TDEuNDQ3IDE0IDAgMTIuNDkzeiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNMCAwaDE2djE2SDB6Ii8+CiAgICAgICAgPHVzZSBmaWxsPSIjRkZGRkZGIiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAxMS43ODIgMSkiIHhsaW5rOmhyZWY9IiNhIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";
var ChevronRight_12 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl9yaWdodC0xMi1hIiBwb2ludHM9IjQuMTEgNS4wMjIgMCAxLjA3NyAxLjAzMyAwIDYuMjczIDUuMDI5IDEuMDI3IDEwIDAgOC45MTciLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMyAxMSkiPgogICAgICA8bWFzayBpZD0iY2hldnJvbl9yaWdodC0xMi1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNjaGV2cm9uX3JpZ2h0LTEyLWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNjaGV2cm9uX3JpZ2h0LTEyLWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNjaGV2cm9uX3JpZ2h0LTEyLWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MyAtNDIpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var ChevronRight_12_white = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl9yaWdodC0xMi1hLXdoaXRlIiBwb2ludHM9IjQuMTEgNS4wMjIgMCAxLjA3NyAxLjAzMyAwIDYuMjczIDUuMDI5IDEuMDI3IDEwIDAgOC45MTciLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMyAxMSkiPgogICAgICA8bWFzayBpZD0iY2hldnJvbl9yaWdodC0xMi1iLXdoaXRlIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNjaGV2cm9uX3JpZ2h0LTEyLWEtd2hpdGUiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiNmZmYiIHhsaW5rOmhyZWY9IiNjaGV2cm9uX3JpZ2h0LTEyLWEtd2hpdGUiLz4KICAgICAgPGcgZmlsbD0iI2ZmZiIgbWFzaz0idXJsKCNjaGV2cm9uX3JpZ2h0LTEyLWItd2hpdGUpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MyAtNDIpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var ChevronRight_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl9yaWdodC0xNi1hIiBwb2ludHM9IjUuNzU0IDYuOTY5IDAgMS41MTcgMS40MzcgMCA4Ljc4MiA2Ljk1OSAxLjQ0NyAxNCAwIDEyLjQ5MyIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ii8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0IDEpIj4KICAgICAgPG1hc2sgaWQ9ImNoZXZyb25fcmlnaHQtMTYtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjY2hldnJvbl9yaWdodC0xNi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjY2hldnJvbl9yaWdodC0xNi1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjY2hldnJvbl9yaWdodC0xNi1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDMgLTQyKSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
var ChevronUp_12 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl91cC0xMi1hIiBwb2ludHM9IjQuOTc4IDQuMTEgOC45MjMgMCAxMCAxLjAzMyA0Ljk3MSA2LjI3MyAwIDEuMDI3IDEuMDgzIDAiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMSA5KSI+CiAgICAgIDxtYXNrIGlkPSJjaGV2cm9uX3VwLTEyLWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2NoZXZyb25fdXAtMTItYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2NoZXZyb25fdXAtMTItYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2NoZXZyb25fdXAtMTItYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQxIC00NCkiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
var ChevronUp_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl91cC0xNi1hIiBwb2ludHM9IjYuOTY5IDMuMDI3IDEuNTE3IDguNzgxIDAgNy4zNDQgNi45NTkgMCAxNCA3LjMzNSAxMi40OTMgOC43ODIiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAzKSI+CiAgICAgIDxtYXNrIGlkPSJjaGV2cm9uX3VwLTE2LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2NoZXZyb25fdXAtMTYtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2NoZXZyb25fdXAtMTYtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2NoZXZyb25fdXAtMTYtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQxIC00MykiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
var CircleDisabled_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8Y2lyY2xlIGN4PSI4IiBjeT0iMTIiIHI9IjgiIGZpbGw9IiNERUUwRTAiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtNCkiLz4KPC9zdmc+Cg==";
var Clock_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iY2xvY2stMjQtYSIgZD0iTTExLDkuODQ3MzUwNzMgTDE0LjMzMDEyNywxMS43NzAwMDA1IEwxMy4zMzAxMjcsMTMuNTAyMDUxMyBMOSwxMS4wMDIwNTEzIEw5LjAwMTE4NDMsMTEgTDksMTEgTDksNCBMMTEsNCBMMTEsOS44NDczNTA3MyBaIE0xMCwyMCBDNC40NzcxNTI1LDIwIC0zLjU4ODI0MDgyZS0xMywxNS41MjI4NDc1IC0zLjU4ODI0MDgyZS0xMywxMCBDLTMuNTg4MjQwODJlLTEzLDQuNDc3MTUyNSA0LjQ3NzE1MjUsMCAxMCwwIEMxNS41MjI4NDc1LDAgMjAsNC40NzcxNTI1IDIwLDEwIEMyMCwxNS41MjI4NDc1IDE1LjUyMjg0NzUsMjAgMTAsMjAgWiBNMTAsMTggQzE0LjQxODI3OCwxOCAxOCwxNC40MTgyNzggMTgsMTAgQzE4LDUuNTgxNzIyIDE0LjQxODI3OCwyIDEwLDIgQzUuNTgxNzIyLDIgMiw1LjU4MTcyMiAyLDEwIEMyLDE0LjQxODI3OCA1LjU4MTcyMiwxOCAxMCwxOCBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgICA8bWFzayBpZD0iY2xvY2stMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjY2xvY2stMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2Nsb2NrLTI0LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNjbG9jay0yNC1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzggLTM5KSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
var Close_12 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iY2xvc2UtMTItYSIgZD0iTTUsNS43ODMwMjkwMyBMMC43ODMwMjkwMjksMTAgTDAsOS4yMTY5NzA5NyBMNC4yMTY5NzA5Nyw1IEwwLDAuNzgzMDI5MDI5IEwwLjc4MzAyOTAyOSwwIEw1LDQuMjE2OTcwOTcgTDkuMjE2OTcwOTcsMCBMMTAsMC43ODMwMjkwMjkgTDUuNzgzMDI5MDMsNSBMMTAsOS4yMTY5NzA5NyBMOS4yMTY5NzA5NywxMCBMNSw1Ljc4MzAyOTAzIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAxKSI+CiAgICAgIDxtYXNrIGlkPSJjbG9zZS0xMi1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNjbG9zZS0xMi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjY2xvc2UtMTItYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2Nsb3NlLTEyLWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MSAtNDEpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var Close_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iY2xvc2UtMTYtYSIgZD0iTTYsNi43ODMwMjkwMyBMMC43ODMwMjkwMjksMTIgTDEuMTM2ODY4MzhlLTEzLDExLjIxNjk3MSBMNS4yMTY5NzA5Nyw2IEwxLjEzNjg2ODM4ZS0xMywwLjc4MzAyOTAyOSBMMC43ODMwMjkwMjksMCBMNiw1LjIxNjk3MDk3IEwxMS4yMTY5NzEsMCBMMTIsMC43ODMwMjkwMjkgTDYuNzgzMDI5MDMsNiBMMTIsMTEuMjE2OTcxIEwxMS4yMTY5NzEsMTIgTDYsNi43ODMwMjkwMyBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgICA8bWFzayBpZD0iY2xvc2UtMTYtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjY2xvc2UtMTYtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2Nsb3NlLTE2LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNjbG9zZS0xNi1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDIgLTQyKSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
var Close_16_thick = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZD0iTTAgMGgxNnYxNkgweiIvPgogICAgPHBhdGggZmlsbD0iI0ZGRiIgZD0iTTEyLjQ5OCAybDEuNSAxLjVMOS40OTcgOGw0LjUgNC41TDEyLjUgMTQgNy45OTkgOS40OTkgMy40OTggMTQgMiAxMi41bDQuNDk5LTQuNTAxTDIgMy41IDMuNSAybDQuNDk4IDQuNSA0LjUtNC41eiIvPgogIDwvZz4KPC9zdmc+Cg==";
var Close_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iY2xvc2UtMjQtYSIgZD0iTTgsOC43ODMwMjkwMyBMMC43ODMwMjkwMjksMTYgTDAsMTUuMjE2OTcxIEw3LjIxNjk3MDk3LDggTDAsMC43ODMwMjkwMjkgTDAuNzgzMDI5MDI5LDAgTDgsNy4yMTY5NzA5NyBMMTUuMjE2OTcxLDAgTDE2LDAuNzgzMDI5MDI5IEw4Ljc4MzAyOTAzLDggTDE2LDE1LjIxNjk3MSBMMTUuMjE2OTcxLDE2IEw4LDguNzgzMDI5MDMgWiIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ii8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0IDQpIj4KICAgICAgPG1hc2sgaWQ9ImNsb3NlLTI0LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2Nsb3NlLTI0LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNjbG9zZS0yNC1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjY2xvc2UtMjQtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQwIC00MCkiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
var Download_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iZG93bmxvYWQtMTYtYSIgZD0iTTQuOTk5ODYwMjEsNyBMNC45OTk4NjAyMSwwIEw2Ljk5OTg2MDIxLDAgTDYuOTk5ODYwMjEsNi45OTczMTMwNSBMOS45OTk4NjAyMSw0IEwxMS40OTgwOTAyLDUuNSBMNS45OTk4NjAyMSwxMC45OTE3Nzk3IEw1Ljk5OTg2MDIxLDEwLjk5NTM2MTMgTDUuOTk4MDY3NiwxMC45OTM1NzAyIEw1Ljk5NjI3NDM5LDEwLjk5NTM2MTMgTDUuOTk2Mjc0MzksMTAuOTkxNzc4NSBMMC40OTk4NjAyMDgsNS41IEwxLjk5OTg2MDIxLDQgTDQuOTk5ODYwMjEsNyBaIE0xMiwxMiBMMTIsMTQgTDAsMTQgTDAsMTIgTDEyLDEyIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAxKSI+CiAgICAgIDxtYXNrIGlkPSJkb3dubG9hZC0xNi1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNkb3dubG9hZC0xNi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHhsaW5rOmhyZWY9IiNkb3dubG9hZC0xNi1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjZG93bmxvYWQtMTYtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQyIC00MSkiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
var Ellipsis_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iZWxsaXBzaXMtMTYtYSIgZD0iTTUsMiBDNC40NDc3MTUyNSwyIDQsMS41NTIyODQ3NSA0LDEgQzQsMC40NDc3MTUyNSA0LjQ0NzcxNTI1LDAgNSwwIEM1LjU1MjI4NDc1LDAgNiwwLjQ0NzcxNTI1IDYsMSBDNiwxLjU1MjI4NDc1IDUuNTUyMjg0NzUsMiA1LDIgWiBNMSwyIEMwLjQ0NzcxNTI1LDIgMCwxLjU1MjI4NDc1IDAsMSBDMCwwLjQ0NzcxNTI1IDAuNDQ3NzE1MjUsMCAxLDAgQzEuNTUyMjg0NzUsMCAyLDAuNDQ3NzE1MjUgMiwxIEMyLDEuNTUyMjg0NzUgMS41NTIyODQ3NSwyIDEsMiBaIE05LDIgQzguNDQ3NzE1MjUsMiA4LDEuNTUyMjg0NzUgOCwxIEM4LDAuNDQ3NzE1MjUgOC40NDc3MTUyNSwwIDksMCBDOS41NTIyODQ3NSwwIDEwLDAuNDQ3NzE1MjUgMTAsMSBDMTAsMS41NTIyODQ3NSA5LjU1MjI4NDc1LDIgOSwyIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyA3KSI+CiAgICAgIDxtYXNrIGlkPSJlbGxpcHNpcy0xNi1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNlbGxpcHNpcy0xNi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjZWxsaXBzaXMtMTYtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2VsbGlwc2lzLTE2LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MyAtNDYpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var Ellipsis_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iZWxsaXBzaXMtMjQtYSIgZD0iTTgsMy41IEM3LjE3MTU3Mjg4LDMuNSA2LjUsMi44Mjg0MjcxMiA2LjUsMiBDNi41LDEuMTcxNTcyODggNy4xNzE1NzI4OCwwLjUgOCwwLjUgQzguODI4NDI3MTIsMC41IDkuNSwxLjE3MTU3Mjg4IDkuNSwyIEM5LjUsMi44Mjg0MjcxMiA4LjgyODQyNzEyLDMuNSA4LDMuNSBaIE0xNC41LDMuNSBDMTMuNjcxNTcyOSwzLjUgMTMsMi44Mjg0MjcxMiAxMywyIEMxMywxLjE3MTU3Mjg4IDEzLjY3MTU3MjksMC41IDE0LjUsMC41IEMxNS4zMjg0MjcxLDAuNSAxNiwxLjE3MTU3Mjg4IDE2LDIgQzE2LDIuODI4NDI3MTIgMTUuMzI4NDI3MSwzLjUgMTQuNSwzLjUgWiBNMS41LDMuNSBDMC42NzE1NzI4NzUsMy41IDAsMi44Mjg0MjcxMiAwLDIgQzAsMS4xNzE1NzI4OCAwLjY3MTU3Mjg3NSwwLjUgMS41LDAuNSBDMi4zMjg0MjcxMiwwLjUgMywxLjE3MTU3Mjg4IDMsMiBDMywyLjgyODQyNzEyIDIuMzI4NDI3MTIsMy41IDEuNSwzLjUgWiIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ii8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0IDEwKSI+CiAgICAgIDxtYXNrIGlkPSJlbGxpcHNpcy0yNC1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNlbGxpcHNpcy0yNC1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjQTJBM0E3IiBmaWxsLXJ1bGU9Im5vbnplcm8iIHhsaW5rOmhyZWY9IiNlbGxpcHNpcy0yNC1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjZWxsaXBzaXMtMjQtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQwIC00NikiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
var Error_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iZXJyb3ItMjQtYSIgZD0iTTEwLDIwIEM0LjQ3NzE1MjUsMjAgMCwxNS41MjI4NDc1IDAsMTAgQzAsNC40NzcxNTI1IDQuNDc3MTUyNSwwIDEwLDAgQzE1LjUyMjg0NzUsMCAyMCw0LjQ3NzE1MjUgMjAsMTAgQzIwLDE1LjUyMjg0NzUgMTUuNTIyODQ3NSwyMCAxMCwyMCBaIE05LDEzIEw5LDE1IEwxMSwxNSBMMTEsMTMgTDksMTMgWiBNOSw1IEw5LDExIEwxMSwxMSBMMTEsNSBMOSw1IFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAyKSI+CiAgICAgIDxtYXNrIGlkPSJlcnJvci0yNC1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNlcnJvci0yNC1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjZXJyb3ItMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjRDYyOTFBIiBtYXNrPSJ1cmwoI2Vycm9yLTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zOCAtMzgpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var ErrorWhite_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTEwIDIwQzQuNDc3IDIwIDAgMTUuNTIzIDAgMTBTNC40NzcgMCAxMCAwczEwIDQuNDc3IDEwIDEwLTQuNDc3IDEwLTEwIDEwem0tMS03djJoMnYtMkg5em0wLTh2NmgyVjVIOXoiLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgICAgICAgICA8bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgICAgIDwvbWFzaz4KICAgICAgICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjYSIvPgogICAgICAgICAgICA8ZyBmaWxsPSIjZmZmIiBtYXNrPSJ1cmwoI2IpIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0tMzgtMzhoOTZ2OTZoLTk2eiIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
var Gear_24 = "data:image/svg+xml;base64,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";
var Grip_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iZ3JpcC0xNi1hIiBkPSJNNCw0IEw2LDQgTDYsNiBMNCw2IEw0LDQgWiBNNCwwIEw2LDAgTDYsMiBMNCwyIEw0LDAgWiBNNCw4IEw2LDggTDYsMTAgTDQsMTAgTDQsOCBaIE0wLDAgTDIsMCBMMiwyIEwwLDIgTDAsMCBaIE0wLDQgTDIsNCBMMiw2IEwwLDYgTDAsNCBaIE0wLDggTDIsOCBMMiwxMCBMMCwxMCBMMCw4IFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNSAzKSI+CiAgICAgIDxtYXNrIGlkPSJncmlwLTE2LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2dyaXAtMTYtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2dyaXAtMTYtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2dyaXAtMTYtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQyIC00OSkiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
var InProgress_24 = "data:image/svg+xml;base64,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";
var InfoOutline_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iaW5mb19vdXRsaW5lLTE2LWEiIGQ9Ik04LDE2IEMzLjU4MTcyMiwxNiAwLDEyLjQxODI3OCAwLDggQzAsMy41ODE3MjIgMy41ODE3MjIsMCA4LDAgQzEyLjQxODI3OCwwIDE2LDMuNTgxNzIyIDE2LDggQzE2LDEyLjQxODI3OCAxMi40MTgyNzgsMTYgOCwxNiBaIE04LDE1IEMxMS44NjU5OTMyLDE1IDE1LDExLjg2NTk5MzIgMTUsOCBDMTUsNC4xMzQwMDY3NSAxMS44NjU5OTMyLDEgOCwxIEM0LjEzNDAwNjc1LDEgMSw0LjEzNDAwNjc1IDEsOCBDMSwxMS44NjU5OTMyIDQuMTM0MDA2NzUsMTUgOCwxNSBaIE03LDQgTDksNCBMOSw2IEw3LDYgTDcsNCBaIE03LDcgTDksNyBMOSwxMiBMNywxMiBMNyw3IFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPgogICAgPG1hc2sgaWQ9ImluZm9fb3V0bGluZS0xNi1iIiBmaWxsPSIjZmZmIj4KICAgICAgPHVzZSB4bGluazpocmVmPSIjaW5mb19vdXRsaW5lLTE2LWEiLz4KICAgIDwvbWFzaz4KICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2luZm9fb3V0bGluZS0xNi1hIi8+CiAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2luZm9fb3V0bGluZS0xNi1iKSI+CiAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQwIC00MCkiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var InfoOutline_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iaW5mb19vdXRsaW5lLTI0LWEiIGQ9Ik0xMCwyMCBDNC40NzcxNTI1LDIwIDAsMTUuNTIyODQ3NSAwLDEwIEMwLDQuNDc3MTUyNSA0LjQ3NzE1MjUsMCAxMCwwIEMxNS41MjI4NDc1LDAgMjAsNC40NzcxNTI1IDIwLDEwIEMyMCwxNS41MjI4NDc1IDE1LjUyMjg0NzUsMjAgMTAsMjAgWiBNMTAsMTggQzE0LjQxODI3OCwxOCAxOCwxNC40MTgyNzggMTgsMTAgQzE4LDUuNTgxNzIyIDE0LjQxODI3OCwyIDEwLDIgQzUuNTgxNzIyLDIgMiw1LjU4MTcyMiAyLDEwIEMyLDE0LjQxODI3OCA1LjU4MTcyMiwxOCAxMCwxOCBaIE05LDkgTDExLDkgTDExLDE1IEw5LDE1IEw5LDkgWiBNOSw1IEwxMSw1IEwxMSw3IEw5LDcgTDksNSBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgICA8bWFzayBpZD0iaW5mb19vdXRsaW5lLTI0LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2luZm9fb3V0bGluZS0yNC1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHhsaW5rOmhyZWY9IiNpbmZvX291dGxpbmUtMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2luZm9fb3V0bGluZS0yNC1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzggLTM4KSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
var Info_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iaW5mby0xNi1hIiBkPSJNOCwxNiBDMy41ODE3MjIsMTYgMCwxMi40MTgyNzggMCw4IEMwLDMuNTgxNzIyIDMuNTgxNzIyLDAgOCwwIEMxMi40MTgyNzgsMCAxNiwzLjU4MTcyMiAxNiw4IEMxNiwxMi40MTgyNzggMTIuNDE4Mjc4LDE2IDgsMTYgWiBNNyw0IEw3LDYgTDksNiBMOSw0IEw3LDQgWiBNNyw3IEw3LDEyIEw5LDEyIEw5LDcgTDcsNyBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiLz4KICAgIDxtYXNrIGlkPSJpbmZvLTE2LWIiIGZpbGw9IiNmZmYiPgogICAgICA8dXNlIHhsaW5rOmhyZWY9IiNpbmZvLTE2LWEiLz4KICAgIDwvbWFzaz4KICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2luZm8tMTYtYSIvPgogICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNpbmZvLTE2LWIpIj4KICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDAgLTQwKSIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
var Info_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iaW5mby0yNC1hIiBkPSJNMTAsMjAgQzQuNDc3MTUyNSwyMCAwLDE1LjUyMjg0NzUgMCwxMCBDMCw0LjQ3NzE1MjUgNC40NzcxNTI1LDAgMTAsMCBDMTUuNTIyODQ3NSwwIDIwLDQuNDc3MTUyNSAyMCwxMCBDMjAsMTUuNTIyODQ3NSAxNS41MjI4NDc1LDIwIDEwLDIwIFogTTksNSBMOSw3IEwxMSw3IEwxMSw1IEw5LDUgWiBNOSw5IEw5LDE1IEwxMSwxNSBMMTEsOSBMOSw5IFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAyKSI+CiAgICAgIDxtYXNrIGlkPSJpbmZvLTI0LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2luZm8tMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2luZm8tMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2luZm8tMjQtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM4IC0zOCkiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
var Library_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0ibGlicmFyeS0yNC1hIiBkPSJNMTcsMTggTDIsMTggTDIsMTcgTDE3LDE3IEwxNywyIEwxOCwyIEwxOCwxOCBMMTcsMTggWiBNMSwwIEwxNSwwIEMxNS41NTIyODQ3LC0xLjAxNDUzMDYzZS0xNiAxNiwwLjQ0NzcxNTI1IDE2LDEgTDE2LDE1IEMxNiwxNS41NTIyODQ3IDE1LjU1MjI4NDcsMTYgMTUsMTYgTDEsMTYgQzAuNDQ3NzE1MjUsMTYgNi43NjM1Mzc1MWUtMTcsMTUuNTUyMjg0NyAwLDE1IEwwLDEgQy02Ljc2MzUzNzUxZS0xNywwLjQ0NzcxNTI1IDAuNDQ3NzE1MjUsMS4wMTQ1MzA2M2UtMTYgMSwwIFogTTMsMTAgTDMsMTEgTDksMTEgTDksMTAgTDMsMTAgWiBNMyw3IEwzLDggTDEzLDggTDEzLDcgTDMsNyBaIE0zLDQgTDMsNSBMMTMsNSBMMTMsNCBMMyw0IFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgIDxtYXNrIGlkPSJsaWJyYXJ5LTI0LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2xpYnJhcnktMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2xpYnJhcnktMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2xpYnJhcnktMjQtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM5IC00MCkiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
var Lock_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0ibG9jay0xNi1hIiBkPSJNMTAsNiBMMTEsNiBDMTEuNTUyMjg0Nyw2IDEyLDYuNDQ3NzE1MjUgMTIsNyBMMTIsMTMgQzEyLDEzLjU1MjI4NDcgMTEuNTUyMjg0NywxNCAxMSwxNCBMMSwxNCBDMC40NDc3MTUyNSwxNCA2Ljc2MzUzNzUxZS0xNywxMy41NTIyODQ3IDAsMTMgTDAsNyBDLTYuNzYzNTM3NTFlLTE3LDYuNDQ3NzE1MjUgMC40NDc3MTUyNSw2IDEsNiBMMiw2IEwyLDMuNTcxNDI4NTcgQzIsMS42IDMuNzkyLDAgNiwwIEM4LjIwOCwwIDEwLDEuNiAxMCwzLjU3MTQyODU3IEwxMCw2IFogTTguMzI1LDYgTDMuNjc0OTk5NzEsNiBMMy42NzQ5OTk3MSwzLjk1NDE1NTgyIEMzLjY3NDk5OTcxLDIuNjUyMDU3NDMgNC43MTc1LDEuNTkzNjI2NTcgNiwxLjU5MzYyNjU3IEM3LjI4MjUsMS41OTM2MjY1NyA4LjMyNSwyLjY1MjA1NzQzIDguMzI1LDMuOTU0MTU1ODIgTDguMzI1LDYgWiIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ii8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyIDEpIj4KICAgICAgPG1hc2sgaWQ9ImxvY2stMTYtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjbG9jay0xNi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjbG9jay0xNi1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjbG9jay0xNi1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDQgLTQ0KSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
var Lock_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0ibG9jay0yNC1hIiBkPSJNMTMsNyBMMTUsNyBDMTUuNTUyMjg0Nyw3IDE2LDcuNDQ3NzE1MjUgMTYsOCBMMTYsMTcgQzE2LDE3LjU1MjI4NDcgMTUuNTUyMjg0NywxOCAxNSwxOCBMMSwxOCBDMC40NDc3MTUyNSwxOCA2Ljc2MzUzNzUxZS0xNywxNy41NTIyODQ3IDAsMTcgTDAsOCBDLTYuNzYzNTM3NTFlLTE3LDcuNDQ3NzE1MjUgMC40NDc3MTUyNSw3IDEsNyBMMyw3IEwzLDUgQzMsMi4yNCA1LjI0LDAgOCwwIEMxMC43NiwwIDEzLDIuMjQgMTMsNSBMMTMsNyBaIE0xMS4xLDcgTDQuODk5OTk5NjIsNyBMNC44OTk5OTk2Miw1IEM0Ljg5OTk5OTYyLDMuMjkgNi4yOSwxLjkgOCwxLjkgQzkuNzEsMS45IDExLjEsMy4yOSAxMS4xLDUgTDExLjEsNyBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQgMykiPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNsb2NrLTI0LWEiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var MagnifyingGlass_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0ibWFnbmlmeWluZ19nbGFzcy0yNC1hIiBkPSJNMTIuODQ4MjQyOSwxMC44NDgyNDI5IEwxOCwxNiBMMTYsMTggTDEwLjg0ODI0MjksMTIuODQ4MjQyOSBDOS43NDQwNjk1MywxMy41NzYyNzY4IDguNDIxNTE3NywxNCA3LDE0IEMzLjEzNDAwNjc1LDE0IDAsMTAuODY1OTkzMiAwLDcgQzAsMy4xMzQwMDY3NSAzLjEzNDAwNjc1LDAgNywwIEMxMC44NjU5OTMyLDAgMTQsMy4xMzQwMDY3NSAxNCw3IEMxNCw4LjQyMTUxNzcgMTMuNTc2Mjc2OCw5Ljc0NDA2OTUzIDEyLjg0ODI0MjksMTAuODQ4MjQyOSBaIE03LDEyIEM5Ljc2MTQyMzc1LDEyIDEyLDkuNzYxNDIzNzUgMTIsNyBDMTIsNC4yMzg1NzYyNSA5Ljc2MTQyMzc1LDIgNywyIEM0LjIzODU3NjI1LDIgMiw0LjIzODU3NjI1IDIsNyBDMiw5Ljc2MTQyMzc1IDQuMjM4NTc2MjUsMTIgNywxMiBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMykiPgogICAgICA8bWFzayBpZD0ibWFnbmlmeWluZ19nbGFzcy0yNC1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNtYWduaWZ5aW5nX2dsYXNzLTI0LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNtYWduaWZ5aW5nX2dsYXNzLTI0LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNtYWduaWZ5aW5nX2dsYXNzLTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MCAtNDApIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var Mail_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0ibWFpbC0yNC1hIiBkPSJNMjAsNC41IEwyMCwxMyBDMjAsMTMuNTUyMjg0NyAxOS41NTIyODQ3LDE0IDE5LDE0IEwxLDE0IEMwLjQ0NzcxNTI1LDE0IDYuNzYzNTM3NTFlLTE3LDEzLjU1MjI4NDcgMCwxMyBMMCw0LjUgTDEwLDkuNSBMMjAsNC41IFogTTIwLDIuOTk3MzYwMjMgTDEwLDggTDAsMi45OTczNjAyMyBMMCwxIEMtNi43NjM1Mzc1MWUtMTcsMC40NDc3MTUyNSAwLjQ0NzcxNTI1LDEuMDE0NTMwNjNlLTE2IDEsMCBMMTksMCBDMTkuNTUyMjg0NywtMS4wMTQ1MzA2M2UtMTYgMjAsMC40NDc3MTUyNSAyMCwxIEwyMCwyLjk5NzM2MDIzIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiA1KSI+CiAgICAgIDxtYXNrIGlkPSJtYWlsLTI0LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI21haWwtMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI21haWwtMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI21haWwtMjQtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM4IC00MCkiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
var Menu_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0ibWVudS0yNC1hIiBkPSJNMCw1IEwxOCw1IEwxOCw3IEwwLDcgTDAsNSBaIE0wLDAgTDE4LDAgTDE4LDIgTDAsMiBMMCwwIFogTTAsMTAgTDE4LDEwIEwxOCwxMiBMMCwxMiBMMCwxMCBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgNikiPgogICAgICA8bWFzayBpZD0ibWVudS0yNC1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNtZW51LTI0LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNtZW51LTI0LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNtZW51LTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iMTA4IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDUgLTQyKSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
var Minus_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cmVjdCBpZD0ibWludXMtMTYtYSIgd2lkdGg9IjEyIiBoZWlnaHQ9IjIiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiA3KSI+CiAgICAgIDxtYXNrIGlkPSJtaW51cy0xNi1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNtaW51cy0xNi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjbWludXMtMTYtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI21pbnVzLTE2LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MiAtNDcpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var Minus_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cmVjdCBpZD0ibWludXMtMjQtYSIgd2lkdGg9IjE2IiBoZWlnaHQ9IjIiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNCAxMSkiPgogICAgICA8bWFzayBpZD0ibWludXMtMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjbWludXMtMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI21pbnVzLTI0LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNtaW51cy0yNC1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDAgLTQ3KSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
var Papers_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0icGFwZXJzLTI0LWEiIGQ9Ik0xMiw3IEw4LDcgTDgsMyBMMiwzIEMxLjQ0NzcxNTI1LDMgMSwzLjQ0NzcxNTI1IDEsNCBMMSwxNiBDMSwxNi41NTIyODQ3IDEuNDQ3NzE1MjUsMTcgMiwxNyBMMTEsMTcgQzExLjU1MjI4NDcsMTcgMTIsMTYuNTUyMjg0NyAxMiwxNiBMMTIsNyBaIE0yLDIgQzIsMC44OTU0MzA1IDIuODk1NDMwNSwyLjAyOTA2MTI1ZS0xNiA0LDAgTDExLDAgTDE1LDQgTDE1LDE0IEMxNSwxNS4xMDQ1Njk1IDE0LjEwNDU2OTUsMTYgMTMsMTYgQzEzLDE3LjEwNDU2OTUgMTIuMTA0NTY5NSwxOCAxMSwxOCBMMiwxOCBDMC44OTU0MzA1LDE4IDEuMzUyNzA3NWUtMTYsMTcuMTA0NTY5NSAwLDE2IEwwLDQgQy0xLjM1MjcwNzVlLTE2LDIuODk1NDMwNSAwLjg5NTQzMDUsMiAyLDIgWiBNMywyIEw5LDIgTDEzLDYgTDEzLDE1IEMxMy41NTIyODQ3LDE1IDE0LDE0LjU1MjI4NDcgMTQsMTQgTDE0LDQuNSBMMTAuNSwxIEw0LDEgQzMuNDQ3NzE1MjUsMSAzLDEuNDQ3NzE1MjUgMywyIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNSAzKSI+CiAgICAgIDxtYXNrIGlkPSJwYXBlcnMtMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcGFwZXJzLTI0LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiNBMkEzQTciIGZpbGwtcnVsZT0ibm9uemVybyIgeGxpbms6aHJlZj0iI3BhcGVycy0yNC1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjcGFwZXJzLTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00NiAtMzkpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var Pencil_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0icGVuY2lsLTI0LWEiIGQ9Ik0wLDE4IEwzLjM3Nzc3Nzc4LDE4IEwxNS4xNTU1NTU2LDYuMTMzMzMzMzMgTDExLjc3Nzc3NzgsMi43NTU1NTU1NiBMMCwxNC42MjIyMjIyIEwwLDE4IFogTTE3LjczMzMzMzMsMi4zMTExMTExMSBMMTUuNjg4ODg4OSwwLjI2NjY2NjY2NyBDMTUuMzMzMzMzMywtMC4wODg4ODg4ODg5IDE0LjgsLTAuMDg4ODg4ODg4OSAxNC40NDQ0NDQ0LDAuMjY2NjY2NjY3IEwxMi44NDQ0NDQ0LDEuODY2NjY2NjcgTDE2LjIyMjIyMjIsNS4yNDQ0NDQ0NCBMMTcuNzMzMzMzMywzLjU1NTU1NTU2IEMxOC4wODg4ODg5LDMuMiAxOC4wODg4ODg5LDIuNjY2NjY2NjcgMTcuNzMzMzMzMywyLjMxMTExMTExIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgIDxtYXNrIGlkPSJwZW5jaWwtMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcGVuY2lsLTI0LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiNBMkEzQTciIGZpbGwtcnVsZT0ibm9uemVybyIgeGxpbms6aHJlZj0iI3BlbmNpbC0yNC1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjcGVuY2lsLTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zOCAtNDApIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var Person_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0icGVyc29uLTI0LWEiIGQ9Ik01LjM5MjQxMzM5LDExIEM2LjQ0NTk1NjE5LDExLjYzNDgxOTggNy42ODAzMzE4OSwxMiA5LDEyIEMxMC4zMTk2NjgxLDEyIDExLjU1NDA0MzgsMTEuNjM0ODE5OCAxMi42MDc1ODY2LDExIEwxMywxMSBDMTUuNzYxNDIzNywxMSAxOCwxMy4yMzg1NzYzIDE4LDE2IEwxOCwxOCBMMCwxOCBMMCwxNiBDLTMuMzgxNzY4NzZlLTE2LDEzLjIzODU3NjMgMi4yMzg1NzYyNSwxMSA1LDExIEw1LjM5MjQxMzM5LDExIFogTTksMTAgQzYuMjM4NTc2MjUsMTAgNCw3Ljc2MTQyMzc1IDQsNSBDNCwyLjIzODU3NjI1IDYuMjM4NTc2MjUsMCA5LDAgQzExLjc2MTQyMzcsMCAxNCwyLjIzODU3NjI1IDE0LDUgQzE0LDcuNzYxNDIzNzUgMTEuNzYxNDIzNywxMCA5LDEwIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgIDxtYXNrIGlkPSJwZXJzb24tMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcGVyc29uLTI0LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNwZXJzb24tMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI3BlcnNvbi0yNC1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzkgLTM4KSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
var Plus_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0icGx1cy0xNi1hIiBkPSJNNyw1IEwxMiw1IEwxMiw3IEw3LDcgTDcsMTIgTDUsMTIgTDUsNyBMMCw3IEwwLDUgTDUsNSBMNSwwIEw3LDAgTDcsNSBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgICA8bWFzayBpZD0icGx1cy0xNi1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwbHVzLTE2LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNwbHVzLTE2LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNwbHVzLTE2LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MiAtNDIpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var Plus_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0icGx1cy0yNC1hIiBkPSJNOSw3IEwxNiw3IEwxNiw5IEw5LDkgTDksMTYgTDcsMTYgTDcsOSBMMCw5IEwwLDcgTDcsNyBMNywwIEw5LDAgTDksNyBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQgNCkiPgogICAgICA8bWFzayBpZD0icGx1cy0yNC1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwbHVzLTI0LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNwbHVzLTI0LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNwbHVzLTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MCAtNDApIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var QuestionMarkCircleOutline_16 = "data:image/svg+xml;base64,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";
var QuestionMarkCircle_16 = "data:image/svg+xml;base64,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";
var Refresh_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0icmVmcmVzaC0yNC1hIiBkPSJNOCwwLjAwMDgyMjE1OTU4MiBDMy41ODE3MjIsMC4wMDA4MjIxNTk1ODIgNS4wNzUzMDUyNmUtMTYsMy41ODI1NDQxNiAwLDguMDAwODIyMTYgQy01LjA3NTMwNTI2ZS0xNiwxMi40MTkxMDAyIDMuNTgxNzIyLDE2LjAwMDgyMjIgOCwxNi4wMDA4MjIyIEMxMC4xMzMzNTAyLDE2LjAzMTM4OTMgMTIuMTkwNTI2NywxNS4yMDg1MTg3IDEzLjcxNDI4NTcsMTMuNzE1MTA3OSBMMTIuMTQyODU3MSwxMi4wMDA4MjIyIEMxMS4wNTMxMDY2LDEzLjExMjc3MTcgOS41NTY4MjU0MSwxMy43MzE5MjI2IDgsMTMuNzE1MTA3OSBDNC44NDQwODcxNCwxMy43MTUxMDc5IDIuMjg1NzE0MjksMTEuMTU2NzM1IDIuMjg1NzE0MjksOC4wMDA4MjIxNiBDMi4yODU3MTQyOSw0Ljg0NDkwOTMgNC44NDQwODcxNCwyLjI4NjUzNjQ1IDgsMi4yODY1MzY0NSBDOS41NTY4MjU0MSwyLjI2OTcyMTc2IDExLjA1MzEwNjYsMi44ODg4NzI1OSAxMi4xNDI4NTcxLDQuMDAwODIyMTYgTDkuNzE0Mjg1NzEsNi4yODY1MzY0NSBMMTYsNi4yODY1MzY0NSBMMTYsMC4wMDA4MjIxNTk1ODIgTDEzLjcxNDI4NTcsMi4yODY1MzY0NSBDMTIuMTkwNTI2NywwLjc5MzEyNTYyOSAxMC4xMzMzNTAyLC0wLjAyOTc0NDk4OTkgOCwwLjAwMDgyMjE1OTU4MiIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ii8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0IDQpIj4KICAgICAgPG1hc2sgaWQ9InJlZnJlc2gtMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcmVmcmVzaC0yNC1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjcmVmcmVzaC0yNC1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjcmVmcmVzaC0yNC1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDAgLTQwKSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
var Revert_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMEgxNlYxNkgweiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik04IDFjMy44NjYgMCA3IDMuMTM0IDcgN3MtMy4xMzQgNy03IDdjLTEuOTMyIDAtMy42ODItLjc4My00Ljk0OS0yLjA1bDEuNDE0LTEuNDEzQzUuMzcgMTIuNDQgNi42MiAxMyA4IDEzYzIuNzYxIDAgNS0yLjIzOSA1LTVzLTIuMjM5LTUtNS01Yy0xLjM4IDAtMi42My41Ni0zLjUzNiAxLjQ2NEw3IDdIMVYxbDIuMDUgMi4wNUM0LjMxNyAxLjc4NCA2LjA2NyAxIDggMXoiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
var StatusCircle_12 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8Y2lyY2xlIGlkPSJzdGF0dXNfY2lyY2xlLTEyLWEiIGN4PSI0IiBjeT0iNCIgcj0iNCIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIi8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyIDIpIj4KICAgICAgPG1hc2sgaWQ9InN0YXR1c19jaXJjbGUtMTItYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjc3RhdHVzX2NpcmNsZS0xMi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjc3RhdHVzX2NpcmNsZS0xMi1hIi8+CiAgICAgIDxnIGZpbGw9IiM1REEzMEQiIG1hc2s9InVybCgjc3RhdHVzX2NpcmNsZS0xMi1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDQgLTQ0KSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
var Success_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0ic3VjY2Vzcy0xNi1hIiBkPSJNNDgsNTYgQzUyLjQxODI3OCw1NiA1Niw1Mi40MTgyNzggNTYsNDggQzU2LDQzLjU4MTcyMiA1Mi40MTgyNzgsNDAgNDgsNDAgQzQzLjU4MTcyMiw0MCA0MCw0My41ODE3MjIgNDAsNDggQzQwLDUyLjQxODI3OCA0My41ODE3MjIsNTYgNDgsNTYgWiBNNDYuMTI5MTg4NCw1MiBMNDMsNDguODg4ODg4OSBMNDQuMTcyMjUxMiw0Ny43MjIyMjIyIEw0Ni4xMjkxODg0LDQ5LjY2NjY2NjcgTDUwLjgyNTgzNzcsNDUgTDUyLDQ2LjE2NjY2NjcgTDQ2LjEyOTE4ODQsNTIgWiIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ii8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDAgLTQwKSI+CiAgICAgIDxtYXNrIGlkPSJzdWNjZXNzLTE2LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3N1Y2Nlc3MtMTYtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzVEQTMwRCIgeGxpbms6aHJlZj0iI3N1Y2Nlc3MtMTYtYSIvPgogICAgICA8ZyBmaWxsPSIjNURBMzBEIiBtYXNrPSJ1cmwoI3N1Y2Nlc3MtMTYtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
var Success_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0ic3VjY2Vzcy0yNC1hIiBkPSJNMTAsMjAgQzE1LjUyMjg0NzUsMjAgMjAsMTUuNTIyODQ3NSAyMCwxMCBDMjAsNC40NzcxNTI1IDE1LjUyMjg0NzUsMCAxMCwwIEM0LjQ3NzE1MjUsMCAwLDQuNDc3MTUyNSAwLDEwIEMwLDE1LjUyMjg0NzUgNC40NzcxNTI1LDIwIDEwLDIwIFogTTcuOTk3NTU4NTksMTUgTDQsMTEgTDUuNDk3NTU4NTksOS41IEw3Ljk5NzU1ODU5LDEyIEwxMy45OTc1NTg2LDYgTDE1LjQ5NzU1ODYsNy41IEw3Ljk5NzU1ODU5LDE1IFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAyKSI+CiAgICAgIDxtYXNrIGlkPSJzdWNjZXNzLTI0LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3N1Y2Nlc3MtMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI3N1Y2Nlc3MtMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjNURBMzBEIiBtYXNrPSJ1cmwoI3N1Y2Nlc3MtMjQtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM4IC0zOCkiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
var Timer_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0idGltZXItMjQtYSIgZD0iTTQuMDE3MzU5NzgsMTUuMzQzNzU3OSBMOSwxMiBMOSw2IEMxMi4zMTM3MDg1LDYgMTUsOC42ODYyOTE1IDE1LDEyIEMxNSwxNS4zMTM3MDg1IDEyLjMxMzcwODUsMTggOSwxOCBDNi45MjQyMjE0MSwxOCA1LjA5NDY0Mzc4LDE2Ljk0NTg4ODQgNC4wMTczNTk3OCwxNS4zNDM3NTc5IFogTTIuNDMyMjgyMTEsNS44NDY0OTU2NyBMMS4yOTI4OTMyMiw0LjcwNzEwNjc4IEwyLjcwNzEwNjc4LDMuMjkyODkzMjIgTDMuOTU4MDI4MzgsNC41NDM4MTQ4MSBDNS4zOTYzOTUwNCwzLjU2OTI3MDEzIDcuMTMxNzE3NDQsMyA5LDMgQzEzLjk3MDU2MjcsMyAxOCw3LjAyOTQzNzI1IDE4LDEyIEMxOCwxNi45NzA1NjI3IDEzLjk3MDU2MjcsMjEgOSwyMSBDNC4wMjk0MzcyNSwyMSAzLjU4ODI0MDgyZS0xMywxNi45NzA1NjI3IDMuNTg4MjQwODJlLTEzLDEyIEMzLjU4ODI0MDgyZS0xMyw5LjYyMDA3ODM1IDAuOTIzNzU4ODEzLDcuNDU1OTEyMTMgMi40MzIyODIxMSw1Ljg0NjQ5NTY3IFogTTksMTkgQzEyLjg2NTk5MzIsMTkgMTYsMTUuODY1OTkzMiAxNiwxMiBDMTYsOC4xMzQwMDY3NSAxMi44NjU5OTMyLDUgOSw1IEM1LjEzNDAwNjc1LDUgMiw4LjEzNDAwNjc1IDIsMTIgQzIsMTUuODY1OTkzMiA1LjEzNDAwNjc1LDE5IDksMTkgWiBNNiwwIEwxMiwwIEwxMiwyIEw2LDIgTDYsMCBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMSkiPgogICAgICA8bWFzayBpZD0idGltZXItMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjdGltZXItMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI3RpbWVyLTI0LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCN0aW1lci0yNC1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzkgLTM4KSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
var Trashcan_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0idHJhc2hjYW4tMjQtYSIgZD0iTTQsMSBDNCwwLjQ0NzcxNTI1IDQuNDQ3NzE1MjUsMS4wMTQ1MzA2M2UtMTYgNSwwIEw5LDAgQzkuNTUyMjg0NzUsLTEuMDE0NTMwNjNlLTE2IDEwLDAuNDQ3NzE1MjUgMTAsMSBMMTMsMSBDMTMuNTUyMjg0NywxIDE0LDEuNDQ3NzE1MjUgMTQsMiBMMTQsMyBMMCwzIEwwLDIgQy02Ljc2MzUzNzUxZS0xNywxLjQ0NzcxNTI1IDAuNDQ3NzE1MjUsMSAxLDEgTDQsMSBaIE0xLDQgTDEzLDQgTDEzLDE3IEMxMywxNy41NTIyODQ3IDEyLjU1MjI4NDcsMTggMTIsMTggTDIsMTggQzEuNDQ3NzE1MjUsMTggMSwxNy41NTIyODQ3IDEsMTcgTDEsNCBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUgMykiPgogICAgICA8bWFzayBpZD0idHJhc2hjYW4tMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjdHJhc2hjYW4tMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iI0EyQTNBNyIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjdHJhc2hjYW4tMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI3RyYXNoY2FuLTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MSAtMzkpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var TriangleDown_12 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0idHJpYW5nbGUtZG93bi0xMi1hIiBwb2ludHM9IjggMCA0IDUgMCAwIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMTIiIGhlaWdodD0iMTIiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgNCkiPgogICAgICA8bWFzayBpZD0idHJpYW5nbGUtZG93bi0xMi1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiN0cmlhbmdsZS1kb3duLTEyLWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiN0cmlhbmdsZS1kb3duLTEyLWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCN0cmlhbmdsZS1kb3duLTEyLWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iNzciIGhlaWdodD0iODAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNCAtMzgpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var VerticalEllipsis_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0idmVydGljYWxfZWxsaXBzaXMtMTYtYSIgZD0iTTEsNiBDMC40NDc3MTUyNSw2IDAsNS41NTIyODQ3NSAwLDUgQzAsNC40NDc3MTUyNSAwLjQ0NzcxNTI1LDQgMSw0IEMxLjU1MjI4NDc1LDQgMiw0LjQ0NzcxNTI1IDIsNSBDMiw1LjU1MjI4NDc1IDEuNTUyMjg0NzUsNiAxLDYgWiBNMSwyIEMwLjQ0NzcxNTI1LDIgMCwxLjU1MjI4NDc1IDAsMSBDMCwwLjQ0NzcxNTI1IDAuNDQ3NzE1MjUsMCAxLDAgQzEuNTUyMjg0NzUsMCAyLDAuNDQ3NzE1MjUgMiwxIEMyLDEuNTUyMjg0NzUgMS41NTIyODQ3NSwyIDEsMiBaIE0xLDEwIEMwLjQ0NzcxNTI1LDEwIDAsOS41NTIyODQ3NSAwLDkgQzAsOC40NDc3MTUyNSAwLjQ0NzcxNTI1LDggMSw4IEMxLjU1MjI4NDc1LDggMiw4LjQ0NzcxNTI1IDIsOSBDMiw5LjU1MjI4NDc1IDEuNTUyMjg0NzUsMTAgMSwxMCBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcgMykiPgogICAgICA8bWFzayBpZD0idmVydGljYWxfZWxsaXBzaXMtMTYtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjdmVydGljYWxfZWxsaXBzaXMtMTYtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI3ZlcnRpY2FsX2VsbGlwc2lzLTE2LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCN2ZXJ0aWNhbF9lbGxpcHNpcy0xNi1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDcgLTQzKSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
var VerticalEllipsis_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0idmVydGljYWxfZWxsaXBzaXMtMjQtYSIgZD0iTTIsOS41IEMxLjE3MTU3Mjg4LDkuNSAwLjUsOC44Mjg0MjcxMiAwLjUsOCBDMC41LDcuMTcxNTcyODggMS4xNzE1NzI4OCw2LjUgMiw2LjUgQzIuODI4NDI3MTIsNi41IDMuNSw3LjE3MTU3Mjg4IDMuNSw4IEMzLjUsOC44Mjg0MjcxMiAyLjgyODQyNzEyLDkuNSAyLDkuNSBaIE0yLDE2IEMxLjE3MTU3Mjg4LDE2IDAuNSwxNS4zMjg0MjcxIDAuNSwxNC41IEMwLjUsMTMuNjcxNTcyOSAxLjE3MTU3Mjg4LDEzIDIsMTMgQzIuODI4NDI3MTIsMTMgMy41LDEzLjY3MTU3MjkgMy41LDE0LjUgQzMuNSwxNS4zMjg0MjcxIDIuODI4NDI3MTIsMTYgMiwxNiBaIE0yLDMgQzEuMTcxNTcyODgsMyAwLjUsMi4zMjg0MjcxMiAwLjUsMS41IEMwLjUsMC42NzE1NzI4NzUgMS4xNzE1NzI4OCwwIDIsMCBDMi44Mjg0MjcxMiwwIDMuNSwwLjY3MTU3Mjg3NSAzLjUsMS41IEMzLjUsMi4zMjg0MjcxMiAyLjgyODQyNzEyLDMgMiwzIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAgNCkiPgogICAgICA8bWFzayBpZD0idmVydGljYWxfZWxsaXBzaXMtMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjdmVydGljYWxfZWxsaXBzaXMtMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iI0EyQTNBNyIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjdmVydGljYWxfZWxsaXBzaXMtMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI3ZlcnRpY2FsX2VsbGlwc2lzLTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00NiAtNDApIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
var Warning_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0id2FybmluZy0yNC1hIiBkPSJNMTguNzI3NTQyNywxNy45OTcyNzcgTDEuMjY3Mzg2MjYsMTcuOTk3Mjc3IEMwLjgxNTcwNTU5MywxNy45OTcyNzcgMC4zOTUxNzUzMTIsMTcuNzUzNjA1NiAwLjE2OTUxNjA4MiwxNy4zNjA4MjIgQy0wLjA1NjUwNTM2MDgsMTYuOTY4NzY1NyAtMC4wNTY1MDUzNjA4LDE2LjQ4MDY5NTYgMC4xNjk1MTYwODIsMTYuMDg3OTExOSBMOC44OTkyMzIxMSwwLjkwNjQ1OTI5NyBDOS4xMjUyNTM1NSwwLjUxMzY3NTYyNSA5LjU0NTc4MzgzLDAuMjcwMDA0MjcyIDkuOTk3NDY0NSwwLjI3MDAwNDI3MiBDMTAuNDQ4NzgzLDAuMjcwMDA0MjcyIDEwLjg2OTMxMzIsMC41MTM2NzU2MjUgMTEuMDk1MzM0NywwLjkwNjQ1OTI5NyBMMTkuNzYyNzQ5OSwxNS45Nzk4OTY0IEMxOS45MjUzODM5LDE2LjIyMTM4NTYgMjAsMTYuNDY4NjkzOSAyMCwxNi43MjQzNjcgQzE5Ljk5ODkxMzQsMTcuNDI4MTA0NCAxOS40MzQ5NDY0LDE3Ljk5MTQ1OCAxOC43Mjc1NDI3LDE3Ljk5NzI3NyBaIE05LDEzIEw5LDE1IEwxMSwxNSBMMTEsMTMgTDksMTMgWiBNOSw2IEw5LDEyIEwxMSwxMiBMMTEsNiBMOSw2IFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAzKSI+CiAgICAgIDxtYXNrIGlkPSJ3YXJuaW5nLTI0LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3dhcm5pbmctMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iI0YyOUIwNSIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjd2FybmluZy0yNC1hIi8+CiAgICAgIDxnIGZpbGw9IiNGMjlCMDUiIG1hc2s9InVybCgjd2FybmluZy0yNC1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzkgLTQwKSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"; // A

var svgList = {
  // A
  Avatar_24: Avatar_24,
  Alert: Alert,
  // C
  "Checkmark-16": Checkmark_16,
  "Checkmark-16-thick": Checkmark_16_thick,
  "Checkmark-24": Checkmark_24,
  "Checkmark-checkbox": CheckmarkCheckbox,
  "Chevron_down-12": ChevronDown_12,
  "Chevron_down-16": ChevronDown_16,
  "Chevron_left-12": ChevronLeft_12,
  "Chevron_left-12-white": ChevronLeft_12_white,
  "Chevron_left-16": ChevronLeft_16,
  "Chevron_left-16-white": ChevronLeft_16_white,
  "Chevron_right-12": ChevronRight_12,
  "Chevron_right-12-white": ChevronRight_12_white,
  "Chevron_right-16": ChevronRight_16,
  "Chevron_up-12": ChevronUp_12,
  "Chevron_up-16": ChevronUp_16,
  "Circle_disabled-16": CircleDisabled_16,
  "Clock-24": Clock_24,
  "Close-12": Close_12,
  "Close-16": Close_16,
  "Close-16-thick": Close_16_thick,
  "Close-24": Close_24,
  // D
  "Download-16": Download_16,
  // E
  "Ellipsis-16": Ellipsis_16,
  "Ellipsis-24": Ellipsis_24,
  "Error-24": Error_24,
  ErrorWhite_24: ErrorWhite_24,
  // G
  "Gear-24": Gear_24,
  "Grip-16": Grip_16,
  // I
  "In_progress-24": InProgress_24,
  "Info_outline-16": InfoOutline_16,
  "Info_outline-24": InfoOutline_24,
  "Info-16": Info_16,
  "Info-24": Info_24,
  // L
  "Library-24": Library_24,
  "Lock-16": Lock_16,
  "Lock-24": Lock_24,
  // M
  "Magnifying_glass-24": MagnifyingGlass_24,
  "Mail-24": Mail_24,
  "Menu-24": Menu_24,
  "Minus-16": Minus_16,
  "Minus-24": Minus_24,
  // P
  "Papers-24": Papers_24,
  "Pencil-24": Pencil_24,
  "Person-24": Person_24,
  "Plus-16": Plus_16,
  "Plus-24": Plus_24,
  // Q
  "Question_mark_circle_outline-16": QuestionMarkCircleOutline_16,
  "Question_mark_circle-16": QuestionMarkCircle_16,
  // R
  "Refresh-24": Refresh_24,
  "Revert-16": Revert_16,
  // S
  "Status_circle-12": StatusCircle_12,
  "Success-16": Success_16,
  "Success-24": Success_24,
  // T
  "Timer-24": Timer_24,
  "Trashcan-24": Trashcan_24,
  "Triangle-down-12": TriangleDown_12,
  // V
  "Vertical_ellipsis-16": VerticalEllipsis_16,
  "Vertical_ellipsis-24": VerticalEllipsis_24,
  // W
  "Warning-24": Warning_24
};

function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  width: ", ";\n  padding: ", ";\n  cursor: ", ";\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var Image$1 = styled.img(_templateObject$7(), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.onClick ? "pointer" : "auto";
});

var Icon = function Icon(_ref) {
  var icon = _ref.icon,
      name = _ref.name,
      rest = _objectWithoutPropertiesLoose(_ref, ["icon", "name"]);

  return React.createElement(Image$1, _extends({
    src: svgList[name || icon]
  }, rest));
};

Icon.displayName = "ImageWrapper";
Icon.defaultProps = {
  size: "24px",
  padding: "0"
};
Icon.propTypes = {
  name: PropTypes.string,
  icon: PropTypes.string,
  size: PropTypes.string,
  padding: PropTypes.string,
  onClick: PropTypes.func
};

function _templateObject3$5() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: Roboto;\n  font-size: 13px;\n  line-height: 24px;\n  color: ", ";\n  margin-left: 8px;\n  display: inline-block;\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteralLoose(["\n  list-style: none;\n  display: flex;\n  align-items: center;\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: 2px;\n  padding: 16px;\n  margin: 0;\n  background-color: ", ";\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var UnorderedList = styled.ul(_templateObject$8(), COLORS.GRAY_COLORS.GRAY_96);
var ListItem = styled.li(_templateObject2$6());
var Label$1 = styled.label(_templateObject3$5(), function (props) {
  return props.active ? COLORS.TEXT_COLORS.EMPHASIZED : COLORS.TEXT_COLORS.LABEL;
});

var ToDoItem = function ToDoItem(_ref) {
  var done = _ref.done,
      label = _ref.label;
  return React.createElement(ListItem, null, done ? React.createElement(Icon, {
    icon: "Success-16",
    size: "16"
  }) : React.createElement(Icon, {
    icon: "Circle_disabled-16",
    size: "16"
  }), done ? React.createElement(Label$1, {
    active: true
  }, label) : React.createElement(Label$1, null, label));
};

var ToDoList = function ToDoList(_ref2) {
  var list = _ref2.list;
  var itemList = list.map(function (item, i) {
    return React.createElement(ToDoItem, {
      label: item.text,
      done: item.complete,
      key: i
    });
  });
  return React.createElement(UnorderedList, null, itemList);
};

function _templateObject2$7() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-left: 12px;\n\n  &:first-child {\n    margin-left: 0px;\n  }\n\n  @media screen and (max-width: ", "px) {\n    margin-left: 0px;\n    margin-top: 24px;\n    display: flex;\n    flex-direction: column;\n\n    &:first-child {\n      margin-top: 0px;\n    }\n  }\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: ", ";\n\n  border-top: solid 1px ", ";\n  padding: 16px 24px;\n\n  @media screen and (max-width: ", "px) {\n    flex-direction: column;\n    padding: 32px 20px;\n  }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

var Footer = styled.div(_templateObject$9(), function (props) {
  return props.horizontalCenter ? "center" : "flex-end";
}, COLORS.SEPARATOR_COLORS.MEDIUM, function (props) {
  return props.breakpoint;
});
var StyledItem = styled.div(_templateObject2$7(), function (props) {
  return props.breakpoint;
});

var DialogFooter = function DialogFooter(_ref) {
  var children = _ref.children,
      breakpoint = _ref.breakpoint,
      horizontalCenter = _ref.horizontalCenter;
  return React.createElement(Footer, {
    horizontalCenter: horizontalCenter,
    breakpoint: breakpoint
  }, Children.map(children, function (child) {
    return child && React.createElement(StyledItem, {
      breakpoint: breakpoint
    }, child);
  }));
};

DialogFooter.propTypes = {
  breakpoint: PropTypes.number,
  horizontalCenter: PropTypes.bool
};

function _templateObject4$4() {
  var data = _taggedTemplateLiteralLoose(["\n      font-size: 14px;\n      line-height: 16px;\n      padding: 0 16px;\n      height: 38px;\n      min-width: 88px;\n    "]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$6() {
  var data = _taggedTemplateLiteralLoose(["\n      font-size: 16px;\n      line-height: 20px;\n      padding: 0 20px;\n      height: 48px;\n      min-width: 112px;\n    "]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteralLoose(["\n      color: ", ";\n      background-color: ", ";\n      border: ", ";\n\n      &:hover {\n        color: ", ";\n        background-color: ", ";\n        border: ", ";\n      }\n\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        border: ", ";\n      }\n\n      &:disabled,\n      &[disabled] {\n        opacity: 0.3;\n\n        &:hover {\n          color: ", ";\n          background-color: ", ";\n          border: ", ";\n        }\n      }\n    "]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  font-weight: 400;\n  font-family: ", ";\n  border-radius: 2px;\n  letter-spacing: 0.4px;\n  box-shadow: none;\n  text-shadow: none;\n  text-transform: capitalize;\n  border: none;\n  cursor: pointer;\n\n  ", ";\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}

var PRIMARY_LOOK = "primary";
var REGULAR_LOOK = "regular";
var LINK_LOOK = "link";
var OUTLINE_LOOK = "outline";
var StyledButton$1 = styled.button(_templateObject$a(), function (props) {
  return getSizingDefinitions$2(props.size);
}, FONTS.FONT_FAMILY.DEFAULT, function (props) {
  var colors = resolveColorSchema(props.look, props.theme.accentColor);
  return css(_templateObject2$8(), colors.normal.color, colors.normal.backgroundColor, colors.normal.border, colors.hover.color, colors.hover.backgroundColor, colors.hover.border, colors.active.color, colors.active.backgroundColor, colors.active.border, colors.normal.color, colors.normal.backgroundColor, colors.normal.border);
});

var getSizingDefinitions$2 = function getSizingDefinitions(size) {
  if (size === SIZES.LARGE) {
    return css(_templateObject3$6());
  } else {
    // medium (default)
    return css(_templateObject4$4());
  }
};

var readableColor$1 = function readableColor$$1(bgColor) {
  var rgb = parseToRgb(bgColor);
  var isLight = 0.5 <= (rgb.red * 212.6 + rgb.green * 715.2 + rgb.blue * 72.2) / 1000 / 255;
  return isLight ? "black" : "white";
};

var resolveColorSchema = function resolveColorSchema(look, accentColor) {
  if (accentColor === void 0) {
    accentColor = COLORS.ACTION_COLORS.BLUE_MAIN;
  }

  switch (look) {
    case PRIMARY_LOOK:
      {
        var hslParsed = parseToHsl(accentColor);
        var textColor = readableColor$1(accentColor);
        return {
          normal: {
            backgroundColor: accentColor,
            color: textColor
          },
          hover: {
            backgroundColor: hsl(hslParsed.hue, Math.max(0, hslParsed.saturation - 0.08), Math.min(1, hslParsed.lightness + 0.08)),
            color: textColor
          },
          active: {
            backgroundColor: hsl(hslParsed.hue, hslParsed.saturation, Math.max(0, hslParsed.lightness - 0.08)),
            color: textColor
          }
        };
      }

    case OUTLINE_LOOK:
      {
        return {
          normal: {
            backgroundColor: "transparent",
            color: COLORS.GRAY_COLORS.GRAY_25,
            border: "solid 1px " + COLORS.GRAY_COLORS.GRAY_35
          },
          hover: {
            backgroundColor: COLORS.GRAY_COLORS.GRAY_35,
            color: "#ffffff",
            border: "solid 1px " + COLORS.GRAY_COLORS.GRAY_35
          },
          active: {
            backgroundColor: COLORS.GRAY_COLORS.GRAY_18,
            color: "#ffffff",
            border: "solid 1px " + COLORS.GRAY_COLORS.GRAY_18
          }
        };
      }

    case REGULAR_LOOK:
      {
        return {
          normal: {
            backgroundColor: COLORS.GRAY_COLORS.GRAY_97,
            color: COLORS.GRAY_COLORS.GRAY_35,
            border: "solid 1px " + COLORS.GRAY_COLORS.GRAY_84
          },
          hover: {
            backgroundColor: COLORS.GRAY_COLORS.GRAY_99,
            color: COLORS.ONELOGIN_GRAY_COLORS.ONELOGIN_BLACK,
            border: "solid 1px " + COLORS.ACTION_COLORS.ONELOGIN_BLUE
          },
          active: {
            backgroundColor: COLORS.GRAY_COLORS.GRAY_96,
            color: COLORS.ONELOGIN_GRAY_COLORS.ONELOGIN_BLACK,
            border: "solid 1px " + COLORS.ACTION_COLORS.BLUE_MID
          }
        };
      }

    default:
      {
        // link
        return {
          normal: {
            backgroundColor: "transparent",
            color: COLORS.ACTION_COLORS.BLUE_MAIN
          },
          hover: {
            backgroundColor: "rgba(0,0,0,0.05)",
            color: COLORS.ACTION_COLORS.BLUE_MAIN_HOVER
          },
          active: {
            backgroundColor: "rgba(0,0,0,0.1)",
            color: COLORS.ACTION_COLORS.BLUE_MAIN_ACTIVE
          }
        };
      }
  }
};

var Button = function Button(props) {
  return React.createElement(StyledButton$1, props);
};

Button.defaultProps = {
  tabIndex: "0",
  disabled: false,
  type: "button",
  size: SIZES.MEDIUM,
  look: LINK_LOOK
};
Button.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.string,
  tabIndex: PropTypes.string,
  disabled: PropTypes.bool,
  look: PropTypes.oneOf([PRIMARY_LOOK, REGULAR_LOOK, LINK_LOOK, OUTLINE_LOOK]),
  size: PropTypes.oneOf([SIZES.MEDIUM, SIZES.LARGE])
};

var challengeMap = function challengeMap(length) {
  return {
    length: React.createElement(FormattedMessage, {
      id: "744377571",
      defaultMessage: "Minimum {length} characters",
      values: {
        length: length
      }
    }),
    upper: React.createElement(FormattedMessage, {
      id: "1963245695",
      defaultMessage: "1 Uppercase"
    }),
    lower: React.createElement(FormattedMessage, {
      id: "3877285238",
      defaultMessage: "1 lowercase"
    }),
    numbers: React.createElement(FormattedMessage, {
      id: "2792137744",
      defaultMessage: "1 number"
    }),
    specials: React.createElement(FormattedMessage, {
      id: "3286567409",
      defaultMessage: "1 special character"
    })
  };
};

var FIELDNAME = "New Password";

var NewPassword = function NewPassword(_ref) {
  var onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      rules = _ref.rules;
  return React.createElement(SingleValueForm, {
    onSubmit: onSubmit,
    render: function render(_ref2) {
      var value = _ref2.value,
          _onChange = _ref2.onChange;
      return React.createElement(PasswordComplexity, {
        rules: rules,
        value: value,
        render: function render(_ref3) {
          var invalid = _ref3.invalid,
              completedChallenges = _ref3.completedChallenges,
              challenges = _ref3.challenges;
          return React.createElement(Fragment, null, React.createElement(Content, {
            "data-testid": "reset-password-screen"
          }, React.createElement(ContentBlock, {
            "data-testid": "reset-password-content"
          }, React.createElement(Label, {
            forId: "password-input"
          }, React.createElement(FormattedMessage, {
            id: "1254879564",
            defaultMessage: FIELDNAME
          })), React.createElement(PasswordInput, {
            "data-testid": "reset-password-input",
            id: "password-input",
            onChange: function onChange(e) {
              return _onChange(e.target.value);
            },
            autoFocus: true,
            value: value
          })), React.createElement(ContentBlock, null, React.createElement(ToDoList, {
            list: challenges.map(function (challenge) {
              return {
                text: challengeMap(rules.length)[challenge],
                complete: completedChallenges.includes(challenge)
              };
            })
          }))), React.createElement(DialogFooter, null, React.createElement(Button, {
            size: "large",
            type: "submit",
            look: "primary",
            disabled: invalid
          }, React.createElement(FormattedMessage, {
            id: "751710530",
            defaultMessage: "Submit"
          })), React.createElement(Button, {
            size: "large",
            onClick: onCancel
          }, React.createElement(FormattedMessage, {
            id: "3528672691",
            defaultMessage: "Cancel"
          }))));
        }
      });
    }
  });
};

var WarningIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGg0OHY0OEgweiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNGMjlCMDUiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTQzLjIgNDNINC43ODlhMi43OTMgMi43OTMgMCAwIDEtMi40MTUtMS40IDIuODE1IDIuODE1IDAgMCAxIDAtMi44TDIxLjU3OCA1LjRBMi43OTUgMi43OTUgMCAwIDEgMjMuOTk0IDRjLjk5MyAwIDEuOTE4LjUzNiAyLjQxNiAxLjRsMTkuMDY4IDMzLjE2MmMuMzU4LjUzMS41MjIgMS4wNzUuNTIyIDEuNjM4YTIuODAyIDIuODAyIDAgMCAxLTIuOCAyLjh6TTIyIDM0djRoNHYtNGgtNHptMC0xOXYxNmg0VjE1aC00eiIvPgogICAgPC9nPgo8L3N2Zz4K";

function _templateObject$b() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 48px;\n  height: 48px;\n  align-self: center;\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}

var CenteredIcon = styled(Icon)(_templateObject$b());

var ContactAdmin = function ContactAdmin(_ref) {
  var onContinue = _ref.onContinue,
      warningMessage = _ref.warningMessage;
  return React.createElement(Content, {
    "data-testid": "contact-admin-screen"
  }, React.createElement(ContentBlock, null, React.createElement(CenteredIcon, {
    src: WarningIcon
  })), React.createElement(ContentBlock, null, warningMessage || React.createElement(FormattedMessage, {
    id: "3737470122",
    defaultMessage: "Please contact admin for more information."
  })), React.createElement(ContentBlock, null, React.createElement(Button, {
    onClick: onContinue,
    size: "large",
    look: "primary"
  }, React.createElement(FormattedMessage, {
    id: "3640052215",
    defaultMessage: "Continue"
  }))));
};

ContactAdmin.displayName = "ContactAdmin";
ContactAdmin.propTypes = {
  onContinue: PropTypes.func.isRequired,
  warningMessage: PropTypes.object
};

function _templateObject3$7() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: ", "px;\n  display: block;\n  margin-top: ", "px;\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteralLoose(["\n  animation: rotate 2s linear infinite;\n  transform-origin: center center;\n  height: 100%;\n  width: 100%;\n  max-width: ", "px;\n  max-height: ", "px;\n  margin: auto;\n\n  & .path {\n    stroke-dasharray: 75, 120;\n    stroke-dashoffset: 0;\n    stroke: ", ";\n    animation: dash 1.5s ease-in-out infinite;\n    stroke-linecap: round;\n  }\n\n  @keyframes rotate {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  @keyframes dash {\n    0% {\n      stroke-dasharray: 1, 120;\n      stroke-dashoffset: 0;\n    }\n    50% {\n      stroke-dasharray: 65, 120;\n      stroke-dashoffset: -30px;\n    }\n    100% {\n      stroke-dasharray: 65, 120;\n      stroke-dashoffset: -100px;\n    }\n  }\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  position: absolute;\n  top: calc(50% - ", "px);\n  text-align: center;\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}

var SPINNER_HEIGHT = 72;
var MSG_FONT_SIZE = 14;
var MSG_SPINNER_DISTANCE = 12;
var LoadingContainer = styled.div(_templateObject$c(), SPINNER_HEIGHT / 2);
var StyledSpinner = styled.svg(_templateObject2$9(), SPINNER_HEIGHT, SPINNER_HEIGHT, COLORS.ACTION_COLORS.ONELOGIN_BLUE);
var LoadingMessage = styled.span(_templateObject3$7(), MSG_FONT_SIZE, MSG_SPINNER_DISTANCE);

var Loading = function Loading(_ref) {
  var msg = _ref.msg;
  return React.createElement(LoadingContainer, null, React.createElement(StyledSpinner, {
    viewBox: "20 20 40 40"
  }, React.createElement("circle", {
    className: "path",
    cx: "40",
    cy: "40",
    r: "16",
    fill: "none",
    strokeWidth: "1"
  })), React.createElement(LoadingMessage, null, msg));
};

Loading.propTypes = {
  msg: PropTypes.string
};

function _templateObject$d() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: 275px;\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}

var Container = styled.div(_templateObject$d());

var LoginLoading = function LoginLoading() {
  return React.createElement(Container, null, React.createElement(Loading, null));
};

LoginLoading.propTypes = {};

function _templateObject$e() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: ", ";\n  line-height: 28px;\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}

var StyledTextField = styled.div(_templateObject$e(), COLORS.TEXT_COLORS.DEFAULT, function (props) {
  return props.large ? "16px" : "14px";
});
StyledTextField.defaultProps = {
  large: false
};
StyledTextField.propTypes = {
  large: PropTypes.bool
};
StyledTextField.displayName = "TextField";

function _templateObject2$a() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-bottom: 12px;\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$f() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 12px;\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}

var BottomButton = styled(Button)(_templateObject$f());
var TopButton = styled(Button)(_templateObject2$a());

var EnterRegistrationCode = function EnterRegistrationCode(_ref) {
  var onSubmit = _ref.onSubmit,
      contactInfo = _ref.contactInfo,
      onTryAgain = _ref.onTryAgain;
  return React.createElement(SingleValueForm, {
    onSubmit: onSubmit,
    render: function render(_ref2) {
      var invalid = _ref2.invalid,
          value = _ref2.value,
          _onChange = _ref2.onChange;
      return React.createElement(Content, {
        "data-testid": "enter-sms-code-screen"
      }, React.createElement(ContentBlock, null, React.createElement(Label, {
        forId: "phone-number"
      }, React.createElement(FormattedMessage, {
        id: "3827227259",
        defaultMessage: "A confirmation code was sent to"
      })), React.createElement(StyledTextField, {
        large: true
      }, " ", contactInfo)), React.createElement(ContentBlock, null, React.createElement(Label, {
        forId: "security-code"
      }, React.createElement(FormattedMessage, {
        id: "3327626662",
        defaultMessage: "Enter your confirmation code"
      })), React.createElement(Input, {
        id: "security-code",
        value: value,
        onChange: function onChange(event) {
          return _onChange(event.target.value);
        },
        autoFocus: true,
        invalid: invalid,
        size: "large"
      })), React.createElement(ContentBlock, null, React.createElement(TopButton, {
        size: "large",
        type: "submit",
        look: "primary"
      }, React.createElement(FormattedMessage, {
        id: "3640052215",
        defaultMessage: "Continue"
      })), React.createElement(BottomButton, {
        "data-testid": "try-again-button",
        size: "large",
        look: "regular",
        onClick: onTryAgain
      }, React.createElement(FormattedMessage, {
        id: "2018264248",
        defaultMessage: "Try Again"
      }))));
    }
  });
};

EnterRegistrationCode.displayName = "EnterRegistrationCode";
EnterRegistrationCode.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  contactInfo: PropTypes.string.isRequired
};

function _templateObject$g() {
  var data = _taggedTemplateLiteralLoose(["\n  .react-tel-input {\n    font-family: \"Roboto\", sans-serif;\n    font-size: 15px;\n    position: relative;\n    width: 100%;\n  }\n\n  .react-tel-input :disabled {\n    cursor: not-allowed;\n  }\n\n  .react-tel-input .flag {\n    width: 16px;\n    height: 11px;\n    background: url(data:image/png;base64,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);\n  }\n\n  .react-tel-input .ad {\n    background-position: -16px 0;\n  }\n\n  .react-tel-input .ae {\n    background-position: -32px 0;\n  }\n\n  .react-tel-input .af {\n    background-position: -48px 0;\n  }\n\n  .react-tel-input .ag {\n    background-position: -64px 0;\n  }\n\n  .react-tel-input .ai {\n    background-position: -80px 0;\n  }\n\n  .react-tel-input .al {\n    background-position: -96px 0;\n  }\n\n  .react-tel-input .am {\n    background-position: -112px 0;\n  }\n\n  .react-tel-input .ao {\n    background-position: -128px 0;\n  }\n\n  .react-tel-input .ar {\n    background-position: -144px 0;\n  }\n\n  .react-tel-input .as {\n    background-position: -160px 0;\n  }\n\n  .react-tel-input .at {\n    background-position: -176px 0;\n  }\n\n  .react-tel-input .au {\n    background-position: -192px 0;\n  }\n\n  .react-tel-input .aw {\n    background-position: -208px 0;\n  }\n\n  .react-tel-input .az {\n    background-position: -224px 0;\n  }\n\n  .react-tel-input .ba {\n    background-position: -240px 0;\n  }\n\n  .react-tel-input .bb {\n    background-position: 0 -11px;\n  }\n\n  .react-tel-input .bd {\n    background-position: -16px -11px;\n  }\n\n  .react-tel-input .be {\n    background-position: -32px -11px;\n  }\n\n  .react-tel-input .bf {\n    background-position: -48px -11px;\n  }\n\n  .react-tel-input .bg {\n    background-position: -64px -11px;\n  }\n\n  .react-tel-input .bh {\n    background-position: -80px -11px;\n  }\n\n  .react-tel-input .bi {\n    background-position: -96px -11px;\n  }\n\n  .react-tel-input .bj {\n    background-position: -112px -11px;\n  }\n\n  .react-tel-input .bm {\n    background-position: -128px -11px;\n  }\n\n  .react-tel-input .bn {\n    background-position: -144px -11px;\n  }\n\n  .react-tel-input .bo {\n    background-position: -160px -11px;\n  }\n\n  .react-tel-input .br {\n    background-position: -176px -11px;\n  }\n\n  .react-tel-input .bs {\n    background-position: -192px -11px;\n  }\n\n  .react-tel-input .bt {\n    background-position: -208px -11px;\n  }\n\n  .react-tel-input .bw {\n    background-position: -224px -11px;\n  }\n\n  .react-tel-input .by {\n    background-position: -240px -11px;\n  }\n\n  .react-tel-input .bz {\n    background-position: 0 -22px;\n  }\n\n  .react-tel-input .ca {\n    background-position: -16px -22px;\n  }\n\n  .react-tel-input .cd {\n    background-position: -32px -22px;\n  }\n\n  .react-tel-input .cf {\n    background-position: -48px -22px;\n  }\n\n  .react-tel-input .cg {\n    background-position: -64px -22px;\n  }\n\n  .react-tel-input .ch {\n    background-position: -80px -22px;\n  }\n\n  .react-tel-input .ci {\n    background-position: -96px -22px;\n  }\n\n  .react-tel-input .ck {\n    background-position: -112px -22px;\n  }\n\n  .react-tel-input .cl {\n    background-position: -128px -22px;\n  }\n\n  .react-tel-input .cm {\n    background-position: -144px -22px;\n  }\n\n  .react-tel-input .cn {\n    background-position: -160px -22px;\n  }\n\n  .react-tel-input .co {\n    background-position: -176px -22px;\n  }\n\n  .react-tel-input .cr {\n    background-position: -192px -22px;\n  }\n\n  .react-tel-input .cu {\n    background-position: -208px -22px;\n  }\n\n  .react-tel-input .cv {\n    background-position: -224px -22px;\n  }\n\n  .react-tel-input .cw {\n    background-position: -240px -22px;\n  }\n\n  .react-tel-input .cy {\n    background-position: 0 -33px;\n  }\n\n  .react-tel-input .cz {\n    background-position: -16px -33px;\n  }\n\n  .react-tel-input .de {\n    background-position: -32px -33px;\n  }\n\n  .react-tel-input .dj {\n    background-position: -48px -33px;\n  }\n\n  .react-tel-input .dk {\n    background-position: -64px -33px;\n  }\n\n  .react-tel-input .dm {\n    background-position: -80px -33px;\n  }\n\n  .react-tel-input .do {\n    background-position: -96px -33px;\n  }\n\n  .react-tel-input .dz {\n    background-position: -112px -33px;\n  }\n\n  .react-tel-input .ec {\n    background-position: -128px -33px;\n  }\n\n  .react-tel-input .ee {\n    background-position: -144px -33px;\n  }\n\n  .react-tel-input .eg {\n    background-position: -160px -33px;\n  }\n\n  .react-tel-input .er {\n    background-position: -176px -33px;\n  }\n\n  .react-tel-input .es {\n    background-position: -192px -33px;\n  }\n\n  .react-tel-input .et {\n    background-position: -208px -33px;\n  }\n\n  .react-tel-input .fi {\n    background-position: -224px -33px;\n  }\n\n  .react-tel-input .fj {\n    background-position: -240px -33px;\n  }\n\n  .react-tel-input .fk {\n    background-position: 0 -44px;\n  }\n\n  .react-tel-input .fm {\n    background-position: -16px -44px;\n  }\n\n  .react-tel-input .fo {\n    background-position: -32px -44px;\n  }\n\n  .react-tel-input .fr,\n  .react-tel-input .bl,\n  .react-tel-input .mf {\n    background-position: -48px -44px;\n  }\n\n  .react-tel-input .ga {\n    background-position: -64px -44px;\n  }\n\n  .react-tel-input .gb {\n    background-position: -80px -44px;\n  }\n\n  .react-tel-input .gd {\n    background-position: -96px -44px;\n  }\n\n  .react-tel-input .ge {\n    background-position: -112px -44px;\n  }\n\n  .react-tel-input .gf {\n    background-position: -128px -44px;\n  }\n\n  .react-tel-input .gh {\n    background-position: -144px -44px;\n  }\n\n  .react-tel-input .gi {\n    background-position: -160px -44px;\n  }\n\n  .react-tel-input .gl {\n    background-position: -176px -44px;\n  }\n\n  .react-tel-input .gm {\n    background-position: -192px -44px;\n  }\n\n  .react-tel-input .gn {\n    background-position: -208px -44px;\n  }\n\n  .react-tel-input .gp {\n    background-position: -224px -44px;\n  }\n\n  .react-tel-input .gq {\n    background-position: -240px -44px;\n  }\n\n  .react-tel-input .gr {\n    background-position: 0 -55px;\n  }\n\n  .react-tel-input .gt {\n    background-position: -16px -55px;\n  }\n\n  .react-tel-input .gu {\n    background-position: -32px -55px;\n  }\n\n  .react-tel-input .gw {\n    background-position: -48px -55px;\n  }\n\n  .react-tel-input .gy {\n    background-position: -64px -55px;\n  }\n\n  .react-tel-input .hk {\n    background-position: -80px -55px;\n  }\n\n  .react-tel-input .hn {\n    background-position: -96px -55px;\n  }\n\n  .react-tel-input .hr {\n    background-position: -112px -55px;\n  }\n\n  .react-tel-input .ht {\n    background-position: -128px -55px;\n  }\n\n  .react-tel-input .hu {\n    background-position: -144px -55px;\n  }\n\n  .react-tel-input .id {\n    background-position: -160px -55px;\n  }\n\n  .react-tel-input .ie {\n    background-position: -176px -55px;\n  }\n\n  .react-tel-input .il {\n    background-position: -192px -55px;\n  }\n\n  .react-tel-input .in {\n    background-position: -208px -55px;\n  }\n\n  .react-tel-input .io {\n    background-position: -224px -55px;\n  }\n\n  .react-tel-input .iq {\n    background-position: -240px -55px;\n  }\n\n  .react-tel-input .ir {\n    background-position: 0 -66px;\n  }\n\n  .react-tel-input .is {\n    background-position: -16px -66px;\n  }\n\n  .react-tel-input .it {\n    background-position: -32px -66px;\n  }\n\n  .react-tel-input .jm {\n    background-position: -48px -66px;\n  }\n\n  .react-tel-input .jo {\n    background-position: -64px -66px;\n  }\n\n  .react-tel-input .jp {\n    background-position: -80px -66px;\n  }\n\n  .react-tel-input .ke {\n    background-position: -96px -66px;\n  }\n\n  .react-tel-input .kg {\n    background-position: -112px -66px;\n  }\n\n  .react-tel-input .kh {\n    background-position: -128px -66px;\n  }\n\n  .react-tel-input .ki {\n    background-position: -144px -66px;\n  }\n\n  .react-tel-input .xk {\n    background-position: -128px -154px;\n  }\n\n  .react-tel-input .km {\n    background-position: -160px -66px;\n  }\n\n  .react-tel-input .kn {\n    background-position: -176px -66px;\n  }\n\n  .react-tel-input .kp {\n    background-position: -192px -66px;\n  }\n\n  .react-tel-input .kr {\n    background-position: -208px -66px;\n  }\n\n  .react-tel-input .kw {\n    background-position: -224px -66px;\n  }\n\n  .react-tel-input .ky {\n    background-position: -240px -66px;\n  }\n\n  .react-tel-input .kz {\n    background-position: 0 -77px;\n  }\n\n  .react-tel-input .la {\n    background-position: -16px -77px;\n  }\n\n  .react-tel-input .lb {\n    background-position: -32px -77px;\n  }\n\n  .react-tel-input .lc {\n    background-position: -48px -77px;\n  }\n\n  .react-tel-input .li {\n    background-position: -64px -77px;\n  }\n\n  .react-tel-input .lk {\n    background-position: -80px -77px;\n  }\n\n  .react-tel-input .lr {\n    background-position: -96px -77px;\n  }\n\n  .react-tel-input .ls {\n    background-position: -112px -77px;\n  }\n\n  .react-tel-input .lt {\n    background-position: -128px -77px;\n  }\n\n  .react-tel-input .lu {\n    background-position: -144px -77px;\n  }\n\n  .react-tel-input .lv {\n    background-position: -160px -77px;\n  }\n\n  .react-tel-input .ly {\n    background-position: -176px -77px;\n  }\n\n  .react-tel-input .ma {\n    background-position: -192px -77px;\n  }\n\n  .react-tel-input .mc {\n    background-position: -208px -77px;\n  }\n\n  .react-tel-input .md {\n    background-position: -224px -77px;\n  }\n\n  .react-tel-input .me {\n    background-position: -112px -154px;\n    height: 12px;\n  }\n\n  .react-tel-input .mg {\n    background-position: 0 -88px;\n  }\n\n  .react-tel-input .mh {\n    background-position: -16px -88px;\n  }\n\n  .react-tel-input .mk {\n    background-position: -32px -88px;\n  }\n\n  .react-tel-input .ml {\n    background-position: -48px -88px;\n  }\n\n  .react-tel-input .mm {\n    background-position: -64px -88px;\n  }\n\n  .react-tel-input .mn {\n    background-position: -80px -88px;\n  }\n\n  .react-tel-input .mo {\n    background-position: -96px -88px;\n  }\n\n  .react-tel-input .mp {\n    background-position: -112px -88px;\n  }\n\n  .react-tel-input .mq {\n    background-position: -128px -88px;\n  }\n\n  .react-tel-input .mr {\n    background-position: -144px -88px;\n  }\n\n  .react-tel-input .ms {\n    background-position: -160px -88px;\n  }\n\n  .react-tel-input .mt {\n    background-position: -176px -88px;\n  }\n\n  .react-tel-input .mu {\n    background-position: -192px -88px;\n  }\n\n  .react-tel-input .mv {\n    background-position: -208px -88px;\n  }\n\n  .react-tel-input .mw {\n    background-position: -224px -88px;\n  }\n\n  .react-tel-input .mx {\n    background-position: -240px -88px;\n  }\n\n  .react-tel-input .my {\n    background-position: 0 -99px;\n  }\n\n  .react-tel-input .mz {\n    background-position: -16px -99px;\n  }\n\n  .react-tel-input .na {\n    background-position: -32px -99px;\n  }\n\n  .react-tel-input .nc {\n    background-position: -48px -99px;\n  }\n\n  .react-tel-input .ne {\n    background-position: -64px -99px;\n  }\n\n  .react-tel-input .nf {\n    background-position: -80px -99px;\n  }\n\n  .react-tel-input .ng {\n    background-position: -96px -99px;\n  }\n\n  .react-tel-input .ni {\n    background-position: -112px -99px;\n  }\n\n  .react-tel-input .nl,\n  .react-tel-input .bq {\n    background-position: -128px -99px;\n  }\n\n  .react-tel-input .no {\n    background-position: -144px -99px;\n  }\n\n  .react-tel-input .np {\n    background-position: -160px -99px;\n  }\n\n  .react-tel-input .nr {\n    background-position: -176px -99px;\n  }\n\n  .react-tel-input .nu {\n    background-position: -192px -99px;\n  }\n\n  .react-tel-input .nz {\n    background-position: -208px -99px;\n  }\n\n  .react-tel-input .om {\n    background-position: -224px -99px;\n  }\n\n  .react-tel-input .pa {\n    background-position: -240px -99px;\n  }\n\n  .react-tel-input .pe {\n    background-position: 0 -110px;\n  }\n\n  .react-tel-input .pf {\n    background-position: -16px -110px;\n  }\n\n  .react-tel-input .pg {\n    background-position: -32px -110px;\n  }\n\n  .react-tel-input .ph {\n    background-position: -48px -110px;\n  }\n\n  .react-tel-input .pk {\n    background-position: -64px -110px;\n  }\n\n  .react-tel-input .pl {\n    background-position: -80px -110px;\n  }\n\n  .react-tel-input .pm {\n    background-position: -96px -110px;\n  }\n\n  .react-tel-input .pr {\n    background-position: -112px -110px;\n  }\n\n  .react-tel-input .ps {\n    background-position: -128px -110px;\n  }\n\n  .react-tel-input .pt {\n    background-position: -144px -110px;\n  }\n\n  .react-tel-input .pw {\n    background-position: -160px -110px;\n  }\n\n  .react-tel-input .py {\n    background-position: -176px -110px;\n  }\n\n  .react-tel-input .qa {\n    background-position: -192px -110px;\n  }\n\n  .react-tel-input .re {\n    background-position: -208px -110px;\n  }\n\n  .react-tel-input .ro {\n    background-position: -224px -110px;\n  }\n\n  .react-tel-input .rs {\n    background-position: -240px -110px;\n  }\n\n  .react-tel-input .ru {\n    background-position: 0 -121px;\n  }\n\n  .react-tel-input .rw {\n    background-position: -16px -121px;\n  }\n\n  .react-tel-input .sa {\n    background-position: -32px -121px;\n  }\n\n  .react-tel-input .sb {\n    background-position: -48px -121px;\n  }\n\n  .react-tel-input .sc {\n    background-position: -64px -121px;\n  }\n\n  .react-tel-input .sd {\n    background-position: -80px -121px;\n  }\n\n  .react-tel-input .se {\n    background-position: -96px -121px;\n  }\n\n  .react-tel-input .sg {\n    background-position: -112px -121px;\n  }\n\n  .react-tel-input .sh {\n    background-position: -128px -121px;\n  }\n\n  .react-tel-input .si {\n    background-position: -144px -121px;\n  }\n\n  .react-tel-input .sk {\n    background-position: -160px -121px;\n  }\n\n  .react-tel-input .sl {\n    background-position: -176px -121px;\n  }\n\n  .react-tel-input .sm {\n    background-position: -192px -121px;\n  }\n\n  .react-tel-input .sn {\n    background-position: -208px -121px;\n  }\n\n  .react-tel-input .so {\n    background-position: -224px -121px;\n  }\n\n  .react-tel-input .sr {\n    background-position: -240px -121px;\n  }\n\n  .react-tel-input .ss {\n    background-position: 0 -132px;\n  }\n\n  .react-tel-input .st {\n    background-position: -16px -132px;\n  }\n\n  .react-tel-input .sv {\n    background-position: -32px -132px;\n  }\n\n  .react-tel-input .sx {\n    background-position: -48px -132px;\n  }\n\n  .react-tel-input .sy {\n    background-position: -64px -132px;\n  }\n\n  .react-tel-input .sz {\n    background-position: -80px -132px;\n  }\n\n  .react-tel-input .tc {\n    background-position: -96px -132px;\n  }\n\n  .react-tel-input .td {\n    background-position: -112px -132px;\n  }\n\n  .react-tel-input .tg {\n    background-position: -128px -132px;\n  }\n\n  .react-tel-input .th {\n    background-position: -144px -132px;\n  }\n\n  .react-tel-input .tj {\n    background-position: -160px -132px;\n  }\n\n  .react-tel-input .tk {\n    background-position: -176px -132px;\n  }\n\n  .react-tel-input .tl {\n    background-position: -192px -132px;\n  }\n\n  .react-tel-input .tm {\n    background-position: -208px -132px;\n  }\n\n  .react-tel-input .tn {\n    background-position: -224px -132px;\n  }\n\n  .react-tel-input .to {\n    background-position: -240px -132px;\n  }\n\n  .react-tel-input .tr {\n    background-position: 0 -143px;\n  }\n\n  .react-tel-input .tt {\n    background-position: -16px -143px;\n  }\n\n  .react-tel-input .tv {\n    background-position: -32px -143px;\n  }\n\n  .react-tel-input .tw {\n    background-position: -48px -143px;\n  }\n\n  .react-tel-input .tz {\n    background-position: -64px -143px;\n  }\n\n  .react-tel-input .ua {\n    background-position: -80px -143px;\n  }\n\n  .react-tel-input .ug {\n    background-position: -96px -143px;\n  }\n\n  .react-tel-input .us {\n    background-position: -112px -143px;\n  }\n\n  .react-tel-input .uy {\n    background-position: -128px -143px;\n  }\n\n  .react-tel-input .uz {\n    background-position: -144px -143px;\n  }\n\n  .react-tel-input .va {\n    background-position: -160px -143px;\n  }\n\n  .react-tel-input .vc {\n    background-position: -176px -143px;\n  }\n\n  .react-tel-input .ve {\n    background-position: -192px -143px;\n  }\n\n  .react-tel-input .vg {\n    background-position: -208px -143px;\n  }\n\n  .react-tel-input .vi {\n    background-position: -224px -143px;\n  }\n\n  .react-tel-input .vn {\n    background-position: -240px -143px;\n  }\n\n  .react-tel-input .vu {\n    background-position: 0 -154px;\n  }\n\n  .react-tel-input .wf {\n    background-position: -16px -154px;\n  }\n\n  .react-tel-input .ws {\n    background-position: -32px -154px;\n  }\n\n  .react-tel-input .ye {\n    background-position: -48px -154px;\n  }\n\n  .react-tel-input .za {\n    background-position: -64px -154px;\n  }\n\n  .react-tel-input .zm {\n    background-position: -80px -154px;\n  }\n\n  .react-tel-input .zw {\n    background-position: -96px -154px;\n  }\n\n  .react-tel-input * {\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n  }\n\n  .react-tel-input .hide {\n    display: none;\n  }\n\n  .react-tel-input .v-hide {\n    visibility: hidden;\n  }\n\n  .react-tel-input .form-control {\n    position: relative;\n    font-size: 14px;\n    letter-spacing: 0.01rem;\n    z-index: 0;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n    padding-left: 48px;\n    margin-left: 0;\n    background: #ffffff;\n    border: 1px solid #cacaca;\n    border-radius: 5px;\n    line-height: 25px;\n    height: 35px;\n    width: 300px;\n  }\n\n  .react-tel-input .form-control.invalid-number {\n    border: 1px solid #d79f9f;\n    background-color: #faf0f0;\n    border-left-color: #cacaca;\n  }\n\n  .react-tel-input .form-control.invalid-number:focus {\n    border: 1px solid #d79f9f;\n    border-left-color: #cacaca;\n    background-color: #faf0f0;\n  }\n\n  .react-tel-input .form-control.open {\n    z-index: 2;\n  }\n\n  .react-tel-input .flag-dropdown {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    padding: 0;\n    background-color: #f5f5f5;\n    border: 1px solid #cacaca;\n    border-radius: 3px 0 0 3px;\n  }\n\n  .react-tel-input .flag-dropdown.open {\n    z-index: 2;\n    background: #fff;\n    border-radius: 3px 0 0 0;\n  }\n\n  .react-tel-input .flag-dropdown.open .selected-flag {\n    background: #fff;\n    border-radius: 3px 0 0 0;\n  }\n\n  .react-tel-input .flag-dropdown:hover,\n  .react-tel-input .flag-dropdown:focus {\n    cursor: pointer;\n  }\n\n  .react-tel-input .flag-dropdown:hover .selected-flag,\n  .react-tel-input .flag-dropdown:focus .selected-flag {\n    background-color: #fff;\n  }\n\n  .react-tel-input input[disabled] + .flag-dropdown:hover {\n    cursor: default;\n  }\n\n  .react-tel-input input[disabled] + .flag-dropdown:hover .selected-flag {\n    background-color: transparent;\n  }\n\n  .react-tel-input .selected-flag {\n    position: relative;\n    width: 38px;\n    height: 100%;\n    padding: 0 0 0 8px;\n    border-radius: 3px 0 0 3px;\n  }\n\n  .react-tel-input .selected-flag .flag {\n    position: absolute;\n    top: 50%;\n    margin-top: -5px;\n  }\n\n  .react-tel-input .selected-flag .arrow {\n    position: relative;\n    top: 50%;\n    margin-top: -2px;\n    left: 20px;\n    width: 0;\n    height: 0;\n    border-left: 3px solid transparent;\n    border-right: 3px solid transparent;\n    border-top: 4px solid #555;\n  }\n\n  .react-tel-input .selected-flag .arrow.up {\n    border-top: none;\n    border-bottom: 4px solid #555;\n  }\n\n  .react-tel-input .country-list {\n    z-index: 1;\n    list-style: none;\n    position: absolute;\n    padding: 0;\n    margin: 2px 0 10px -1px;\n    box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.35);\n    background-color: white;\n    width: 300px;\n    max-height: 200px;\n    overflow-y: scroll;\n    border-radius: 0 0 3px 3px;\n  }\n\n  .react-tel-input .country-list .flag {\n    display: inline-block;\n  }\n\n  .react-tel-input .country-list .divider {\n    padding-bottom: 5px;\n    margin-bottom: 5px;\n    border-bottom: 1px solid #ccc;\n  }\n\n  .react-tel-input .country-list .country {\n    padding: 7px 9px;\n  }\n\n  .react-tel-input .country-list .country .dial-code {\n    color: #6b6b6b;\n  }\n\n  .react-tel-input .country-list .country:hover {\n    background-color: #f1f1f1;\n  }\n\n  .react-tel-input .country-list .country.highlight {\n    background-color: #f1f1f1;\n  }\n\n  .react-tel-input .country-list .flag {\n    margin-right: 7px;\n    margin-top: 2px;\n  }\n\n  .react-tel-input .country-list .country-name {\n    margin-right: 6px;\n  }\n\n  .react-tel-input .country-list .search {\n    position: sticky;\n    top: 0;\n    background-color: #fff;\n    padding: 10px 0 6px 10px;\n  }\n\n  .react-tel-input .country-list .search-emoji {\n    font-size: 15px;\n  }\n\n  .react-tel-input .country-list .search-box {\n    border: 1px solid #cacaca;\n    border-radius: 3px;\n    font-size: 15px;\n    line-height: 15px;\n    margin-left: 6px;\n    padding: 3px 8px 5px;\n  }\n\n  .react-tel-input .country-list .no-entries-message {\n    padding: 7px 10px 11px;\n    opacity: 0.7;\n  }\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
} // and paste here. This is just exported prettified content of style.css.
// We wanted to avoid rollup's css-postprocessors to be involved in RC. So the styles are wrapped into this styled.css
// we also need to delete all the `outline: none` in this file


var phoneNumberInputStyles = css(_templateObject$g());

function _templateObject$h() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  .react-tel-input {\n    .form-control {\n      line-height: normal;\n      height: 38px;\n      border-radius: 2px;\n      width: 100%;\n      padding-left: 66px;\n      border-color: ", ";\n    }\n\n    .flag-dropdown {\n      background-color: white;\n      width: 54px;\n      border-color: ", ";\n\n      .selected-flag {\n        padding-left: 12px;\n        z-index: inherit;\n        .arrow {\n          left: 24px;\n        }\n      }\n    }\n  }\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}

var phoneInputStyle = {
  lineHeight: "normal",
  height: "38px",
  borderRadius: "2px",
  width: "100%",
  color: COLORS.GRAY_COLORS.GRAY_35,
  fontFamily: FONTS.FONT_FAMILY.DEFAULT
};
var countrySelectorStyle = {
  backgroundColor: "white",
  width: "48px"
};
var PhoneInputWrapper = styled.div(_templateObject$h(), phoneNumberInputStyles, COLORS.GRAY_COLORS.GRAY_88, COLORS.GRAY_COLORS.GRAY_88);

var PhoneNumberInput = function PhoneNumberInput(_ref) {
  var _onChange = _ref.onChange,
      value = _ref.value,
      defaultCountry = _ref.defaultCountry,
      disabled = _ref.disabled,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? null : _ref$placeholder;
  return React.createElement(PhoneInputWrapper, null, React.createElement(PhoneInput, {
    id: "phone-number",
    country: defaultCountry,
    value: value,
    onChange: function onChange(value) {
      return _onChange(value);
    },
    buttonStyle: countrySelectorStyle,
    inputStyle: phoneInputStyle,
    disableAreaCodes: true,
    disabled: disabled,
    placeholder: placeholder
  }));
};

PhoneNumberInput.displayName = "PhoneNumberInput";
PhoneNumberInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  defaultCountry: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string
};

var EnterPhoneNumber = function EnterPhoneNumber(_ref) {
  var onSubmitSMS = _ref.onSubmitSMS,
      phoneNumber = _ref.phoneNumber,
      defaultCountry = _ref.defaultCountry,
      placeholder = _ref.placeholder;
  return React.createElement(SingleValueForm, {
    onSubmit: onSubmitSMS,
    value: phoneNumber,
    render: function render(_ref2) {
      var invalid = _ref2.invalid,
          value = _ref2.value,
          onChange = _ref2.onChange;
      return React.createElement(Content, {
        "data-testid": "enter-phone-number-screen"
      }, React.createElement(ContentBlock, null, React.createElement(Label, {
        forId: "enter-phone-number"
      }, React.createElement(FormattedMessage, {
        id: "2229754167",
        defaultMessage: "Enter your phone number"
      })), React.createElement(ContentBlock, null, React.createElement(PhoneNumberInput, {
        defaultCountry: defaultCountry || "us",
        onChange: onChange,
        value: value,
        placeholder: placeholder
      }))), React.createElement(ContentBlock, null, React.createElement(Button, {
        size: "large",
        type: "submit",
        look: "primary"
      }, React.createElement(FormattedMessage, {
        id: "3640052215",
        defaultMessage: "Continue"
      }))));
    }
  });
};

EnterPhoneNumber.displayName = "EnterPhoneNumber";
EnterPhoneNumber.propTypes = {
  onSubmitSMS: PropTypes.func.isRequired,
  phoneNumber: PropTypes.string,
  defaultCountry: PropTypes.string,
  placeholder: PropTypes.string
};

function _templateObject7$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: ", "px;\n  height: ", "px;\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteralLoose(["\n  align-self: center;\n  padding-left: 4px;\n  font-size: 14px;\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = _taggedTemplateLiteralLoose(["\n  align-self: flex-end;\n  display: flex;\n  align-items: center;\n  height: 100%;\n"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$5() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex: 1 1 auto;\n  padding-right: ", "px;\n"]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$8() {
  var data = _taggedTemplateLiteralLoose(["\n  height: ", "px;\n  width: ", "px;\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: left;\n  align-items: center;\n  flex: 0 0 ", "px;\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$i() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  width: auto;\n  height: ", "px;\n  cursor: pointer;\n  border-bottom: 1px solid ", ";\n  font-size: 16px;\n  color: ", ";\n  overflow: hidden;\n  padding-right: 24px;\n  padding-left: 24px;\n  flex-shrink: 0;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:first-child {\n    border-top: 1px solid ", ";\n  }\n\n  &:last-child {\n    border-bottom: 1px solid ", ";\n  }\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}

var ICON_IMAGE_SIZE = 24;
var ICON_MARGIN = 16;
var LIST_HEIGHT = 56;
var Container$1 = styled.div(_templateObject$i(), LIST_HEIGHT, COLORS.SEPARATOR_COLORS.REGULAR, COLORS.TEXT_COLORS.DEFAULT, COLORS.ONELOGIN_GRAY_COLORS.ONELOGIN_GRAY_LIGHT, COLORS.SEPARATOR_COLORS.MEDIUM, COLORS.SEPARATOR_COLORS.MEDIUM);
var IconWrapper = styled.div(_templateObject2$b(), ICON_IMAGE_SIZE + ICON_MARGIN);
var Icon$1 = styled.img(_templateObject3$8(), ICON_IMAGE_SIZE, ICON_IMAGE_SIZE);
var TextWrapper = styled.div(_templateObject4$5(), ICON_MARGIN);
var Configure = styled.div(_templateObject5$2());
var ConfigureText = styled.div(_templateObject6$1());
var AddIcon = styled.img.attrs(function (props) {
  return {
    src: props.icon
  };
})(_templateObject7$1(), function (props) {
  return props.big ? 24 : 16;
}, function (props) {
  return props.big ? 24 : 16;
});

var ListItem$1 = function ListItem(_ref) {
  var icon = _ref.icon,
      text = _ref.text,
      showConfigure = _ref.showConfigure,
      configureIcon = _ref.configureIcon,
      showConfigureText = _ref.showConfigureText,
      onClick = _ref.onClick;
  return React.createElement(Container$1, {
    onClick: onClick
  }, icon && React.createElement(IconWrapper, null, React.createElement(Icon$1, {
    src: icon,
    alt: text
  })), React.createElement(TextWrapper, null, text), showConfigure && React.createElement(Configure, null, React.createElement(AddIcon, {
    big: !showConfigureText,
    icon: svgList[configureIcon]
  }), showConfigureText && React.createElement(ConfigureText, null, React.createElement(FormattedMessage, {
    id: "1477893598",
    defaultMessage: "Configure"
  }))));
};

ListItem$1.propTypes = {
  /** Optional icon to render */
  icon: PropTypes.string,

  /** Text displayed in item */
  text: PropTypes.string.isRequired,

  /** Show +configure icon and text */
  showConfigure: PropTypes.bool,

  /** Change configure icon */
  configureIcon: PropTypes.string,

  /** Show configure text next to icon */
  showConfigureText: PropTypes.bool,

  /** On item click handler */
  onClick: PropTypes.func.isRequired
};
ListItem$1.defaultProps = {
  configureIcon: "Plus-24"
};
var EmailIcon = "data:image/png;base64,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";
var ProtectIcon = "data:image/png;base64,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";
var VipIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDAgNzkuMTYwNDUxLCAyMDE3LzA1LzA2LTAxOjA4OjIxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+LUNEtwAAEw5JREFUeJztnHmcVNWVx7/nvveqqje6AVkEFBEVQRGMSgsjBBFcWYIxiUnG4ETNqnFGjcSgBhPxY2LGqDGGxCUxjhljYmKURBPRz0xG44IajQoCLiwCIgTo7urqWt67Z/54Vd3V1VVdr1lMPkl+n88PPl3v3nPvPe8u55577hMAXUzvsKCjXHRYA5K1qC+IY2GghcCDVkCyEDjgGehnIWVAQbOhCEkEkDSQMOAppAVFQDWfwCACigVrQUAcF2wGxEWtIAao9SHpggICGIvEhSee7uCkRZkqDamMsQc4PHZ9A8OHmuNsWn8FrHXO2Hmi2W2Jf2dYtTFg9lVJ1m9Wx8RlODAG4J8K6sKZL73lPz7nytbPbtnCLCPOWfBPBRVjNDDjlfXBsfc8nlmO0T8CuH/lSv214AAXAfvl/1YgAK6eOcHjC2fGr1Xfbgdu+kdVUABcBgwv+m3p9PHe53+xuOG4+oQ+Z3O08A+ooHrgg0aITR7rZuobJPvntcHLW3bYrcALpx/n0ThYknanLkPkHfg7GmIaLdkBwDLHwN2X1TF6nMuaV/xr/+Wy1oe2tyjr3rOgukoMc9QK8P4qqAlhBMqBBLI/MAjohxAPH2sWaAG2g2wBNgDvADujCJfyGuoPNAFJYBtggRzg5WX7r64PBqYyHAS03P5oeuekMQ4L5sahLRSwbxQkgGJQjgKZjDBfs+6RuAzG4mALCYtbpZ02IyIAgQZ2G+K8JioPAf8HvILg9ygvCxMPcxk5JMv6rd009RXgYuB+4FOECnJ9i/78ydwZx7ynaz75rfY701m9Dbgl57PwvO+0M7hJOG1qAtgXClIZQUbmaU7OAyYgeVMi4hgoggMMRc1QhZMAq8prkjF3Ag8C6zuLDGDAEGHhv3pceGMW21VWDIgDCUKTxgECVbjirlSHEdJWcfPPYwCBhbOubecXi8JqC+ytrUZurKq7EDFzUe0fSt4HCLcYLcAygeswdiVWEDdH1hGOPCfF2i2dXXQY4VBuBr4AbAEW5Z8tAfYHbgOeIxyCmwoZRw9xeXOrv4c9SADLSES+qngfR2gAZZ8pp1AmNAKfVJgvKvcDi1HWGwHX6ZZ6c56jgAnAEODF/LOJwFDC1/tSaTF+EP6/+woSoMOcrxmuAR2223L2DLWqci5wqmCWiKO3xjwArgAOpWtLuw34NFAL3JHPuwRIEfaeHjD5PcbuKmiIOuYmOuTsfdpbomOoWve7Tq2csOjj9tJPfDM1xw+YXPT8Z8BCwlXt1vxvIwlXyrIw+Xb1XUFGjseVHwGH/40oBzHQkYaf/yzzsXSWo5vqTWx7iy1OMho4j3BOsnnW9iazPRPO9OEk/bUqNbCgoxx0WOM8Av1voGb3mrL3YQxQI7RuVxrPimQyFXAEsLJaIrfo38pQAc89G+WeCKnfN4iB1nbljTcDWtuVE45wSWVhzcaAZLqsXZEhVEqWcP6pirCxY3pJoS420fAxHO7B6t5QTguwCeQdQdcA2xVFkIGKHgYyHBhBaAFXhBGgRnj5VZ9pX25jQIPw9o8b6TfAMPXCVp58rac9CWwEjidUUCSEDd5cqRbAcG8aMbl9j5RjWIfKAyiPigYrMeY9VPwu6zH/vyqIcRA7SJCxWJ2pIh8nXKa7IJDJQS6pJDvCvIGFtpTiJpQg6F68CDlVkoQbCEsfEM5BT1fwm+1wR9ts3f8QlxFd+4A+Cf8NPnfQoI9rxrRhQTQIJw41nXVVLIKgqiAOSPg3gQVr6lGdpq58xrjMAyAuLP1lmiX3pcnmlPd2KUZg6ACDY2DrLks211WP2c2xltknM3fxLdnX321hG32w68NeMTLW84lvjM3E70Lpu3JEnxVHr8d3HsT26YV1FxPWMInht1Krv0232lOT7eaS/UaZmam0yjvbumRbhc1/KV9WzKXxs7Prr5kzMTNz9Q4buTUnXdCRV1BrrvsTUXRbYiFtMg3TB+UoKjG9Edf/Kr5kw61P3yCAuEBMwIc337L8cWWONdssDz+TfXTrDiZNHOPMWLfJdhPer1a4/eJaGhoMly1NsXJDwPmnxjhzepwhdYJuZ/qwMfL1YQf7iyKb+hcUelCqrnsNO2Sc7nKu7Jty9C+S4EKE+0LfQ9+MJAEkLuAIm99VHnsxzSPP5Vj2nE979xVp/KPP2B6aj8fgozPjsJ/haz/uAMKjnNNmxKBFsVlF344tNGvMA1j7YrTqZfMK8opmfCtoMnYLaK+GVEnztom188XhKVyBuIAvkBNIC8RBAtAcPUa/ABITMMJLa3xue6iDB57MsqOtW8L9gM8Q7rjHlatBewdc8YMUiRrhtGM9Tm/2aD7cRVsUzeZlGXVs3FxnHHsGQlBOTo+WAejyrgVKcU7UTO0T0RQDiO4UwymiwQrqDa+sVR7/U5pduwSsYf9+wtFHORw0wGXwQAGxkBM0MKFHICasfjvH4p+k+eVTPlm/R681wGPAjKhVeuY7DTRP6eo5pb1F4MMCv6zatDN2hj1IbU0hp2jWvabg8aoKMUhtcI40ZlbgK5+7JuCOR3yCoGfeQY2G5rEO55/sccqkOIl+QvsuuPqHKX7w20zpMCrGN4mgnJgLHxzv4blQlxC0VdFcec+CwuVi9OF8n+69iQD2sYa868JM0Zx5qlqmMKcg7ZnFAtfQIFz144Br7+uIlHXsgQ6zjvV4bEWOVRt77emzgYejyBzUKGz4SROJfgJprbp4iupcUelVtszJ9yCpD202bYtdFKn3CODr0/Kefx2u5a77A677efTlfNWGgFUbqk4BI4E7I4hLAmtSGd3x7s4gdlCNOy2SZWHkHMRWVX5+L5YDNcPVmnnRbCjxTSr3Jfq7uadft1z0sI8N54pLgDOBZ4C7gZcjCCsHB/ghMDhC2peBE7I+ZH09HOFZoF+1TAony9DMARi7sbcVLZyD3vUAZzpGaqIoSNQ+Sr15nrjD4m8nSYXzx1HADfkkkwldnDcDNxG6OvuCTwMnV0mTI9x8JgEOHiaMPMi+jvp3g3NR9SKkUd9yzpSM3tzbAXz4KF4HbnxWRAs8QMzX8RxS7YbVmzr7c0e+wgXEgcuBFcBpUQTnMZouRfeGuwiX/E8BHHmgS9xzwDc3ErpRe4cqxLyT1I2hpjyhoCA/aFRrZ0WpvYi+gLErEIsXU+oSnf1zNXBVmSzDgd8AV0eRD1xH6HOuhg7C3fl7APOaY+EBQmDWCbIsSkEq8gFqbT11AWVJQUFe7nBCb1sVCDj2frws6mTwGjOMHdktwX8C/1U+I9dQvWecDHy0ej2whOdkACQ8mHqkB37ouiLiyofIcBo4nialLCkoKOOMjSQQzZD2HiRZC8la6Khl0qhEacW/ADxdQcBlwNd7KWBhhErkgHMoMvROPdbloBEWsjlQH9R/CmivLkohGZtISxx2lSGdQ0wOjbQ3cXibQdn1DMrAoCw0Zpk/G+pru2VuI+wFb1aQchXhJFyK2USzlr8E/LT4hwWzasGLocaDkBtFpNJL6g7VQ/DzYX+lJK8gTXBAJMPZspZWx6fVgVYH/mI4dGCMow/usXd8B/gIld2aNwKHlPx2cYTmXA8sLf6hqRamHAjs8CEZdDGrf4r00oUDkIIfv5SFHmTNoAiiAF1HoBSogYJRZk4s69b4E3BhBUGNwA+K/h4HTKtS+KOUmeiPO8xj8P4GFQ2DQz0FV8Ho+igvXZGBalzKETpD8DSaglS3hrFHRcz5zJ/skIiVfV0/Ar5fQdoM8ks0cCn5s/EKaAE+Rzj/dMO8KTGoc9CYg8bzTDioY7ZGahPUi7GuGEspgc7AgvookhSnXYnRjdkY4w9LMHlsRefYpYQmQDlcReigr2YnfYWiYIUC6hLCh5pdyCiCIlpENBmlTUAc67hYhx6kK4gzajBnj12OAsSEqUd4lfJ0EDawHA4BHiAMIqiEP1NhTzb+IIfhQxzwNfQrFbFcXStArBXKEboUk44mSuMYSw9ay4yje9Xxg1S2TSZVKXURZYYWQPMYF2ryU6p0p4YhLdVhNOfUZq1Tm6WUkFeQiOyIIktEB4ijiOlOfEvzkS5jRvTqg76WPpxH5fEG8PvydYH5J9SA5pd2KaLxwDgDIpWgkrK+k7O+QymhsMyj26MJMyOwhlKqb0g0OMyZXHGYQRhF8etI5XThXioodVCjMHGUQiYb+r2KaXOgwYhIJVhpkUxMJROjlNA5SdtNvckoQNFDwyOgMvQtpx1T9Wzx1moJipABflLp4TGjXRobFc0FiC1D1d7Oi7vg2C2ayFCO0KkgeTtipQ/FOAMwDj2Yc5gyIc64kb0Osz8AkTaSwKtAxXrNaHahyUB9GdY59YpMjVSK8lap5dJJCnOQupWW4RJhMoBMRzOpNugoYbKNhJtkwQerSvlepLJCp1tZUy/mCjM/4EDOhocApcROJPRI9g4RJO2vlrYckuxJKPSgen8lEnElc2ILiCcg1p0aTwBxPjK9lrjXq42/nLAnVUPFnnbocGH8UAM7NfT8lLLdnBKpLWg7xnsSNw5OGVLoQQMyG8QLL29UEYgis8RhP3GVUqLKqNFw+qReh5kP3FKloCS9uGunj/dwagwEgmgJLZ6iZ1ZvCwCvUhOso85SlhR60GtxJSnLIx6GDtCc+zk6EpRluoYr5jdUk/EIZSzjIqwj7wgrhRH48GgL6zOwqYQbM2iKs3FM2cPF7hDE2KcRn4qksMw3CLi6PGrMgwpfxM024aXBLWHQwXETLfOn9La1IgV8q5fnq6D8yefEUYYTpxtoCGA/252DbFzruDRSOxRLOvMg6SwVSWGI2Syi/kvAKxFEAzpUjS4Me1wZI18Cvv8fdRx9cK/L/r1UjkwqaxwCfH5eDQxugqYm6F/Exia0X79/x3UmRIlGEaMvShD/g2TrqEQo9KB4HI3FciJSbW7ohObcy2mKT+ZggYNNF2s8NOkxZKDhsRvqOe24isZjC3AB+VOJIjwC3FOa2BG4dkGc8z/kQrYdMq2QLLAFtP0QtcEVkSN/cvZ+XBQPKpLCyepDncdIA9VxVgMDqxagQMy+YYK2ZgKb36q4aDYOMQ8cE07c4vDtn3Ww5KcpdrWXrf0RhJfb+gO/I/Rpd7OeRw413HZRHadPcSCwaCDI5gB2tYcVcd24HlD/vxozzRFjmVpMhqMItGIYMIB8ZFc+eOHhrkMEFblcRb4ZpRQQCIJlJrDzVdTHN2EkU52TjyJTxBioEd54O8clS1M8/EzV4/BuOOdEjxsuSTCkvwc7AzSu4e7Ud4EsgsGK3IeYj0WcexArS8TolVVbN3tnXkGPFB9gapPVYDWqUU41Q0HIPaj+G9kgIFCo7VIQGBQwMUVjAXf/xufKOzrYVCEarIAhTcL159Vy7ske1ARo2oWMhYKCci5qFBFzs6r9UtS64up202AnglTdXsmUlvwyL61dNG27RLNRz7AAUPQcFb0fpOL6rhlFrHLunDgvfLcfiz6aoLG+p11hBL44N8GK2xo5d04MshVjMOLA3X1SjoI47tV48U14HlVJIT7o7pJ2iYjt7zyBw/TIk56ABDxLLriQmHkep3sPErVoTQA5BxMAMVi7Qbn3iQwvrPGJe8LhIx1OOcZj6jEe5BTN2nCxrwsgKPQgC1bG4bs3q+jMyMoJW/qs2ZmZji+Rdg2yIJXPtqxs4PxoK4nnqRKvXAZtAldhZCmqmXIKkgxgFalzQid7IcDNlVAhGQ3fi5YoKGsdHC5QNd9AO28sR2gpoNJhdvmT8INXI2db0F44m9dyfFMc++XduNvUoHCTWv0DYaRHxWsLmlNsu0JGsWnFphRbUE63hMRQ5oJ5XK35fp+UA2AF8XMXE+NVEgZqIpJC+IspP3WIyB0EubFquWQ3PkEwSZUHQFcjLCU8tllLGQu5wigW4BAMp2jGuQA4arcuzxgQP7hdNiRvDwPV+5Y9HGI9rpMVIfDEttTeQ8p8cg9v92QxuhqVlyVgBVZfxDMtqpoWQJU4RhqBCahOIrzwNoaovuVyUBBHfi3Ht30YLxcpaLMYUl9QULWJeK2p01VNP1VX5+5WRSsjoGgGYncCq3uDshxH5plprSlqy97d6BUiUY97VNoF/xMiuXv38n1Lh3C5jrO3lQO/As4CUrtxobgT0WcW1XbUP1ec4Du7X9w+Rt49LuitInK2hvu9PULfpl7FJxFcInHOp/Pq/d8IFHBpk4S9EPQitM9HTGWxG5/HUXC4UxLMQCWK6/T9geEZabAzqbPf25Mh1VPs7kLkeVEzXbCXAu/uvSr1tR5sF+RyccxUjJa9wbwn2NMPLClWb5Ss/YAIS4j4nY29hBZscL3UZI8mDO3r+zIVAXvnC1TKFoQrxQ8mCHo5wlt7RW4pwhj3dQKLJGcnig2uQPSdfVJWHnv3gq7VjXh6g6T1NsSZrIZTQWcB4ym2D/p2W0pBVoryO/zg9wT8kZi8bwvEvrnBrLQjLEdZjuCJ2iNUnPHAOHHsISoMw5cmoA4Kn8chi5BEaUHYLPAG6OtgXlYrr6Hkv1ry/l7W/3/QwDOVglCqPgAAAABJRU5ErkJggg==";
var YubiKeyIcon = "data:image/png;base64,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";
var DuoIcon = "data:image/png;base64,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";
var GoogleAuthIcon = "data:image/png;base64,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";
var OneloginSmsIcon = "data:image/png;base64,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";
var SecureIdIcon = "data:image/png;base64,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";
var SecurityQuestionsIcon = "data:image/png;base64,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";
var TempOtpIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MDAiIGhlaWdodD0iNTAwIiB2aWV3Qm94PSIwIDAgNTAwIDUwMCI+CiAgPG1ldGFkYXRhPjw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+Cjx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQwIDc5LjE2MDQ1MSwgMjAxNy8wNS8wNi0wMTowODoyMSAgICAgICAgIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIvPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPiAgICAgICAgICAgICAgICAgICAgICAgICAKPD94cGFja2V0IGVuZD0idyI/PjwvbWV0YWRhdGE+CjxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICMxYzFmMmE7CiAgICAgICAgZmlsbC1ydWxlOiBldmVub2RkOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMTIwLDM4NmMtMTM4LjA3LDAtMjUwLDExMS45MjgtMjUwLDI1MHMxMTEuOTMsMjUwLDI1MCwyNTAsMjUwLTExMS45MjcsMjUwLTI1MFMyMjU4LjA3LDM4NiwyMTIwLDM4NlptMzcuMTEsMzM4LjQ2NnEwLDcuMDg3LTcuMDksNy4wODdoLTQ0Ljg3cS03LjA5NSwwLTcuMDktNy4wODdWNjE2LjIzNmgtMzQuNDhxLTcuMSwwLTcuMDktNy4wODZWNTY0LjI2OXEwLTcuMDg2LDcuMDktNy4wODZoODcuNjNjNC43MiwwLDUuOSwyLjM2Miw1LjksNS45VjcyNC40NjdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTg3MCAtMzg2KSIvPgo8L3N2Zz4K";
var OneloginVoiceIcon = "data:image/png;base64,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";
var WebAuthnOtpIcon = "data:image/png;base64,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";
var EmailOtpIcon = "data:image/png;base64,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";
var MFA_TYPE_EMAIL = 0;
var MFA_TYPE_YUBIKEY = 1;
var MFA_TYPE_VIPACCESS = 2;
var MFA_TYPE_SECURID = 7;
var MFA_TYPE_ONELOGIN = 8;
var MFA_TYPE_AUTHENTICATOR = 10;
var MFA_TYPE_SMS = 11;
var MFA_TYPE_DUOSECURITY = 12;
var MFA_TYPE_SECURITYQUESTIONS = 13;
var MFA_TYPE_TEMP_OTP = 16;
var MFA_TYPE_VOICE = 17;
var MFA_TYPE_WEBAUTHN = 18;
var MFA_TYPE_EMAIL_OTP = 19;

var IconProvider = function IconProvider(type) {
  switch (type) {
    case MFA_TYPE_EMAIL:
      {
        return EmailIcon;
      }

    case MFA_TYPE_YUBIKEY:
      {
        return YubiKeyIcon;
      }

    case MFA_TYPE_VIPACCESS:
      {
        return VipIcon;
      }

    case MFA_TYPE_SECURID:
      {
        return SecureIdIcon;
      }

    case MFA_TYPE_ONELOGIN:
      {
        return ProtectIcon;
      }

    case MFA_TYPE_AUTHENTICATOR:
      {
        return GoogleAuthIcon;
      }

    case MFA_TYPE_SMS:
      {
        return OneloginSmsIcon;
      }

    case MFA_TYPE_DUOSECURITY:
      {
        return DuoIcon;
      }

    case MFA_TYPE_SECURITYQUESTIONS:
      {
        return SecurityQuestionsIcon;
      }

    case MFA_TYPE_TEMP_OTP:
      {
        return TempOtpIcon;
      }

    case MFA_TYPE_VOICE:
      {
        return OneloginVoiceIcon;
      }

    case MFA_TYPE_WEBAUTHN:
      {
        return WebAuthnOtpIcon;
      }

    case MFA_TYPE_EMAIL_OTP:
      {
        return EmailOtpIcon;
      }

    default:
      return ProtectIcon;
  }
};

var SelectMFADevice = function SelectMFADevice(_ref) {
  var devices = _ref.devices,
      onSelect = _ref.onSelect;
  return React.createElement("div", {
    "data-testid": "devices-list"
  }, devices.map(function (device) {
    return React.createElement(ListItem$1, {
      key: device.id,
      icon: IconProvider(device.factorTypeId),
      text: device.factorName,
      onClick: function onClick() {
        return onSelect(device.id);
      }
    });
  }));
};

SelectMFADevice.displayName = "SelectMFADevice";
SelectMFADevice.propTypes = {
  devices: PropTypes.arrayOf(PropTypes.shape({
    /** Text representation of link */
    factorName: PropTypes.string.isRequired,

    /** On link click handler */
    id: PropTypes.number.isRequired,

    /** MFA device type id */
    factorTypeId: PropTypes.number.isRequired
  })).isRequired,
  onSelect: PropTypes.func.isRequired
};

var FactorList = function FactorList(_ref) {
  var factors = _ref.factors,
      showConfigure = _ref.showConfigure,
      showConfigureText = _ref.showConfigureText,
      configureIcon = _ref.configureIcon,
      onSelect = _ref.onSelect;
  return React.createElement("div", {
    "data-testid": "factor-list"
  }, factors.map(function (factor) {
    return React.createElement(ListItem$1, {
      key: factor.id,
      icon: IconProvider(factor.typeId),
      text: factor.name,
      showConfigure: showConfigure,
      showConfigureText: showConfigureText,
      configureIcon: configureIcon,
      onClick: function onClick() {
        return onSelect(factor.id);
      }
    });
  }));
};

FactorList.displayName = "FactorList";
FactorList.propTypes = {
  factors: PropTypes.arrayOf(PropTypes.shape({
    /** Text representation of link */
    name: PropTypes.string.isRequired,

    /** MFA id of factor */
    id: PropTypes.number.isRequired,

    /** MFA type of factor */
    typeId: PropTypes.number.isRequired
  })).isRequired,

  /** Show +configure icon and text */
  showConfigure: PropTypes.bool,

  /** Show configure text next to icon */
  showConfigureText: PropTypes.bool,

  /** Change configure icon */
  configureIcon: PropTypes.string,
  onSelect: PropTypes.func.isRequired
};

function _templateObject$j() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 48px;\n  height: 48px;\n  align-self: center;\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}

var ImageWrapper = styled.img(_templateObject$j());

var RegistrationRequired = function RegistrationRequired(_ref) {
  var onContinue = _ref.onContinue,
      message = _ref.message;
  return React.createElement("form", {
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      onContinue();
    }
  }, React.createElement(Content, {
    "data-testid": "registration-required-screen"
  }, React.createElement(ContentBlock, null, React.createElement(ImageWrapper, {
    src: WarningIcon
  })), React.createElement(ContentBlock, null, message || React.createElement(FormattedMessage, {
    id: "2859281487",
    defaultMessage: "2-factor authentication is required to secure your account."
  })), React.createElement(ContentBlock, null, React.createElement(Button, {
    size: "large",
    type: "submit",
    look: "primary"
  }, React.createElement(FormattedMessage, {
    id: "3640052215",
    defaultMessage: "Continue"
  })))));
};

RegistrationRequired.displayName = "RegistrationRequired";
RegistrationRequired.propTypes = {
  onContinue: PropTypes.func.isRequired,
  message: PropTypes.string
};

function _templateObject3$9() {
  var data = _taggedTemplateLiteralLoose(["\n  align-self: center;\n"]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$c() {
  var data = _taggedTemplateLiteralLoose(["\n  counter-increment: item;\n  line-height: ", "px;\n  margin-bottom: 24px;\n  color: ", ";\n\n  display: flex;\n  align-self: center;\n  justify-items: center;\n\n  &:before {\n    flex: 0 0 ", "px;\n    max-height: ", "px;\n    max-width: ", "px;\n    margin-right: 12px;\n    font-size: 14px;\n    line-height: 16px;\n    content: counter(item);\n    background: ", ";\n    border-radius: 100%;\n    color: white;\n    padding: 6px 0;\n    text-align: center;\n    vertical-align: middle;\n    display: flex;\n    justify-content: center;\n    align-self: flex-start;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$k() {
  var data = _taggedTemplateLiteralLoose(["\n  counter-reset: item;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  font-size: 16px; //TODO: unify with content in bullet somehow\n"]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}

var BulletSize = 28;
var BulletOrderedList = styled.ol(_templateObject$k());
var BulletItem = styled.li(_templateObject2$c(), BulletSize, COLORS.TEXT_COLORS.DEFAULT, BulletSize, BulletSize, BulletSize, COLORS.ACTION_COLORS.BLUE_DARKER);
var StyledContent = styled.div(_templateObject3$9());

var Bullets = function Bullets(_ref) {
  var children = _ref.children;
  return React.createElement(BulletOrderedList, null, Children.map(children, function (child) {
    return child && React.createElement(BulletItem, null, React.createElement(StyledContent, null, child));
  }));
};

Bullets.propTypes = {};

function _templateObject$l() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 32px;\n  position: relative;\n  left: 60px;\n"]);

  _templateObject$l = function _templateObject() {
    return data;
  };

  return data;
}

var QRCODE_WIDTH = 120;
var QRCodeWrap = styled.div(_templateObject$l());

var ScanBarCode = function ScanBarCode(_ref) {
  var appName = _ref.appName,
      code = _ref.code,
      onContinue = _ref.onContinue,
      onCantScan = _ref.onCantScan;
  return React.createElement(Content, {
    "data-testid": "scan-bar-code-screen"
  }, React.createElement(ContentBlock, null, React.createElement(Bullets, null, React.createElement(FormattedMessage, {
    id: "737192390",
    defaultMessage: "Open {appName}",
    values: {
      appName: appName
    }
  }), React.createElement("div", null, React.createElement(FormattedMessage, {
    id: "3645029425",
    defaultMessage: "Scan below QR Code"
  }), React.createElement(QRCodeWrap, null, React.createElement(QRCode, {
    value: encodeURI(code),
    size: QRCODE_WIDTH
  }))))), onCantScan && React.createElement(ContentBlock, {
    centered: true
  }, React.createElement(LinkButton, {
    onClick: onCantScan,
    size: "large"
  }, React.createElement(FormattedMessage, {
    id: "3469481929",
    defaultMessage: "Can't scan the code?"
  }))), onContinue && React.createElement(ContentBlock, null, React.createElement(Button, {
    size: "large",
    look: "primary",
    onClick: onContinue,
    "data-testid": "activate-button"
  }, React.createElement(FormattedMessage, {
    id: "3673120330",
    defaultMessage: "Next"
  }))));
};

ScanBarCode.propTypes = {
  appName: PropTypes.string.isRequired,
  onContinue: PropTypes.func,
  onCantScan: PropTypes.func,
  code: PropTypes.string.isRequired
};

function _templateObject3$a() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  box-sizing: border-box;\n  width: 42px;\n  font-family: ", ";\n  line-height: 14px;\n  color: ", ";\n\n  &:not(:last-of-type) {\n    position: relative;\n\n    &::after {\n      content: \"\";\n      display: block;\n      width: 1px;\n      height: 38px;\n      position: absolute;\n      right: 0;\n      top: -12px;\n      background-color: ", ";\n    }\n  }\n"]);

  _templateObject3$a = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$d() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border-width: 1px;\n  border-color: ", ";\n  font-size: ", ";\n  line-height: 1;\n  letter-spacing: ", ";\n  box-sizing: border-box;\n  min-width: 336px;\n  padding: ", ";\n  margin-top: 16px;\n  margin-left: -40px;\n  cursor: pointer;\n  transition: border-color 0.2s;\n  text-align: center;\n"]);

  _templateObject2$d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$m() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: 24px;\n"]);

  _templateObject$m = function _templateObject() {
    return data;
  };

  return data;
}

var Content$1 = styled.div(_templateObject$m());
var StyledCode = styled.div(_templateObject2$d(), COLORS.GRAY_COLORS.GRAY_96, function (props) {
  return props.copied ? COLORS.STATUS_COLORS.SUCCESS : "transparent";
}, function (props) {
  return props.condensedCode ? "13px" : "20px";
}, function (props) {
  return props.condensedCode ? "0.4px" : "8px";
}, function (props) {
  return props.condensedCode ? "12px 0" : "16px 8px";
});
var SecretKeyBlock = styled.div(_templateObject3$a(), FONTS.FONT_FAMILY.MONOSPACE, COLORS.TEXT_COLORS.EMPHASIZED, COLORS.WHITE);

var CopyCodeManually =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(CopyCodeManually, _Component);

  function CopyCodeManually(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.onCopy = function () {
      _this.setState({
        copied: true
      });

      _this.copiedTimeoutId = setTimeout(function () {
        _this.setState({
          copied: false
        });
      }, 1000);
    };

    _this.showCode = function () {
      if (_this.props.appName === "OneLogin Protect") {
        return _this.props.code;
      } else if (_this.props.appName === "Authenticator") {
        var keyBlocks = [];

        for (var i = 0; i < 32; i += 4) {
          keyBlocks.push(React.createElement(SecretKeyBlock, {
            key: i
          }, _this.props.code.slice(i, i + 4)));
        }

        return React.createElement("div", null, keyBlocks);
      }
    };

    _this.render = function () {
      return React.createElement(Content$1, {
        "data-testid": "copy-code-manually-screen"
      }, React.createElement(ContentBlock, null, React.createElement(Bullets, null, React.createElement(FormattedMessage, {
        id: "3374226769",
        defaultMessage: "Click Pair using manual entry"
      }), React.createElement("div", null, React.createElement(FormattedMessage, {
        id: "3855542277",
        defaultMessage: "Enter this code into the app"
      }), React.createElement(StyledCode, {
        copied: _this.state.copied,
        condensedCode: _this.props.condensedCode
      }, _this.showCode())))), _this.props.onScanBarCode && React.createElement(ContentBlock, {
        centered: true
      }, React.createElement(Button, {
        size: "large",
        onClick: _this.props.onScanBarCode
      }, React.createElement(FormattedMessage, {
        id: "2097632732",
        defaultMessage: "Scan barcode instead"
      }))), _this.props.onContinue && React.createElement(ContentBlock, null, React.createElement(Button, {
        size: "large",
        look: "primary",
        onClick: _this.props.onContinue,
        "data-testid": "activate-button"
      }, React.createElement(FormattedMessage, {
        id: "3673120330",
        defaultMessage: "Next"
      }))));
    };

    _this.state = {
      copied: undefined
    };
    return _this;
  }

  var _proto = CopyCodeManually.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.copiedTimeoutId);
  };

  return CopyCodeManually;
}(Component);

CopyCodeManually.displayName = "CopyCodeManually";
CopyCodeManually.propTypes = {
  appName: PropTypes.oneOf(["OneLogin Protect", "Authenticator"]).isRequired,
  onScanBarCode: PropTypes.func,
  code: PropTypes.string.isRequired,
  condensedCode: PropTypes.bool
};
CopyCodeManually.defaultProps = {
  condensedCode: false
};

var PairProtectOrAuthenticator =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(PairProtectOrAuthenticator, _Component);

  function PairProtectOrAuthenticator(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.toggleQR = function (event) {
      event.preventDefault();

      _this.setState({
        showScanBarCode: !_this.state.showScanBarCode
      });
    };

    _this.render = function () {
      var _this$props = _this.props,
          code = _this$props.code,
          qrLink = _this$props.qrLink,
          onContinue = _this$props.onContinue,
          appName = _this$props.appName,
          condensedCode = _this$props.condensedCode;
      return _this.state.showScanBarCode ? React.createElement(ScanBarCode, {
        appName: appName,
        code: qrLink,
        onCantScan: _this.toggleQR,
        onContinue: onContinue
      }) : React.createElement(CopyCodeManually, {
        appName: appName,
        code: code,
        condensedCode: condensedCode,
        onScanBarCode: _this.toggleQR,
        onContinue: onContinue
      });
    };

    _this.state = {
      showScanBarCode: true
    };
    return _this;
  }

  return PairProtectOrAuthenticator;
}(Component);

PairProtectOrAuthenticator.displayName = "PairProtectOrAuthenticator";
PairProtectOrAuthenticator.propTypes = {
  appName: PropTypes.string.isRequired,
  qrLink: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  condensedCode: PropTypes.bool
};
var AppleBadgeIcon = "data:image/svg+xml;base64,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";

function _templateObject3$b() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 20px;\n"]);

  _templateObject3$b = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$e() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 140px;\n"]);

  _templateObject2$e = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$n() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 160px;\n  margin: -10px;\n  height: 67px;\n"]);

  _templateObject$n = function _templateObject() {
    return data;
  };

  return data;
}

var messages = defineMessages({
  linkToGooglePlay: {
    "id": "linkToGooglePlay",
    defaultMessage: "Link to Google Play"
  },
  linkToAppStore: {
    "id": "linkToAppStore",
    defaultMessage: "Link to App Store"
  },
  getOnGooglePlay: {
    "id": "getOnGooglePlay",
    defaultMessage: "Get it on Google Play"
  },
  downloadOnAppStore: {
    "id": "downloadOnAppStore",
    defaultMessage: "Download on the app store"
  }
});
var ACTIVATE_ACTION_TEXT = "Activate";
var GoogleBadge = styled.img(_templateObject$n());
var AppleBadge = styled.img(_templateObject2$e());
var BadgeWrapper = styled.div(_templateObject3$b()); // https://play.google.com/intl/en_us/badges/
// google badge is not translated by intention

var GOOGLE_BADGE = function GOOGLE_BADGE(intl) {
  return React.createElement("a", {
    href: "https://play.google.com/store/apps/details?id=com.onelogin.protect",
    target: "_blank",
    alt: intl.formatMessage(messages.linkToGooglePlay),
    rel: "noopener noreferrer"
  }, React.createElement(GoogleBadge, {
    alt: intl.formatMessage(messages.getOnGooglePlay),
    src: "https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png"
  }));
}; // https://developer.apple.com/app-store/marketing/guidelines/#downloadOnAppstore
// apple bade is not translated by intention (see 1.2 Localized badges ^)


var APPLE_BADGE = function APPLE_BADGE(intl) {
  return React.createElement("a", {
    href: "https://itunes.apple.com/us/app/onelogin-protect/id509252983",
    target: "_blank",
    alt: intl.formatMessage(messages.linkToAppStore),
    rel: "noopener noreferrer"
  }, React.createElement(AppleBadge, {
    alt: intl.formatMessage(messages.downloadOnAppStore),
    src: AppleBadgeIcon
  }));
};

var OTHER_BADGE = function OTHER_BADGE(intl) {
  return React.createElement("div", null, React.createElement("a", {
    href: "https://itunes.apple.com/us/app/onelogin-protect/id509252983",
    target: "_blank",
    alt: intl.formatMessage(messages.linkToAppStore),
    rel: "noopener noreferrer"
  }, React.createElement(AppleBadge, {
    alt: intl.formatMessage(messages.downloadOnAppStore),
    src: AppleBadgeIcon
  })), React.createElement("a", {
    href: "https://play.google.com/store/apps/details?id=com.onelogin.protect",
    target: "_blank",
    alt: intl.formatMessage(messages.linkToGooglePlay),
    rel: "noopener noreferrer"
  }, React.createElement(GoogleBadge, {
    alt: intl.formatMessage(messages.getOnGooglePlay),
    src: "https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png"
  })));
};

var InstallProtect = function InstallProtect(_ref) {
  var bowser = _ref.bowser,
      onContinue = _ref.onContinue,
      onUseMagicLink = _ref.onUseMagicLink,
      intl = _ref.intl;

  var badge = function badge(bowser) {
    if (bowser.android) {
      return GOOGLE_BADGE(intl);
    } else if (bowser.ios) {
      return APPLE_BADGE(intl);
    } else {
      return OTHER_BADGE(intl);
    }
  };

  return React.createElement(Content, {
    "data-testid": "install-protect-screen"
  }, React.createElement(ContentBlock, null, React.createElement(Bullets, null, React.createElement("div", null, React.createElement(FormattedMessage, {
    id: "1536965459",
    defaultMessage: "Download and install OneLogin Protect on your device"
  }), React.createElement(BadgeWrapper, null, badge(bowser))), React.createElement("div", null, React.createElement(FormattedMessage, {
    id: "4227081527",
    defaultMessage: "When the app is installed, come back to this screen and click {action}",
    values: {
      action: React.createElement("b", null, React.createElement(FormattedMessage, {
        id: "3865193889",
        defaultMessage: ACTIVATE_ACTION_TEXT
      }))
    }
  }))), React.createElement(ContentBlock, null, React.createElement(Button, {
    size: "large",
    look: "primary",
    onClick: onContinue,
    "data-testid": "activate-button"
  }, React.createElement(FormattedMessage, {
    id: "3865193889",
    defaultMessage: ACTIVATE_ACTION_TEXT
  })), onUseMagicLink && React.createElement(Button, {
    size: "large",
    onClick: onUseMagicLink
  }, React.createElement(FormattedMessage, {
    id: "505702857",
    defaultMessage: "Magic Link"
  })))));
};

InstallProtect.propTypes = {
  bowser: PropTypes.object,
  onContinue: PropTypes.func,
  onUseMagicLink: PropTypes.func
};
var InstallProtect$1 = injectIntl(InstallProtect);

var LoginSecurityCode = function LoginSecurityCode(_ref) {
  var children = _ref.children,
      deviceName = _ref.deviceName,
      onSubmit = _ref.onSubmit;
  return React.createElement(SingleValueForm, {
    onSubmit: onSubmit,
    render: function render(_ref2) {
      var invalid = _ref2.invalid,
          value = _ref2.value,
          _onChange = _ref2.onChange;
      return React.createElement(Content, {
        "data-testid": "security-code-screen"
      }, React.createElement(ContentBlock, null, React.createElement(Label, {
        forId: "security-code"
      }, React.createElement(FormattedMessage, {
        id: "694278426",
        defaultMessage: "Enter your {deviceName} code",
        values: {
          deviceName: deviceName
        }
      })), React.createElement(PasswordInput, {
        "data-testid": "security-code",
        id: "security-code",
        onChange: function onChange(event) {
          return _onChange(event.target.value);
        },
        value: value,
        invalid: invalid,
        autoFocus: true,
        size: "large"
      })), React.createElement(ContentBlock, null, React.createElement(Button, {
        size: "large",
        type: "submit"
      }, React.createElement(FormattedMessage, {
        id: "3640052215",
        defaultMessage: "Continue"
      }))), children && React.createElement(ContentBlock, null, children));
    }
  });
};

LoginSecurityCode.displayName = "LoginSecurityCode";
LoginSecurityCode.propTypes = {
  deviceName: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired
};

function _templateObject$o() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: 0.2px;\n\n  pre {\n    white-space: normal;\n  }\n"]);

  _templateObject$o = function _templateObject() {
    return data;
  };

  return data;
}

var TextWrapper$1 = styled.div(_templateObject$o(), COLORS.TEXT_COLORS.DEFAULT);

var DescriptionText = function DescriptionText(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return React.createElement(TextWrapper$1, {
    className: className
  }, children);
};

var EnterYubiKey = function EnterYubiKey(_ref) {
  var onSubmit = _ref.onSubmit,
      onChangeClient = _ref.onChangeClient;
  return React.createElement(SingleValueForm, {
    onSubmit: onSubmit,
    render: function render(_ref2) {
      var invalid = _ref2.invalid,
          value = _ref2.value,
          _onChange = _ref2.onChange;
      return React.createElement(Content, {
        "data-testid": "enter-yubikey-screen"
      }, React.createElement(DescriptionText, null, React.createElement(FormattedMessage, {
        id: "2606375562",
        defaultMessage: "Insert your YubiKey in the USB port and press the button"
      })), React.createElement(ContentBlock, null, React.createElement(Input, {
        id: "security-code",
        value: value,
        onChange: function onChange(event) {
          return _onChange(event.target.value.toLowerCase());
        },
        autoFocus: true,
        invalid: invalid,
        size: "large",
        type: "password"
      })), React.createElement(ContentBlock, null, React.createElement(Button, {
        size: "large",
        type: "submit",
        look: "primary"
      }, React.createElement(FormattedMessage, {
        id: "3640052215",
        defaultMessage: "Continue"
      }))));
    }
  });
};

EnterYubiKey.displayName = "EnterYubiKey";
EnterYubiKey.propTypes = {
  onSubmit: PropTypes.func.isRequired
};
/* eslint-disable */
// this script was downloaded from https://api.duosecurity.com/frame/hosted/Duo-Web-v2.js
// and updated to be exported as ES module

/**
 * Duo Web SDK v2
 * Copyright 2017, Duo Security
 */

function Duo() {
  var DUO_MESSAGE_FORMAT = /^(?:AUTH|ENROLL)+\|[A-Za-z0-9\+\/=]+\|[A-Za-z0-9\+\/=]+$/;
  var DUO_ERROR_FORMAT = /^ERR\|[\w\s\.\(\)]+$/;
  var DUO_OPEN_WINDOW_FORMAT = /^DUO_OPEN_WINDOW\|/;
  var VALID_OPEN_WINDOW_DOMAINS = ["duo.com", "duosecurity.com", "duomobile.s3-us-west-1.amazonaws.com"];
  var iframeId = "duo_iframe",
      postAction = "",
      postArgument = "sig_response",
      host,
      duoSig,
      appSig,
      iframe,
      submitCallback;

  function throwError(message, url) {
    throw new Error("Duo Web SDK error: " + message + (url ? "\n" + "See " + url + " for more information" : ""));
  }

  function hyphenize(str) {
    return str.replace(/([a-z])([A-Z])/, "$1-$2").toLowerCase();
  } // cross-browser data attributes


  function getDataAttribute(element, name) {
    if ("dataset" in element) {
      return element.dataset[name];
    } else {
      return element.getAttribute("data-" + hyphenize(name));
    }
  } // cross-browser event binding/unbinding


  function on(context, event, fallbackEvent, callback) {
    if ("addEventListener" in window) {
      context.addEventListener(event, callback, false);
    } else {
      context.attachEvent(fallbackEvent, callback);
    }
  }

  function off(context, event, fallbackEvent, callback) {
    if ("removeEventListener" in window) {
      context.removeEventListener(event, callback, false);
    } else {
      context.detachEvent(fallbackEvent, callback);
    }
  }

  function onReady(callback) {
    on(document, "DOMContentLoaded", "onreadystatechange", callback);
  }

  function offReady(callback) {
    off(document, "DOMContentLoaded", "onreadystatechange", callback);
  }

  function onMessage(callback) {
    on(window, "message", "onmessage", callback);
  }

  function offMessage(callback) {
    off(window, "message", "onmessage", callback);
  }
  /**
   * Parse the sig_request parameter, throwing errors if the token contains
   * a server error or if the token is invalid.
   *
   * @param {String} sig Request token
   */


  function parseSigRequest(sig) {
    if (!sig) {
      // nothing to do
      return;
    } // see if the token contains an error, throwing it if it does


    if (sig.indexOf("ERR|") === 0) {
      throwError(sig.split("|")[1]);
    } // validate the token


    if (sig.indexOf(":") === -1 || sig.split(":").length !== 2) {
      throwError("Duo was given a bad token.  This might indicate a configuration " + "problem with one of Duo's client libraries.", "https://www.duosecurity.com/docs/duoweb#first-steps");
    }

    var sigParts = sig.split(":"); // hang on to the token, and the parsed duo and app sigs

    duoSig = sigParts[0];
    appSig = sigParts[1];
    return {
      sigRequest: sig,
      duoSig: sigParts[0],
      appSig: sigParts[1]
    };
  }
  /**
   * This function is set up to run when the DOM is ready, if the iframe was
   * not available during `init`.
   */


  function onDOMReady() {
    iframe = document.getElementById(iframeId);

    if (!iframe) {
      throw new Error("This page does not contain an iframe for Duo to use." + 'Add an element like <iframe id="duo_iframe"></iframe> ' + "to this page.  " + "See https://www.duosecurity.com/docs/duoweb#3.-show-the-iframe " + "for more information.");
    } // we've got an iframe, away we go!


    ready(); // always clean up after yourself

    offReady(onDOMReady);
  }
  /**
   * Validate that a MessageEvent came from the Duo service, and that it
   * is a properly formatted payload.
   *
   * The Google Chrome sign-in page injects some JS into pages that also
   * make use of postMessage, so we need to do additional validation above
   * and beyond the origin.
   *
   * @param {MessageEvent} event Message received via postMessage
   */


  function isDuoMessage(event) {
    return Boolean(event.origin === "https://" + host && typeof event.data === "string" && (event.data.match(DUO_MESSAGE_FORMAT) || event.data.match(DUO_ERROR_FORMAT) || event.data.match(DUO_OPEN_WINDOW_FORMAT)));
  }
  /**
   * Validate the request token and prepare for the iframe to become ready.
   *
   * All options below can be passed into an options hash to `Duo.init`, or
   * specified on the iframe using `data-` attributes.
   *
   * Options specified using the options hash will take precedence over
   * `data-` attributes.
   *
   * Example using options hash:
   * ```javascript
   * Duo.init({
   *     iframe: "some_other_id",
   *     host: "api-main.duo.test",
   *     sig_request: "...",
   *     post_action: "/auth",
   *     post_argument: "resp"
   * });
   * ```
   *
   * Example using `data-` attributes:
   * ```
   * <iframe id="duo_iframe"
   *         data-host="api-main.duo.test"
   *         data-sig-request="..."
   *         data-post-action="/auth"
   *         data-post-argument="resp"
   *         >
   * </iframe>
   * ```
   *
   * @param {Object} options
   * @param {String} options.iframe                         The iframe, or id of an iframe to set up
   * @param {String} options.host                           Hostname
   * @param {String} options.sig_request                    Request token
   * @param {String} [options.post_action='']               URL to POST back to after successful auth
   * @param {String} [options.post_argument='sig_response'] Parameter name to use for response token
   * @param {Function} [options.submit_callback]            If provided, duo will not submit the form instead execute
   *                                                        the callback function with reference to the "duo_form" form object
   *                                                        submit_callback can be used to prevent the webpage from reloading.
   */


  function init(options) {
    if (options) {
      if (options.host) {
        host = options.host;
      }

      if (options.sig_request) {
        parseSigRequest(options.sig_request);
      }

      if (options.post_action) {
        postAction = options.post_action;
      }

      if (options.post_argument) {
        postArgument = options.post_argument;
      }

      if (options.iframe) {
        if (options.iframe.tagName) {
          iframe = options.iframe;
        } else if (typeof options.iframe === "string") {
          iframeId = options.iframe;
        }
      }

      if (typeof options.submit_callback === "function") {
        submitCallback = options.submit_callback;
      }
    } // if we were given an iframe, no need to wait for the rest of the DOM


    if (iframe) {
      ready();
    } else {
      // try to find the iframe in the DOM
      iframe = document.getElementById(iframeId); // iframe is in the DOM, away we go!

      if (iframe) {
        ready();
      } else {
        // wait until the DOM is ready, then try again
        onReady(onDOMReady);
      }
    } // always clean up after yourself!


    offReady(init);
  }
  /**
   * This function is called when a message was received from another domain
   * using the `postMessage` API.  Check that the event came from the Duo
   * service domain, and that the message is a properly formatted payload,
   * then perform the post back to the primary service.
   *
   * @param event Event object (contains origin and data)
   */


  function onReceivedMessage(event) {
    if (isDuoMessage(event)) {
      if (event.data.match(DUO_OPEN_WINDOW_FORMAT)) {
        var url = event.data.substring("DUO_OPEN_WINDOW|".length);

        if (isValidUrlToOpen(url)) {
          // Open the URL that comes after the DUO_WINDOW_OPEN token.
          window.open(url, "_self");
        }
      } else {
        // the event came from duo, do the post back
        doPostBack(event.data); // always clean up after yourself!

        offMessage(onReceivedMessage);
      }
    }
  }
  /**
   * Validate that this passed in URL is one that we will actually allow to
   * be opened.
   * @param url String URL that the message poster wants to open
   * @returns {boolean} true if we allow this url to be opened in the window
   */


  function isValidUrlToOpen(url) {
    if (!url) {
      return false;
    }

    var parser = document.createElement("a");
    parser.href = url;

    if (parser.protocol === "duotrustedendpoints:") {
      return true;
    } else if (parser.protocol !== "https:") {
      return false;
    }

    for (var i = 0; i < VALID_OPEN_WINDOW_DOMAINS.length; i++) {
      if (parser.hostname.endsWith("." + VALID_OPEN_WINDOW_DOMAINS[i]) || parser.hostname === VALID_OPEN_WINDOW_DOMAINS[i]) {
        return true;
      }
    }

    return false;
  }
  /**
   * Point the iframe at Duo, then wait for it to postMessage back to us.
   */


  function ready() {
    if (!host) {
      host = getDataAttribute(iframe, "host");

      if (!host) {
        throwError("No API hostname is given for Duo to use.  Be sure to pass " + "a `host` parameter to Duo.init, or through the `data-host` " + "attribute on the iframe element.", "https://www.duosecurity.com/docs/duoweb#3.-show-the-iframe");
      }
    }

    if (!duoSig || !appSig) {
      parseSigRequest(getDataAttribute(iframe, "sigRequest"));

      if (!duoSig || !appSig) {
        throwError("No valid signed request is given.  Be sure to give the " + "`sig_request` parameter to Duo.init, or use the " + "`data-sig-request` attribute on the iframe element.", "https://www.duosecurity.com/docs/duoweb#3.-show-the-iframe");
      }
    } // if postAction/Argument are defaults, see if they are specified
    // as data attributes on the iframe


    if (postAction === "") {
      postAction = getDataAttribute(iframe, "postAction") || postAction;
    }

    if (postArgument === "sig_response") {
      postArgument = getDataAttribute(iframe, "postArgument") || postArgument;
    } // point the iframe at Duo


    iframe.src = ["https://", host, "/frame/web/v1/auth?tx=", duoSig, "&parent=", encodeURIComponent(document.location.href), "&v=2.6"].join(""); // listen for the 'message' event

    onMessage(onReceivedMessage);
  }
  /**
   * We received a postMessage from Duo.  POST back to the primary service
   * with the response token, and any additional user-supplied parameters
   * given in form#duo_form.
   */


  function doPostBack(response) {
    // create a hidden input to contain the response token
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = postArgument;
    input.value = response + ":" + appSig; // user may supply their own form with additional inputs

    var form = document.getElementById("duo_form"); // if the form doesn't exist, create one

    if (!form) {
      form = document.createElement("form"); // insert the new form after the iframe

      iframe.parentElement.insertBefore(form, iframe.nextSibling);
    } // make sure we are actually posting to the right place


    form.method = "POST";
    form.action = postAction; // add the response token input to the form

    form.appendChild(input); // away we go!

    if (typeof submitCallback === "function") {
      submitCallback.call(null, form);
    } else {
      form.submit();
    }
  }

  return {
    init: init,
    _onReady: onReady,
    _parseSigRequest: parseSigRequest,
    _isDuoMessage: isDuoMessage,
    _doPostBack: doPostBack
  };
}

function _templateObject$p() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 400px;\n  width: 100%;\n  border: 0;\n  display: block;\n  padding: 8px;\n  box-sizing: border-box;\n"]);

  _templateObject$p = function _templateObject() {
    return data;
  };

  return data;
}

var StyledIFrame = styled.iframe(_templateObject$p());

var DuoFrame =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DuoFrame, _React$Component);

  function DuoFrame() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.componentDidMount = function () {
      var _this$props = _this.props,
          host = _this$props.host,
          sigRequest = _this$props.sigRequest;
      Duo().init({
        host: host,
        sig_request: sigRequest,
        submit_callback: _this.handleDuoResponse
      });
    };

    _this.handleDuoResponse = function (duoForm) {
      var callback = _this.props.callback; // read signedResponse from Duo form

      var sigResponse = duoForm.firstChild.value;
      return callback(sigResponse);
    };

    _this.render = function () {
      return React.createElement(StyledIFrame, {
        id: "duo_iframe",
        title: "Duo 2FA"
      });
    };

    return _this;
  }

  return DuoFrame;
}(React.Component);

DuoFrame.displayName = "DuoFrame";
DuoFrame.propTypes = {
  host: PropTypes.string.isRequired,
  sigRequest: PropTypes.string.isRequired,
  callback: PropTypes.func
};
DuoFrame.defaultProps = {
  callback: function callback() {}
};

var MultiValueForm =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(MultiValueForm, _Component);

  function MultiValueForm(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.getOnChange = function (fieldName) {
      return function (value) {
        var _this$setState;

        _this.setState((_this$setState = {}, _this$setState[fieldName] = {
          value: value,
          invalid: false
        }, _this$setState));
      };
    };

    _this.isValid = function (fieldName) {
      return _this.state[fieldName].value.length >= 1;
    };

    _this.onSubmit = function (event) {
      event.preventDefault();
      var invalidFieldNames = filter(complement(_this.isValid), _this.props.fieldNames);

      if (isEmpty(invalidFieldNames)) {
        // all forms input have valid value
        var fieldToValueMap = reduce(function (acc, fieldName) {
          acc[fieldName] = _this.state[fieldName].value;
          return acc;
        }, {}, _this.props.fieldNames);

        _this.props.onSubmit(fieldToValueMap);
      } else {
        _this.setState(reduce(function (acc, fieldName) {
          acc[fieldName] = _objectSpread({}, _this.state[fieldName], {
            invalid: true
          });
          return acc;
        }, {}, invalidFieldNames));
      }
    };

    _this.render = function () {
      return React.createElement("form", {
        onSubmit: _this.onSubmit
      }, _this.props.render(_objectSpread({}, mapObjIndexed(function (value, key) {
        return _objectSpread({}, value, {
          onChange: _this.getOnChange(key)
        });
      }, _this.state))));
    };

    _this.state = reduce(function (acc, fieldName) {
      acc[fieldName] = {
        value: "",
        invalid: false
      };
      return acc;
    }, {}, props.fieldNames);
    return _this;
  }

  return MultiValueForm;
}(Component);

MultiValueForm.displayName = "MultiValueForm";
MultiValueForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  fieldNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  render: PropTypes.func.isRequired
};
var CREDENTIAL_ID_TEXT = "Credential ID";

var RegisterVipAccess = function RegisterVipAccess(_ref) {
  var onSubmit = _ref.onSubmit;
  return React.createElement(MultiValueForm, {
    fieldNames: ["credentialId", "otp1", "otp2"],
    onSubmit: onSubmit,
    render: function render(_ref2) {
      var credentialId = _ref2.credentialId,
          otp1 = _ref2.otp1,
          otp2 = _ref2.otp2;
      return React.createElement(Content, {
        "data-testid": "register-vip-screen"
      }, React.createElement(ContentBlock, null, React.createElement(FormattedMessage, {
        id: "2104438124",
        defaultMessage: "Enter {fieldName} and two consecutive Security Codes from Symantec VIP Access.",
        values: {
          fieldName: CREDENTIAL_ID_TEXT
        }
      })), React.createElement(ContentBlock, null, React.createElement(Label, {
        forId: "credentialId"
      }, CREDENTIAL_ID_TEXT), React.createElement(Input, {
        id: "credentialId",
        value: credentialId.value,
        onChange: function onChange(event) {
          return credentialId.onChange(event.target.value);
        },
        invalid: credentialId.invalid,
        size: "large"
      })), React.createElement(ContentBlock, null, React.createElement(Label, {
        forId: "otp1"
      }, React.createElement(FormattedMessage, {
        id: "694920552",
        defaultMessage: "First Security Code"
      })), React.createElement(Input, {
        id: "otp1",
        value: otp1.value,
        onChange: function onChange(event) {
          return otp1.onChange(event.target.value);
        },
        invalid: otp1.invalid,
        size: "large"
      })), React.createElement(ContentBlock, null, React.createElement(Label, {
        forId: "otp2"
      }, React.createElement(FormattedMessage, {
        id: "2942752129",
        defaultMessage: "Second Security Code"
      })), React.createElement(Input, {
        id: "otp2",
        value: otp2.value,
        onChange: function onChange(event) {
          return otp2.onChange(event.target.value);
        },
        invalid: otp2.invalid,
        size: "large"
      })), React.createElement(ContentBlock, null, React.createElement(Button, {
        size: "large",
        type: "submit",
        look: "primary",
        "data-testid": "continue-button"
      }, React.createElement(FormattedMessage, {
        id: "3640052215",
        defaultMessage: "Continue"
      }))));
    }
  });
};

RegisterVipAccess.displayName = "RegisterVipAccess";
RegisterVipAccess.propTypes = {
  onSubmit: PropTypes.func.isRequired
};

var RegisterSecureId = function RegisterSecureId(_ref) {
  var onSubmit = _ref.onSubmit;
  return React.createElement(MultiValueForm, {
    fieldNames: ["username", "securityCode"],
    onSubmit: onSubmit,
    render: function render(_ref2) {
      var username = _ref2.username,
          securityCode = _ref2.securityCode;
      return React.createElement(Content, {
        "data-testid": "register-secure-id-screen"
      }, React.createElement(ContentBlock, null, React.createElement("div", null, React.createElement(FormattedMessage, {
        id: "2124363772",
        defaultMessage: "Enter your username and security code from your SecurID token."
      }))), React.createElement(ContentBlock, null, React.createElement(Label, {
        forId: "username"
      }, React.createElement(FormattedMessage, {
        id: "2663586870",
        defaultMessage: "Username"
      })), React.createElement(Input, {
        id: "username",
        value: username.value,
        onChange: function onChange(event) {
          return username.onChange(event.target.value);
        },
        invalid: username.invalid,
        size: "large"
      })), React.createElement(ContentBlock, null, React.createElement(Label, {
        forId: "security-code"
      }, React.createElement(FormattedMessage, {
        id: "1654624862",
        defaultMessage: "Security Code"
      })), React.createElement(PasswordInput, {
        "data-testid": "security-code",
        id: "security-code",
        onChange: function onChange(event) {
          return securityCode.onChange(event.target.value);
        },
        value: securityCode.value,
        invalid: securityCode.invalid,
        size: "large"
      })), React.createElement(ContentBlock, null, React.createElement(Button, {
        size: "large",
        type: "submit",
        look: "primary"
      }, React.createElement(FormattedMessage, {
        id: "3640052215",
        defaultMessage: "Continue"
      }))));
    }
  });
};

RegisterSecureId.displayName = "RegisterSecureId";
RegisterSecureId.propTypes = {
  onSubmit: PropTypes.func.isRequired
};

var LoginProvideAnswer = function LoginProvideAnswer(_ref) {
  var question = _ref.question,
      onSubmit = _ref.onSubmit;
  return React.createElement(SingleValueForm, {
    onSubmit: onSubmit,
    render: function render(_ref2) {
      var invalid = _ref2.invalid,
          value = _ref2.value,
          _onChange = _ref2.onChange;
      return React.createElement(Content, {
        "data-testid": "provide-answer-screen"
      }, React.createElement(ContentBlock, null, React.createElement(Label, {
        forId: "secure-answer"
      }, question), React.createElement(PasswordInput, {
        id: "secure-answer",
        value: value,
        onChange: function onChange(event) {
          return _onChange(event.target.value);
        },
        autoFocus: true,
        invalid: invalid,
        size: "large"
      })), React.createElement(ContentBlock, null, React.createElement(Button, {
        size: "large",
        type: "submit",
        look: "primary"
      }, React.createElement(FormattedMessage, {
        id: "3640052215",
        defaultMessage: "Continue"
      }))));
    }
  });
};

LoginProvideAnswer.displayName = "LoginProvideAnswer";
LoginProvideAnswer.propTypes = {
  question: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired
};

function _templateObject$q() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  height: 400px;\n"]);

  _templateObject$q = function _templateObject() {
    return data;
  };

  return data;
}

var ScrollableContent = styled.div(_templateObject$q());
ScrollableContent.displayName = "ScrollableContent";

var SelectQuestion = function SelectQuestion(_ref) {
  var onSelect = _ref.onSelect,
      questions = _ref.questions;
  return React.createElement(ScrollableContent, {
    "data-testid": "select-question-screen"
  }, keys(questions).map(function (key) {
    return React.createElement(ListItem$1, {
      key: key,
      text: questions[key],
      onClick: function onClick() {
        return onSelect(key);
      }
    });
  }));
};

SelectQuestion.displayName = "SelectQuestion";
SelectQuestion.propTypes = {
  questions: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired
};

function _templateObject$r() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 22px;\n  padding: 16px 24px;\n  color: ", ";\n  border-bottom: 1px solid ", ";\n"]);

  _templateObject$r = function _templateObject() {
    return data;
  };

  return data;
}

var SubTitle = styled.div(_templateObject$r(), COLORS.TEXT_COLORS.TITLE, COLORS.SEPARATOR_COLORS.MEDIUM);

var AnswerSecurityQuestions =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(AnswerSecurityQuestions, _Component);

  function AnswerSecurityQuestions(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.onSelectQuestion = function (id) {
      _this.setState({
        current: id,
        remaining: _this.state.remaining.filter(function (current) {
          return current !== id;
        }),
        showSelector: false
      });
    };

    _this.getSubmitAnswer = function (questionId) {
      return function (answer) {
        _this.answers[questionId] = answer;

        if (keys(_this.answers).length === _this.props.requiredAnwersCount || isEmpty(_this.state.remaining)) {
          _this.props.onComplete(_this.answers);
        } else {
          if (_this.letUserPickAnswers) {
            _this.setState({
              showSelector: true
            });
          } else {
            var _this$state$remaining = _this.state.remaining,
                current = _this$state$remaining[0],
                remaining = _this$state$remaining.slice(1);

            _this.setState({
              current: current,
              remaining: remaining
            });
          }
        }
      };
    };

    _this.render = function () {
      var _this$state = _this.state,
          current = _this$state.current,
          questions = _this$state.questions,
          remaining = _this$state.remaining,
          showSelector = _this$state.showSelector;
      var totalQuestions = keys(questions);

      if (showSelector) {
        return React.createElement("div", null, React.createElement(SubTitle, null, React.createElement(FormattedMessage, {
          id: "4151518079",
          defaultMessage: "Select Security Question {current} / {total}",
          values: {
            current: totalQuestions.length - remaining.length + 1,
            total: _this.props.requiredAnwersCount || totalQuestions.length
          }
        })), React.createElement(SelectQuestion, {
          questions: pickBy(function (val, id) {
            return remaining.includes(id);
          }, questions),
          onSelect: _this.onSelectQuestion
        }));
      } else {
        return (// key is used here in quite hacky way (it ensures that the same LoginProvideAnswer is not reused)
          React.createElement(LoginProvideAnswer, {
            key: current,
            question: questions[current],
            onSubmit: _this.getSubmitAnswer(current)
          })
        );
      }
    };

    _this.letUserPickAnswers = !isNil(props.requiredAnwersCount) && props.requiredAnwersCount < keys(props.questions).length;

    if (_this.letUserPickAnswers) {
      _this.state = {
        showSelector: true,
        remaining: keys(props.questions),
        questions: props.questions
      };
    } else {
      var _keys = keys(props.questions),
          current = _keys[0],
          remaining = _keys.slice(1);

      _this.state = {
        current: current,
        remaining: remaining,
        questions: props.questions
      };
    }

    _this.answers = {};
    return _this;
  }

  return AnswerSecurityQuestions;
}(Component);

AnswerSecurityQuestions.propTypes = {
  questions: PropTypes.object.isRequired,
  requiredAnwersCount: PropTypes.number,
  onComplete: PropTypes.func.isRequired
};
var callingGif = "data:image/gif;base64,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";

function _templateObject$s() {
  var data = _taggedTemplateLiteralLoose(["\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n"]);

  _templateObject$s = function _templateObject() {
    return data;
  };

  return data;
}

var fadeIn = keyframes(_templateObject$s());

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 140px;\n  height: 24px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$1() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-bottom: 16px;\n"]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$2() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 12px;\n  text-align: center;\n  margin-top: 12px;\n  line-height: 16px;\n"]);

  _templateObject7$2 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$6() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n"]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$c() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-top: 16px;\n  padding-bottom: 16px;\n"]);

  _templateObject3$c = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$f() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border-width: 1px;\n  border-color: ", ";\n  font-size: 28px;\n  line-height: 1;\n  letter-spacing: 8px;\n  transition: border-color 0.2s;\n  height: 60px;\n  margin-top: 8px;\n"]);

  _templateObject2$f = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$t() {
  var data = _taggedTemplateLiteralLoose(["\n  animation: ", " 0.3s ease-in-out;\n"]);

  _templateObject$t = function _templateObject() {
    return data;
  };

  return data;
}

var messages$1 = defineMessages({
  calling: {
    "id": "calling",
    defaultMessage: "Calling"
  }
});
var FadeInButton = styled(Button)(_templateObject$t(), fadeIn);
var StyledBlock = styled.div(_templateObject2$f(), COLORS.GRAY_COLORS.GRAY_96, function (props) {
  return props.copied ? COLORS.STATUS_COLORS.SUCCESS : "transparent";
});
var StyledCode$1 = styled.div(_templateObject3$c());
var PhoneNumber = styled(StyledTextField)(_templateObject4$6());
var Centered = styled.div(_templateObject5$3());
var CenteredFlex = styled(Centered)(_templateObject6$2());
var CenteredSmallTextField = styled(StyledTextField)(_templateObject7$2());
var EmptyCenteredSmallTextField = styled(CenteredSmallTextField)(_templateObject8$1());
var CallingGif = styled.img(_templateObject9());
var GifButton = styled.div(_templateObject10());
var DEFAULT_SECONDS = 30;

var getInitialState = function getInitialState() {
  return {
    secLeft: DEFAULT_SECONDS
  };
};

var ShowPinCode =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(ShowPinCode, _Component);

  function ShowPinCode(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.componentDidMount = function () {
      _this.timer = setInterval(_this.countdown, 1000);
    };

    _this.componentWillUnmount = function () {
      clearInterval(_this.timer);
    };

    _this.countdown = function () {
      var seconds = _this.state.secLeft;

      if (seconds === 0) {
        clearInterval(_this.timer);
      } else {
        _this.setState({
          secLeft: seconds - 1
        });
      }
    };

    _this.resetTimer = function () {
      _this.setState({
        secLeft: DEFAULT_SECONDS
      });
    };

    _this.renderButton = function () {
      if (_this.state.secLeft === 0) {
        return React.createElement(FadeInButton, {
          "data-testid": "try-again-button",
          size: "large",
          look: "regular",
          onClick: function onClick() {
            _this.props.onTryAgain();

            _this.resetTimer();
          }
        }, React.createElement(FormattedMessage, {
          id: "2018264248",
          defaultMessage: "Try Again"
        }));
      } else {
        return React.createElement(GifButton, null, React.createElement(CallingGif, {
          alt: _this.props.intl.formatMessage(messages$1.calling),
          src: callingGif
        }), React.createElement(Button, {
          "data-testid": "calling-button",
          size: "large",
          look: "regular",
          disabled: true
        }));
      }
    };

    _this.renderRemainingSecs = function () {
      if (_this.state.secLeft > 0) {
        return React.createElement(CenteredSmallTextField, null, React.createElement(FormattedMessage, {
          id: "374233718",
          defaultMessage: "You can try again in {secLeft, number} {secLeft, plural,\n                        one {second}\n                        other {seconds}\n                      }",
          values: {
            secLeft: _this.state.secLeft
          }
        }));
      } else {
        return React.createElement(EmptyCenteredSmallTextField, null);
      }
    };

    _this.render = function () {
      return React.createElement(Content, {
        "data-testid": "show-pincode-screen"
      }, React.createElement(ContentBlock, null, React.createElement(FormattedMessage, {
        id: "4000449233",
        defaultMessage: "Calling the below phone number:"
      }), React.createElement(PhoneNumber, {
        large: true
      }, " ", _this.props.phoneNumber)), React.createElement(ContentBlock, null, React.createElement(FormattedMessage, {
        id: "3645116517",
        defaultMessage: "Enter this code when receiving the call:"
      }), React.createElement(CenteredFlex, null, React.createElement(StyledBlock, null, React.createElement(StyledCode$1, null, _this.props.verificationToken)))), React.createElement(ContentBlock, null, _this.renderButton(), _this.renderRemainingSecs()));
    };

    _this.state = getInitialState();
    return _this;
  }

  return ShowPinCode;
}(Component);

ShowPinCode.displayName = "ShowPinCode";
ShowPinCode.propTypes = {
  onTryAgain: PropTypes.func.isRequired,
  verificationToken: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string.isRequired
};
var ShowPinCode$1 = injectIntl(ShowPinCode);

function _templateObject$u() {
  var data = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"]);

  _templateObject$u = function _templateObject() {
    return data;
  };

  return data;
}

var HorizontalCenter = styled(DescriptionText)(_templateObject$u());

var CancelAuthentication = function CancelAuthentication(_ref) {
  var onRetry = _ref.onRetry;
  return React.createElement(Content, {
    "data-testid": "cancelled-webauthn-screen"
  }, React.createElement(ContentBlock, null, React.createElement(HorizontalCenter, null, React.createElement(FormattedMessage, {
    id: "1136625613",
    defaultMessage: "The process was cancelled. Please try again or use another authentication factor."
  })), React.createElement(ContentBlock, null, React.createElement(Button, {
    size: "large",
    look: "regular",
    onClick: onRetry
  }, React.createElement(FormattedMessage, {
    id: "2018264248",
    defaultMessage: "Try Again"
  })))));
};

CancelAuthentication.displayName = "CancelAuthentication";
CancelAuthentication.propTypes = {
  onSubmit: PropTypes.func.isRequired
};

function _templateObject2$g() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-right: 15px;\n"]);

  _templateObject2$g = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$v() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n"]);

  _templateObject$v = function _templateObject() {
    return data;
  };

  return data;
}

var ICON_IMAGE_SIZE$1 = "32px";
var TextWrapper$2 = styled.div(_templateObject$v());
var IconPadding = styled.div(_templateObject2$g());

function UnsupportedBrowser() {
  return React.createElement(Content, {
    "data-testid": "unsupported-webauthn-screen"
  }, React.createElement(ContentBlock, null, React.createElement(TextWrapper$2, null, React.createElement(IconPadding, null, React.createElement(Icon, {
    icon: "Warning-24",
    size: ICON_IMAGE_SIZE$1
  })), React.createElement(FormattedMessage, {
    id: "3781468762",
    defaultMessage: "Your browser doesn't support WebAuthn"
  }))));
}

function _templateObject$w() {
  var data = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"]);

  _templateObject$w = function _templateObject() {
    return data;
  };

  return data;
}

var HorizontalCenter$1 = styled(DescriptionText)(_templateObject$w());

var WebAuthn =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(WebAuthn, _Component);

  function WebAuthn() {
    var _this;

    _this = _Component.call(this) || this;

    _this.callAuthenticateUser = function () {
      _this.props.authenticateUser().catch(function () {
        _this.setState({
          error: true
        });
      });
    };

    _this.handleRetry = function () {
      _this.setState({
        error: false
      }, _this.callAuthenticateUser);
    };

    _this.state = {
      error: false
    };
    return _this;
  }

  var _proto = WebAuthn.prototype;

  _proto.browserSupported = function browserSupported() {
    return navigator.credentials && navigator.credentials.create;
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.browserSupported()) {
      this.callAuthenticateUser();
    }
  };

  _proto.render = function render() {
    if (!this.browserSupported()) {
      return React.createElement(UnsupportedBrowser, null);
    } else if (this.props.loading) {
      return React.createElement(LoginLoading, null);
    } else if (this.state.error) {
      return React.createElement(CancelAuthentication, {
        onRetry: this.handleRetry
      });
    }

    return React.createElement(Content, {
      "data-testid": "webauthn-screen"
    }, React.createElement(ContentBlock, null, React.createElement(HorizontalCenter$1, null, React.createElement(FormattedMessage, {
      id: "437305782",
      defaultMessage: "Verifying your WebAuthn authenticators now."
    }))));
  };

  return WebAuthn;
}(Component);

var BREAKPOINTS = {
  SMALL_MODAL_SIZE: "376px",
  PHONE_LARGE: "480px",
  PORTAL_MIDDLE: "652px",
  MID_VIEW_LIMIT: "856px",
  WIDE_VIEW_LIMIT: "1060px"
};

function _templateObject2$h() {
  var data = _taggedTemplateLiteralLoose(["\n      border-radius: 0;\n      width: 100%;\n    "]);

  _templateObject2$h = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$x() {
  var data = _taggedTemplateLiteralLoose(["\n  align-self: center;\n  visibility: hidden;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 0 0 3px 3px;\n  color: #ffffff;\n  text-align: center;\n\n  padding: 16px;\n  position: absolute;\n  font-size: 16px;\n  min-height: 50px;\n  line-height: 1;\n\n  box-sizing: border-box;\n  z-index: 1;\n  transition: top 0.5s;\n\n  background-color: ", ";\n  border-color: ", ";\n  visibility: ", ";\n  top: ", ";\n\n  @media screen and (max-width: ", ") {\n    top: ", ";\n  }\n\n  ", ";\n"]);

  _templateObject$x = function _templateObject() {
    return data;
  };

  return data;
}

var typeToColor = function typeToColor(type) {
  switch (type) {
    case "success":
      return COLORS.STATUS_COLORS.SUCCESS;

    case "error":
      return COLORS.STATUS_COLORS.ERROR;

    default:
      return COLORS.STATUS_COLORS.INFO;
  }
}; // "invisible" => top=0, visibility=hidden
// "hiding" => top=0;  visibility=visible
// "showing" => top=offset, visibility=visible


var computeTop = function computeTop(status, offset) {
  var top = status === "showing" ? offset : 0;
  return top + "px";
};

var Notification = styled.div(_templateObject$x(), function (props) {
  return typeToColor(props.type);
}, function (props) {
  return typeToColor(props.type);
}, function (props) {
  return props.status === "invisible" ? "hidden" : "visible";
}, function (props) {
  return computeTop(props.status, props.offsets.desktop);
}, BREAKPOINTS.PORTAL_MIDDLE, function (props) {
  return computeTop(props.status, props.offsets.mobile);
}, function (props) {
  return props.fluid && css(_templateObject2$h());
});
Notification.defaultProps = {
  type: "info",
  status: "invisible",
  fluid: true
};
Notification.propTypes = {
  offsets: PropTypes.shape({
    mobile: PropTypes.number.isRequired,
    desktop: PropTypes.number.isRequired
  }).isRequired,
  status: PropTypes.oneOf(["invisible", "showing", "hiding"]),
  type: PropTypes.oneOf(["error", "success", "info"]),
  fluid: PropTypes.bool
};
var CSS_HIDE_ANIMATION_TIME = 600; // this must be equal or higher then transition time of hidding animation

var DEFAULT_DISMISS_DELAY = 2000;

var Notifications =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Notifications, _Component);

  function Notifications(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      notification: null,
      status: "invisible"
    };
    return _this;
  }

  var _proto = Notifications.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.showNext(this.props);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.showingTimeout);
    clearTimeout(this.hiddingTimeout);
    clearTimeout(this.removeTimeout);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    if (newProps.notifications.length) {
      this.showNext(newProps);
    }
  };

  _proto.showNext = function showNext(props) {
    var _this2 = this;

    var notification = props.notifications && props.notifications.length ? props.notifications[0] : null;

    if (!this.state.notification && notification) {
      this.setState({
        notification: notification,
        status: "invisible"
      });
      this.showingTimeout = setTimeout(function () {
        _this2.setState({
          status: "showing"
        });
      }, 0);
      this.planHide(notification);
      props.clearDisplayedNotification(notification.id);
    }
  };

  _proto.planHide = function planHide(notification) {
    var _this3 = this;

    this.hiddingTimeout = setTimeout(function () {
      _this3.setState({
        status: "hiding"
      });

      _this3.removeTimeout = setTimeout(function () {
        _this3.setState({
          notification: null
        });

        _this3.showNext(_this3.props);
      }, CSS_HIDE_ANIMATION_TIME);
    }, notification.dismissDelay || DEFAULT_DISMISS_DELAY);
  };

  _proto.render = function render() {
    var _this$state = this.state,
        notification = _this$state.notification,
        status = _this$state.status;
    return notification && React.createElement(Notification, {
      type: notification.type,
      status: status,
      offsets: this.props.offsets,
      fluid: true,
      "data-testid": "notification-item"
    }, notification.message);
  };

  return Notifications;
}(Component);

Notifications.defaultProps = {
  offsets: {
    mobile: 0,
    desktop: 0
  }
};
Notifications.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.shape({
    message: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["error", "success", "info"])
  })),
  clearDisplayedNotification: PropTypes.func.isRequired,
  offsets: PropTypes.shape({
    mobile: PropTypes.number.isRequired,
    desktop: PropTypes.number.isRequired
  }).isRequired
};

function _templateObject$y() {
  var data = _taggedTemplateLiteralLoose(["\n  top: 0em;\n  left: 0em;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  background-color: rgba(45, 45, 45, 0.85);\n  line-height: 1;\n  animation-fill-mode: both;\n  animation-duration: 0.5s;\n  transition: background-color 0.5s linear;\n  user-select: none;\n  z-index: 1000;\n\n  opacity: 1;\n\n  position: fixed;\n  transform-style: \"\";\n  perspective: 2000px;\n  transform-origin: center center;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject$y = function _templateObject() {
    return data;
  };

  return data;
}

var ModalDimmer = styled.div(_templateObject$y());

var Dimmer =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Dimmer, _Component);

  function Dimmer(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.onClickHandler = function (event) {
      if (_this.dimmerRef && _this.dimmerRef.current.contains(event.target)) {
        _this.props.onClick && _this.props.onClick(event);
      }
    };

    _this.render = function () {
      var _this$props = _this.props,
          dataTestId = _this$props["data-testid"],
          children = _this$props.children;
      return React.createElement(ModalDimmer, {
        ref: _this.dimmerRef,
        "data-testid": dataTestId
      }, children);
    };

    _this.dimmerRef = React.createRef();
    return _this;
  }

  var _proto = Dimmer.prototype;

  _proto.componentWillMount = function componentWillMount() {
    this.props.onClick && window.addEventListener("click", this.onClickHandler);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.onClick && window.removeEventListener("click", this.onClickHandler);
  };

  return Dimmer;
}(Component);

Dimmer.displayName = "Dimmer";
Dimmer.propTypes = {
  onClose: PropTypes.func
};

function _templateObject$z() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n\n  z-index: 1001;\n\n  text-align: left;\n  background: #ffffff;\n  border: none;\n  box-shadow: 1px 3px 3px 0px rgba(0, 0, 0, 0.2),\n    1px 3px 15px 2px rgba(0, 0, 0, 0.2);\n  transform-origin: 50% 25%;\n  border-radius: 0.28571429rem;\n  user-select: text;\n\n  padding: 0;\n  outline: none; //so whole dialog doesn't appear outlined when focused programatically\n\n  ", "\n\n  ", "\n\n  @media screen and (max-width: ", "px) {\n    min-width: none;\n    margin: 0 !important;\n    border-radius: 0;\n    height: 100%;\n    width: 100%;\n    top: 0;\n    left: 0;\n    display: flex;\n    flex-direction: column;\n  }\n"]);

  _templateObject$z = function _templateObject() {
    return data;
  };

  return data;
}

var largePhoneBreakpoint = parseInt(BREAKPOINTS.PHONE_LARGE, 10); // ui small modal transition visible active modal-dialog

var ModalBox = styled.div(_templateObject$z(), function (props) {
  return !props.fixedWidth && "\n    @media only screen and (min-width: " + largePhoneBreakpoint + ") {\n      width: 95%;\n    }\n    @media only screen and (min-width: 768px) {\n      width: 70.4%;\n    }\n    @media only screen and (min-width: 992px) {\n      width: 680px;\n    }\n    @media only screen and (min-width: 1200px) {\n      width: 720px;\n    }\n    @media only screen and (min-width: 1920px) {\n      width: 760px;\n    }\n  ";
}, function (props) {
  return props.fixedWidth && "width: " + props.fixedWidth + "px;";
}, function (props) {
  return props.fullScreenWidth;
}); //VPAT stuff taken/inspired by https://github.com/ghosh/Micromodal/blob/master/lib/src/index.js

var FOCUSABLE_ELEMENTS = ["a[href]", "area[href]", 'input:not([disabled]):not([type="hidden"]):not([aria-hidden])', "select:not([disabled]):not([aria-hidden])", "textarea:not([disabled]):not([aria-hidden])", "button:not([disabled]):not([aria-hidden])", "iframe", "object", "embed", "[contenteditable]", '[tabindex]:not([tabindex^="-"])'];

var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Modal, _React$Component);

  function Modal(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.focusModal = function () {
      _this.modalRef.current.focus();
    };

    _this.addListeners = function () {
      _this.modalRef.current.addEventListener("keydown", _this.onKeyDown);
    };

    _this.removeListeners = function () {
      _this.modalRef.current.removeEventListener("keydown", _this.onKeyDown);
    };

    _this.onKeyDown = function (event) {
      if (event.key === "Tab") {
        _this.maintainFocus(event);
      }

      if (event.key === "Escape" && _this.props.onClose) {
        _this.closeDialog(event);
      }
    };

    _this.closeDialog = function () {
      _this.props.onClose && _this.props.onClose();
    };

    _this.getFocusableNodes = function () {
      var nodes = _this.modalRef.current.querySelectorAll(FOCUSABLE_ELEMENTS);

      return Array.apply(void 0, nodes);
    };

    _this.maintainFocus = function (event) {
      //theoretically getting focusable elements can be done only once, but it may not work for dynamic dialog contents
      //keeping here to avoid weird behavior and hard to catch bugs in future
      var focusableNodes = _this.getFocusableNodes();

      if (focusableNodes.length === 0) {
        _this.focusModal();

        event.preventDefault();
        return;
      }

      if (!_this.modalRef.current.contains(document.activeElement)) {
        focusableNodes[0].focus();
      } else {
        var focusedItemIndex = focusableNodes.indexOf(document.activeElement);

        if (event.shiftKey && focusedItemIndex === 0) {
          focusableNodes[focusableNodes.length - 1].focus();
          event.preventDefault();
        }

        if (!event.shiftKey && focusedItemIndex === focusableNodes.length - 1) {
          focusableNodes[0].focus();
          event.preventDefault();
        }
      }
    };

    _this.onDimmerClick = function (event) {
      if (!_this.modalRef.current.contains(event.target)) {
        _this.focusModal();

        if (_this.props.closeOnClick && _this.props.onClose) {
          _this.closeDialog();
        }
      }
    };

    _this.activeElementBeforeOpening = undefined;
    _this.modalRef = React.createRef();
    return _this;
  }

  var _proto = Modal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.activeElementBeforeOpening = document.activeElement;
    this.modalRef.current.setAttribute("aria-hidden", "false");
    this.addListeners();
    this.focusModal();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.activeElementBeforeOpening && this.activeElementBeforeOpening.focus && this.activeElementBeforeOpening.focus();
    this.modalRef.current.setAttribute("aria-hidden", "true"); //probably not needed, as dialog will be probably removed from DOM anyway, but use-cases can be different

    this.removeListeners();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        fixedWidth = _this$props.fixedWidth,
        dataTestId = _this$props["data-testid"],
        onClose = _this$props.onClose;
    var fullScreenWidth = Math.max(largePhoneBreakpoint, fixedWidth || 0);
    return ReactDOM.createPortal(React.createElement(Dimmer, {
      onClick: this.onDimmerClick,
      "data-testid": dataTestId && dataTestId + "-dimmer"
    }, React.createElement(ModalBox, {
      fixedWidth: fixedWidth,
      fullScreenWidth: fullScreenWidth,
      ref: this.modalRef,
      tabIndex: -1,
      "data-testid": dataTestId
    }, React.Children.map(children, function (child) {
      return React.cloneElement(child, {
        breakpoint: fullScreenWidth,
        onClose: onClose
      });
    }))), document.body);
  };

  return Modal;
}(React.Component);

Modal.displayName = "Modal";
Modal.defaultProps = {
  closeOnClick: false
};
Modal.propTypes = {
  fixedWidth: PropTypes.number,
  closeOnClick: PropTypes.bool,
  onClose: PropTypes.func
};

function _templateObject3$d() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: initial;\n  background: none;\n  border: none;\n  padding: 0;\n  background-image: url(", ");\n  background-repeat: no-repeat;\n  background-position: 8px;\n  min-width: ", "px;\n  height: ", "px;\n\n  @media screen and (max-width: ", "px) {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-sizing: initial;\n    background-image: url(", ");\n  }\n"]);

  _templateObject3$d = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$i() {
  var data = _taggedTemplateLiteralLoose(["\n  flex-grow: 1;\n\n  font-size: ", "px;\n  line-height: ", ";\n  padding: 0 ", "px;\n\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  max-height: ", "px; //fallback for browsers not supporting -webkit-line-clamp (i.e. IE)\n\n  @media screen and (max-width: ", "px) {\n    font-size: 18px;\n    text-align: center;\n    padding: 0 8px;\n    margin-right: ", ";\n  }\n"]);

  _templateObject2$i = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$A() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  height: 58px;\n  justify-content: left;\n  align-items: center;\n  color: #3f4040;\n  padding: 0 8px;\n  position: relative;\n\n  border-bottom: solid 1px ", ";\n\n  @media screen and (max-width: ", "px) {\n    background-color: ", ";\n    color: ", ";\n    border-bottom: none;\n    padding: 0 10px;\n    height: 52px;\n    flex-direction: row-reverse;\n  }\n"]);

  _templateObject$A = function _templateObject() {
    return data;
  };

  return data;
}

var CLOSE_ICON_SIZE = 32;
var HEADER_CONTENT_PADDING = 16;
var messages$2 = defineMessages({
  closeDialog: {
    "id": "closeDialog",
    defaultMessage: "Close dialog"
  }
});
var HeaderContainer = styled.div(_templateObject$A(), COLORS.SEPARATOR_COLORS.MEDIUM, function (props) {
  return props.breakpoint;
}, function (props) {
  return props.theme.primaryColor;
}, function (props) {
  return props.fontColor;
});
var CONTENT_FONT_SIZE = 22;
var CONTENT_LINE_HEIGHT = 1.18;
var CONTENT_VISIBLE_ROWS = 2;
var Content$2 = styled.div(_templateObject2$i(), CONTENT_FONT_SIZE, CONTENT_LINE_HEIGHT, HEADER_CONTENT_PADDING, CONTENT_VISIBLE_ROWS, CONTENT_FONT_SIZE * CONTENT_LINE_HEIGHT * CONTENT_VISIBLE_ROWS, function (props) {
  return props.breakpoint;
}, function (props) {
  return props.hasClose && CLOSE_ICON_SIZE + "px";
});
var CloseIconWrapper = styled.button(_templateObject3$d(), svgList["Close-16"], CLOSE_ICON_SIZE, CLOSE_ICON_SIZE, function (props) {
  return props.breakpoint;
}, function (props) {
  return props.showDarkIcon ? svgList["Chevron_left-16"] : svgList["Chevron_left-16-white"];
});

var DialogHeader = function DialogHeader(_ref) {
  var onClose = _ref.onClose,
      breakpoint = _ref.breakpoint,
      children = _ref.children,
      theme = _ref.theme,
      intl = _ref.intl;
  var fontColor = theme.primaryFontColor || readableColor(theme.primaryColor);
  return React.createElement(HeaderContainer, {
    fontColor: fontColor,
    breakpoint: breakpoint
  }, React.createElement(Content$2, {
    hasClose: !!onClose,
    breakpoint: breakpoint
  }, children), onClose && React.createElement(CloseIconWrapper, {
    breakpoint: breakpoint,
    "aria-label": intl.formatMessage(messages$2.closeDialog),
    showDarkIcon: fontColor === "#000",
    onClick: onClose
  }));
};

DialogHeader.propTypes = {
  onClose: PropTypes.func,
  breakpoint: PropTypes.number
};
var DialogHeader$1 = withTheme(injectIntl(DialogHeader));

function _templateObject2$j() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-left: 12px;\n"]);

  _templateObject2$j = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$B() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 56px;\n  background-color: #d6291a;\n  font-size: 16px;\n  font-weight: 500;\n  color: #ffffff;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 24px;\n"]);

  _templateObject$B = function _templateObject() {
    return data;
  };

  return data;
}

var Box = styled.div(_templateObject$B());
var Text = styled.div(_templateObject2$j());

var DialogNotification = function DialogNotification(_ref) {
  var children = _ref.children;
  return React.createElement(Box, null, React.createElement(Icon, {
    name: "ErrorWhite_24",
    size: "20px"
  }), React.createElement(Text, null, children));
};

function _templateObject$C() {
  var data = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  margin: auto;\n  padding: 24px;\n  line-height: 1.4;\n\n  @media screen and (max-width: ", "px) {\n    flex-direction: column;\n    padding: 32px 20px;\n    margin: 0;\n  }\n"]);

  _templateObject$C = function _templateObject() {
    return data;
  };

  return data;
}

var DialogContent = styled.div(_templateObject$C(), function (props) {
  return props.breakpoint;
});
Modal.Content = DialogContent;
Modal.Actions = DialogFooter;
Modal.Header = DialogHeader$1;
Modal.Notification = DialogNotification;

function _templateObject2$k() {
  var data = _taggedTemplateLiteralLoose(["\n  height: ", "px;\n  width: ", "px;\n  margin-right: 16px;\n"]);

  _templateObject2$k = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$D() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: left;\n  align-items: center;\n  font-size: 20px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: ", ";\n  background-color: #ffffff;\n  height: 64px;\n  padding-left: 24px;\n  border-bottom: solid 1px ", ";\n"]);

  _templateObject$D = function _templateObject() {
    return data;
  };

  return data;
}

var HeadingWrapper = styled.div(_templateObject$D(), COLORS.TEXT_COLORS.TITLE, COLORS.SEPARATOR_COLORS.MEDIUM);
var ICON_IMAGE_SIZE$2 = 32;
var Icon$2 = styled.img(_templateObject2$k(), ICON_IMAGE_SIZE$2, ICON_IMAGE_SIZE$2);

var Heading = function Heading(_ref) {
  var children = _ref.children,
      icon = _ref.icon;
  return React.createElement(HeadingWrapper, null, icon && React.createElement(Icon$2, {
    src: icon
  }), children);
};

Heading.propTypes = {
  icon: PropTypes.string
};

function _templateObject2$l() {
  var data = _taggedTemplateLiteralLoose(["\n  flex-basis: auto;\n  padding: 0 16px;\n  text-align: center;\n  position: relative;\n\n  &:not(:first-child)::after {\n    content: \"\";\n    background: ", ";\n    position: absolute;\n    bottom: 25%;\n    left: 0;\n    height: 50%;\n    width: 1px;\n  }\n"]);

  _templateObject2$l = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$E() {
  var data = _taggedTemplateLiteralLoose(["\n  list-style-type: none;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n"]);

  _templateObject$E = function _templateObject() {
    return data;
  };

  return data;
}

var StyledList = styled.ul(_templateObject$E());
var StyledItem$1 = styled.li(_templateObject2$l(), COLORS.SEPARATOR_COLORS.MEDIUM);

var LinksList = function LinksList(_ref) {
  var children = _ref.children;
  return React.createElement(StyledList, null, Children.map(children, function (child) {
    return child && React.createElement(StyledItem$1, null, child);
  }));
};

LinksList.propTypes = {};

function _templateObject2$m() {
  var data = _taggedTemplateLiteralLoose(["\n  flex-basis: auto;\n  padding: 0 5px;\n  text-align: left;\n"]);

  _templateObject2$m = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$F() {
  var data = _taggedTemplateLiteralLoose(["\n  list-style-type: none;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: left;\n  margin: 0;\n  padding: 0;\n  line-height: 2;\n  font-size: 14px;\n"]);

  _templateObject$F = function _templateObject() {
    return data;
  };

  return data;
}

var StyledList$1 = styled.ul(_templateObject$F());
var StyledItem$2 = styled.li(_templateObject2$m());

var VerticalList = function VerticalList(_ref) {
  var children = _ref.children;
  return React.createElement(StyledList$1, null, Children.map(children, function (child) {
    return child && React.createElement(StyledItem$2, null, child);
  }));
};

VerticalList.propTypes = {};
var clearSearchIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICAgIDxwYXRoIGZpbGw9IiM5ODk4OTgiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTE5LjIxMy4wMzNsLTkuMTggOS4yMTNMLjgyLjAzMy4xOTcuNjU2bDkuMTggOS4yMTMtOS4xOCA5LjIxMy42MjMuNjIzIDkuMjEzLTkuMjEzIDkuMTggOS4yMTMuNjU2LS42MjMtOS4yMTMtOS4yMTNMMTkuODY5LjY1NnoiLz4KPC9zdmc+Cg==";
var searchIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiNBNEE1QTkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE1Ljg0OCAxMy44NDhMMjEgMTlsLTIgMi01LjE1Mi01LjE1MmE3IDcgMCAxIDEgMi0yek0xMCAxNWE1IDUgMCAxIDAgMC0xMCA1IDUgMCAwIDAgMCAxMHoiLz4KPC9zdmc+Cg==";

function _templateObject6$3() {
  var data = _taggedTemplateLiteralLoose(["\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  margin: 0;\n  outline-offset: -5px;\n"]);

  _templateObject6$3 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$4() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: ", "px;\n  top: ", "px;\n  width: ", "px;\n  height: ", "px;\n"]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$7() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  box-sizing: content-box;\n  right: 0;\n  top: ", "px;\n  width: ", "px;\n  height: ", "px;\n  padding: ", "px;\n  cursor: pointer;\n"]);

  _templateObject4$7 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$e() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  flex-grow: 1;\n"]);

  _templateObject3$e = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$n() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n"]);

  _templateObject2$n = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$G() {
  var data = _taggedTemplateLiteralLoose(["\npadding-left: ", "px;\npadding-right: ", "px;\nborder-top-right-radius: ", "\nborder-bottom-right-radius: ", "\noutline-offset: -5px;\n"]);

  _templateObject$G = function _templateObject() {
    return data;
  };

  return data;
}

var searchIconSize = 24;
var iconsMargin = 8;
var clearIconSize = 12;
var clearIconInteractiveSize = 38;
var InputOverrided = styled(Input)(_templateObject$G(), iconsMargin * 2 + searchIconSize, iconsMargin + clearIconInteractiveSize, function (props) {
  return props.showButton ? 0 : "inherit";
}, function (props) {
  return props.showButton ? 0 : "inherit";
});
var SearchContainer = styled.div(_templateObject2$n());
var InputField = styled.div(_templateObject3$e());
var ClearIcon = styled.img(_templateObject4$7(), function (props) {
  return (props.inputHeight - clearIconInteractiveSize) / 2;
}, clearIconSize, clearIconSize, (clearIconInteractiveSize - clearIconSize) / 2);
var SearchIcon = styled.img(_templateObject5$4(), iconsMargin, function (props) {
  return (props.inputHeight - searchIconSize) / 2;
}, searchIconSize, searchIconSize);
var ButtonOverrided = styled(Button)(_templateObject6$3());

var SearchField = function SearchField(_ref) {
  var inputRef = _ref.inputRef,
      value = _ref.value,
      onRemove = _ref.onRemove,
      onSearch = _ref.onSearch,
      showButton = _ref.showButton,
      buttonLabel = _ref.buttonLabel,
      size = _ref.size,
      rest = _objectWithoutPropertiesLoose(_ref, ["inputRef", "value", "onRemove", "onSearch", "showButton", "buttonLabel", "size"]);

  var _onKeyDown = function onKeyDown(event, value) {
    if (event.keyCode === 13) onSearch(value);
    if (event.keyCode === 27) onRemove();
  };

  return React.createElement(SearchContainer, null, React.createElement(InputField, null, value.length > 0 && React.createElement(ClearIcon, {
    src: clearSearchIcon,
    onClick: onRemove,
    inputHeight: getHeight$1(size),
    showButton: showButton
  }), React.createElement(SearchIcon, {
    src: searchIcon,
    inputHeight: getHeight$1(size)
  }), React.createElement(InputOverrided, _extends({}, rest, {
    value: value,
    size: size,
    ref: inputRef,
    onKeyDown: function onKeyDown(event) {
      return _onKeyDown(event, value);
    }
  }))), showButton && React.createElement(ButtonOverrided, {
    look: "regular",
    onClick: onSearch,
    size: size
  }, buttonLabel));
};

SearchField.defaultProps = {
  size: SIZES.MEDIUM,
  onSearch: function onSearch() {
    return null;
  },
  showButton: false,
  buttonLabel: "Search"
};
SearchField.propTypes = {
  value: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  showButton: PropTypes.bool,
  buttonLabel: PropTypes.string,
  size: PropTypes.oneOf([SIZES.MEDIUM, SIZES.LARGE, SIZES.BIG]),
  inputRef: PropTypes.func
};

var _buttonSizeMap;

function _templateObject6$4() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n"]);

  _templateObject6$4 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$5() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #d62a1b;\n"]);

  _templateObject5$5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$8() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #5da40d;\n"]);

  _templateObject4$8 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$f() {
  var data = _taggedTemplateLiteralLoose(["\n  height: ", "px;\n  width: ", "px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 8px;\n  border: none;\n  padding: 3px;\n  cursor: pointer;\n\n  & img {\n    cursor: pointer;\n  }\n"]);

  _templateObject3$f = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$o() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"]);

  _templateObject2$o = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$H() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  margin-left: 4px;\n  width: 100%;\n"]);

  _templateObject$H = function _templateObject() {
    return data;
  };

  return data;
}

var messages$3 = defineMessages({
  confirm: {
    "id": "confirm",
    defaultMessage: "confirm"
  },
  revert: {
    "id": "revert",
    defaultMessage: "revert"
  },
  cancel: {
    "id": "cancel",
    defaultMessage: "cancel"
  }
});
var EditContainer = styled.div(_templateObject$H());
var ControlContainer = styled.div(_templateObject2$o());
var buttonSizeMap = (_buttonSizeMap = {}, _buttonSizeMap[SIZES.MEDIUM] = 32, _buttonSizeMap[SIZES.LARGE] = 42, _buttonSizeMap[SIZES.BIG] = 42, _buttonSizeMap);
var Button$1 = styled.button(_templateObject3$f(), function (props) {
  return buttonSizeMap[props.size];
}, function (props) {
  return buttonSizeMap[props.size];
});
var CheckmarkButton = styled(Button$1)(_templateObject4$8());
var CloseButton = styled(Button$1)(_templateObject5$5());
var RevertButton = styled(Button$1)(_templateObject6$4(), COLORS.ACTION_COLORS.BLUE_MAIN);

var InlineTextEdit =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(InlineTextEdit, _Component);

  function InlineTextEdit(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.componentDidUpdate = function (prevProps) {
      if (prevProps.editMode !== _this.props.editMode) {
        _this.setState({
          updateValue: _this.props.value
        });
      }
    };

    _this.onKeyDown = function (_ref) {
      var key = _ref.key;
      var _this$props = _this.props,
          onSave = _this$props.onSave,
          onCancel = _this$props.onCancel;

      if (key === "Enter") {
        onSave && onSave(_this.state.updateValue);
      }

      if (key === "Escape") {
        onCancel && onCancel();
      }
    };

    _this.onBlur = function (event) {
      // Don't fire the `onBlur` callback if the focusout targets the other elements of this input
      if (!_this.containerRef.current.contains(event.relatedTarget)) {
        _this.props.saveOnBlur ? _this.props.onSave && _this.props.onSave(_this.state.updateValue) : _this.props.onCancel && _this.props.onCancel();
      }
    };

    _this.render = function () {
      var _this$props2 = _this.props,
          id = _this$props2.id,
          value = _this$props2.value,
          editMode = _this$props2.editMode,
          render = _this$props2.render,
          onSave = _this$props2.onSave,
          onCancel = _this$props2.onCancel,
          onRevert = _this$props2.onRevert,
          size = _this$props2.size,
          intl = _this$props2.intl,
          inputProps = _objectWithoutPropertiesLoose(_this$props2, ["id", "value", "editMode", "render", "onSave", "onCancel", "onRevert", "size", "intl"]);

      var updateValue = _this.state.updateValue;

      if (editMode) {
        return React.createElement(EditContainer, {
          ref: _this.containerRef
        }, React.createElement(Input, _extends({
          id: id,
          value: updateValue,
          onChange: function onChange(event) {
            return _this.setState({
              updateValue: event.target.value
            });
          },
          onKeyDown: _this.onKeyDown,
          onBlur: _this.onBlur
        }, inputProps, {
          size: size
        })), React.createElement(ControlContainer, null, React.createElement(CheckmarkButton, {
          onClick: function onClick() {
            return onSave && onSave(updateValue);
          },
          size: size
        }, React.createElement(Icon, {
          icon: "Checkmark-16-thick",
          alt: intl.formatMessage(messages$3.confirm),
          size: "16px"
        })), React.createElement(CloseButton, {
          onClick: function onClick() {
            return onCancel && onCancel();
          },
          size: size
        }, React.createElement(Icon, {
          icon: "Close-16-thick",
          alt: intl.formatMessage(messages$3.cancel),
          size: "16px"
        })), onRevert && React.createElement(RevertButton, {
          onClick: function onClick() {
            return onRevert && onRevert();
          },
          size: size
        }, React.createElement(Icon, {
          icon: "Revert-16",
          alt: intl.formatMessage(messages$3.revert),
          size: "16px"
        }))));
      }

      return render(value);
    };

    _this.state = {
      updateValue: props.value
    };
    _this.containerRef = createRef();
    return _this;
  }

  return InlineTextEdit;
}(Component);

InlineTextEdit.defaultProps = {
  saveOnBlur: false,
  autoFocus: false,
  disabled: false,
  invalid: false,
  autoComplete: "off",
  autoCorrect: "off",
  spellCheck: "false",
  large: false,
  maxLength: 255,
  focused: false,
  locked: false,
  size: SIZES.MEDIUM
};
InlineTextEdit.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  editMode: PropTypes.bool.isRequired,
  render: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  onRevert: PropTypes.func,
  saveOnBlur: PropTypes.bool,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  autoComplete: PropTypes.string,
  autoCorrect: PropTypes.string,
  spellCheck: PropTypes.string,
  maxLength: PropTypes.number,
  name: PropTypes.string,
  autoCapitalize: PropTypes.string,
  size: PropTypes.oneOf([SIZES.MEDIUM, SIZES.LARGE, SIZES.BIG]),
  focused: PropTypes.bool,
  locked: PropTypes.bool
};
var InlineTextEdit$1 = injectIntl(InlineTextEdit);

var _positions;

function _templateObject2$p() {
  var data = _taggedTemplateLiteralLoose(["\n  border: 1px solid #d1d2d4;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16);\n  border-radius: 4px;\n  padding: 6px 0;\n  display: inline-block;\n  min-width: 190px;\n  background-color: #ffffff;\n  z-index: 10;\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  left: ", ";\n"]);

  _templateObject2$p = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$I() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: 100%;\n"]);

  _templateObject$I = function _templateObject() {
    return data;
  };

  return data;
}

var LEFT = "left";
var BOTTOM = "bottom";
var BOTTOMLEFT = "bottom-left";
var positions = (_positions = {}, _positions[LEFT] = {
  top: 0,
  right: "100%"
}, _positions[BOTTOM] = {
  top: "100%",
  left: 0
}, _positions[BOTTOMLEFT] = {
  top: "100%"
}, _positions);

var getTop = function getTop(menuPosition) {
  return positions[menuPosition].top;
};

var getRight = function getRight(menuPosition) {
  return positions[menuPosition].right;
};

var getLeft = function getLeft(menuPosition) {
  return positions[menuPosition].left;
};

var Wrap = styled.div(_templateObject$I());
var MenuWrap = styled.div(_templateObject2$p(), function (props) {
  return getTop(props.position);
}, function (props) {
  return getRight(props.position);
}, function (props) {
  return getLeft(props.position);
});

var Menu$1 =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Menu$$1, _Component);

  function Menu$$1(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.onTogglerClick = function (event) {
      var isOpen = _this.state.isOpen;

      _this.setState({
        isOpen: !isOpen
      });

      _this.setListeners(!isOpen);
    };

    _this.setListeners = function (isOpen) {
      if (isOpen) {
        _this.registerListeners();
      } else {
        _this.unregisterListeners();
      }
    };

    _this.registerListeners = function () {
      window.addEventListener("mousedown", _this.onMouseDown, false);
      window.addEventListener("click", _this.onMouseClick, false);
    };

    _this.unregisterListeners = function () {
      window.removeEventListener("mousedown", _this.onMouseDown);
      window.removeEventListener("click", _this.onMouseClick);
    };

    _this.onMouseDown = function (event) {
      if (!_this.wrap.contains(event.target) && _this.state.isOpen) {
        _this.setState({
          isOpen: false
        });

        _this.setListeners(false);
      }
    };

    _this.onMouseClick = function (event) {
      if (_this.menuWrap && _this.menuWrap.contains(event.target) && _this.state.isOpen) {
        _this.setState({
          isOpen: false
        });

        _this.setListeners(false);
      }
    };

    _this.setMenuWrapPosition = function () {
      if (_this.toggleEl) {
        switch (_this.props.position) {
          case BOTTOMLEFT:
            var toggleRect = _this.toggleEl.getBoundingClientRect();

            var menuWrapRect = _this.menuWrap.getBoundingClientRect();

            _this.menuWrap.style.left = toggleRect.width - menuWrapRect.width + "px";
            break;
        }
      }
    };

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  var _proto = Menu$$1.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        toggle = _this$props.toggle,
        position = _this$props.position,
        children = _this$props.children;
    var toggleEl = React.cloneElement(toggle, {
      ref: function ref(tglEl) {
        if (tglEl) {
          _this2.toggleEl = tglEl;
        }
      },
      onClick: this.onTogglerClick
    });
    return React.createElement(Wrap, {
      ref: function ref(wrap) {
        if (wrap) {
          _this2.wrap = wrap;
          _this2.togglerWidth = wrap.offsetWidth;
        }
      }
    }, toggleEl, this.state.isOpen ? React.createElement(MenuWrap, {
      ref: function ref(menuWrap) {
        if (menuWrap) {
          _this2.menuWrap = menuWrap;
        }

        _this2.setMenuWrapPosition();
      },
      togglerWidth: this.togglerWidth,
      position: position
    }, children) : null);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unregisterListeners();
  };

  return Menu$$1;
}(Component);

Menu$1.defaultProps = {
  position: BOTTOM
};
Menu$1.propTypes = {
  toggle: PropTypes.element,
  position: PropTypes.oneOf([LEFT, BOTTOM, BOTTOMLEFT])
};

function _templateObject$J() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 10px;\n  color: #333333;\n  cursor: pointer;\n  transition: background-color 0.1s;\n  background: #ffffff;\n  font-size: 14px;\n  text-align: left;\n\n  &:hover {\n    background-color: #eefbff;\n  }\n"]);

  _templateObject$J = function _templateObject() {
    return data;
  };

  return data;
}

var Item = styled.div(_templateObject$J());

var MenuItem = function MenuItem(_ref) {
  var onClick = _ref.onClick,
      children = _ref.children;
  return React.createElement(Item, {
    onClick: onClick
  }, children);
};

MenuItem.propTypes = {
  onClick: PropTypes.func.isRequired
};

function _templateObject$K() {
  var data = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid #d1d2d4;\n  height: 1px;\n  margin: 6px 10px;\n"]);

  _templateObject$K = function _templateObject() {
    return data;
  };

  return data;
}

var MenuDivider = styled.div(_templateObject$K());
var oneloginLogoUrl = "data:image/svg+xml;base64,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";

function _templateObject2$q() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n\n  .avatar {\n    color: ", ";\n\n    &.image {\n      background-color: ", ";\n      width: 32px;\n      height: 32px;\n    }\n  }\n\n  .ui.circular.image {\n    overflow: hidden;\n    border-radius: 500rem;\n  }\n\n  .ui.avatar.image {\n    vertical-align: middle;\n  }\n"]);

  _templateObject2$q = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$L() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 32px;\n  height: 32px;\n  margin-right: 10px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n\n  background: ", ";\n  color: ", ";\n  letter-spacing: 0.2px;\n"]);

  _templateObject$L = function _templateObject() {
    return data;
  };

  return data;
}

var InitialsCircle = styled.div(_templateObject$L(), COLORS.ONELOGIN_GRAY_COLORS.ONELOGIN_GRAY_LIGHT, COLORS.BLACK);
var AvatarImage = styled.div(_templateObject2$q(), COLORS.BLACK, COLORS.ONELOGIN_GRAY_COLORS.ONELOGIN_GRAY_LIGHT);

var NavbarUserAvatar = function NavbarUserAvatar(_ref) {
  var initials = _ref.initials,
      picture = _ref.picture;
  return React.createElement(AvatarImage, {
    "data-testid": "navbar-avatar"
  }, picture ? React.createElement("img", {
    className: "ui avatar circular image",
    src: picture
  }) : React.createElement(InitialsCircle, {
    "data-testid": "initials-circle"
  }, initials));
};

NavbarUserAvatar.propTypes = {
  initials: PropTypes.string,
  picture: PropTypes.string
};

function _templateObject7$3() {
  var data = _taggedTemplateLiteralLoose(["\n  opacity: 0.6;\n  font-size: 11px;\n  line-height: 14px;\n  max-width: 150px;\n"]);

  _templateObject7$3 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$5() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  font-size: 12px;\n  line-height: 18px;\n  max-width: 150px;\n"]);

  _templateObject6$5 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$6() {
  var data = _taggedTemplateLiteralLoose(["\n  border-left: ", ";\n"]);

  _templateObject5$6 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$9() {
  var data = _taggedTemplateLiteralLoose(["\n  /*\n   * # Semantic UI 2.4.0 - Dropdown\n   * http://github.com/semantic-org/semantic-ui/\n\n   styles changed:\n   - background color according to Props\n   - font color when not active or hover according to Props\n   - ensure active and hover on item text is white via menu-trigger class\n   - set height of .right.menu to enforce height\n   */\n\n  .ui.dropdown {\n    cursor: pointer;\n    position: relative;\n    padding: 16px 24px;\n    display: inline-block;\n    outline: none;\n    text-align: left;\n    transition: box-shadow 0.1s ease, width 0.1s ease;\n  }\n\n  .ui.dropdown.active,\n  .ui.dropdown:hover {\n    background: ", ";\n  }\n\n  .ui.dropdown .menu {\n    cursor: auto;\n    position: absolute;\n    display: none;\n    outline: none;\n    top: 100%;\n    min-width: max-content;\n    margin: 0em;\n    padding: 6px 0em;\n    background-color: ", ";\n    font-size: 14px;\n    text-shadow: none;\n    text-align: left;\n    box-shadow: 0 4px 12px 0 rgba(45, 46, 46, 0.08),\n      0 1px 4px 0 rgba(45, 46, 46, 0.2);\n    border-radius: 0 0 2px 2px;\n    transition: opacity 0.1s ease;\n    z-index: 11;\n    will-change: transform, opacity;\n    left: 0px;\n  }\n  .ui.dropdown .menu > * {\n    white-space: nowrap;\n  }\n\n  .ui.dropdown .menu:empty {\n    display: none;\n  }\n\n  .ui.menu .ui.dropdown .menu a.item {\n    padding: 12px 24px;\n  }\n\n  .ui.menu .ui.dropdown .menu a.item:hover {\n    background-color: ", ";\n  }\n\n  /* Automatically float dropdown menu right on last menu item */\n  .ui.menu .right.menu .dropdown:last-child .menu {\n    left: auto;\n    right: 0em;\n  }\n\n  .ui.inline.dropdown {\n    cursor: pointer;\n  }\n\n  .ui.simple.dropdown .menu:before,\n  .ui.simple.dropdown .menu:after {\n    display: none;\n  }\n  .ui.simple.dropdown .menu {\n    position: absolute;\n    display: block;\n    overflow: hidden;\n    top: -9999px;\n    opacity: 0;\n    width: 0;\n    height: 0;\n    transition: opacity 0.1s ease;\n  }\n  .ui.simple.active.dropdown,\n  .ui.simple.dropdown:hover {\n    border-bottom-left-radius: 0em;\n    border-bottom-right-radius: 0em;\n  }\n  .ui.simple.active.dropdown > .menu,\n  .ui.simple.dropdown:hover > .menu {\n    overflow: visible;\n    width: auto;\n    height: auto;\n    top: 100%;\n    opacity: 1;\n  }\n  .ui.simple.dropdown > .menu > .item:active > .menu,\n  .ui.simple.dropdown:hover > .menu > .item:hover > .menu {\n    overflow: visible;\n    width: auto;\n    height: auto;\n    top: 0%;\n    left: 100%;\n    opacity: 1;\n  }\n\n  /* Visible */\n  .ui.simple.visible.dropdown > .menu {\n    display: block;\n  }\n\n  /*\n   * # Semantic UI - Menu\n   * http://github.com/semantic-org/semantic-ui/\n   */\n\n  .ui.menu {\n    display: flex;\n    margin: 1rem 0em;\n    background: ", ";\n    font-weight: normal;\n    border: 1px solid rgba(34, 36, 38, 0.15);\n    box-shadow: 0px 1px 2px 0 rgba(34, 36, 38, 0.15);\n    border-radius: 0.28571429rem;\n    min-height: 2.85714286em;\n  }\n  .ui.menu:after {\n    content: \"\";\n    display: block;\n    height: 0px;\n    clear: both;\n    visibility: hidden;\n  }\n  .ui.menu:first-child {\n    margin-top: 0rem;\n  }\n  .ui.menu:last-child {\n    margin-bottom: 0rem;\n  }\n\n  .ui.menu .menu {\n    margin: 0em;\n  }\n  .ui.menu:not(.vertical) > .menu {\n    display: flex;\n  }\n\n  .ui.menu:not(.vertical) .item {\n    display: flex;\n    align-items: center;\n  }\n  .ui.menu .item {\n    position: relative;\n    vertical-align: middle;\n    line-height: 1;\n    text-decoration: none;\n    flex: 0 0 auto;\n    user-select: none;\n    text-transform: none;\n    color: rgba(0, 0, 0, 0.87);\n    font-weight: normal;\n    transition: background 0.1s ease, box-shadow 0.1s ease, color 0.1s ease;\n  }\n\n  .ui.menu .dropdown.item .menu {\n    min-width: calc(100% - 1px);\n    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.08);\n    flex-direction: column;\n  }\n\n  .ui.link.menu .item:hover,\n  .ui.menu .dropdown.item:hover,\n  .ui.menu .link.item:hover,\n  .ui.menu a.item:hover {\n    cursor: pointer;\n    .text {\n      color: ", ";\n    }\n  }\n\n  .ui.menu .ui.dropdown .text {\n    position: relative;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 1.43;\n    letter-spacing: 0.4px;\n    color: ", ";\n  }\n\n  .ui.menu .ui.dropdown .text:after {\n    position: absolute;\n    bottom: -16px;\n    content: \"\";\n    width: 100%;\n    height: 3px;\n    background-color: transparent;\n    display: block;\n  }\n\n  .ui.menu .ui.dropdown.navbar-item-active:not(.active) .text:after {\n    background-color: ", ";\n  }\n\n  .ui.menu .active.item {\n    color: rgba(0, 0, 0, 0.95);\n    font-weight: normal;\n    box-shadow: none;\n    .text {\n      color: ", ";\n    }\n  }\n  .ui.menu .active.item > i.icon {\n    opacity: 1;\n  }\n\n  .ui.menu .active.item:hover,\n  .ui.vertical.menu .active.item:hover {\n    color: rgba(0, 0, 0, 0.95);\n  }\n\n  .ui.menu:not(.vertical) .right.item,\n  .ui.menu:not(.vertical) .right.menu {\n    display: flex;\n    margin-left: auto;\n    height: ", "px;\n  }\n\n  .ui.inverted.menu {\n    border: 0px solid transparent;\n    background: ", ";\n    box-shadow: none;\n  }\n\n  /* Menu Item */\n  .ui.inverted.menu .item,\n  .ui.inverted.menu .item > a:not(.ui) {\n    color: ", ";\n  }\n\n  /*--- Hover ---*/\n\n  .ui.link.inverted.menu .item:hover,\n  .ui.inverted.menu .dropdown.item:hover,\n  .ui.inverted.menu .link.item:hover,\n  .ui.inverted.menu a.item:hover {\n    color: ", ";\n  }\n  .ui.vertical.inverted.menu .item .menu a.item:hover,\n  .ui.vertical.inverted.menu .item .menu .link.item:hover {\n    background: transparent;\n    color: ", ";\n  }\n\n  /*--------------\n       Fixed\n  ---------------*/\n\n  .ui.menu.fixed {\n    position: fixed;\n    z-index: 101;\n    margin: 0em;\n    width: 100%;\n  }\n  .ui.menu.fixed,\n  .ui.menu.fixed .item:first-child,\n  .ui.menu.fixed .item:last-child {\n    border-radius: 0px;\n  }\n  .ui.fixed.menu,\n  .ui[class*=\"top fixed\"].menu {\n    top: 0px;\n    left: 0px;\n    right: auto;\n    bottom: auto;\n  }\n  .ui[class*=\"top fixed\"].menu {\n    border-top: none;\n    border-left: none;\n    border-right: none;\n  }\n  .ui[class*=\"right fixed\"].menu {\n    border-top: none;\n    border-bottom: none;\n    border-right: none;\n    top: 0px;\n    right: 0px;\n    left: auto;\n    bottom: auto;\n    width: auto;\n    height: 100%;\n  }\n  .ui[class*=\"bottom fixed\"].menu {\n    border-bottom: none;\n    border-left: none;\n    border-right: none;\n    bottom: 0px;\n    left: 0px;\n    top: auto;\n    right: auto;\n  }\n  .ui[class*=\"left fixed\"].menu {\n    border-top: none;\n    border-bottom: none;\n    border-left: none;\n    top: 0px;\n    left: 0px;\n    right: auto;\n    bottom: auto;\n    width: auto;\n    height: 100%;\n  }\n\n  /*******************************\n           Custom Overrides\n  *******************************/\n\n  .ui.dropdown .menu.visible.transition {\n    display: block;\n    visibility: visible;\n  }\n\n  .ui.dropdown.navbar-avatar {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    .menu-trigger {\n      display: flex;\n      align-items: center;\n      color: ", ";\n    }\n    &:hover {\n      .menu-trigger {\n        color: ", ";\n      }\n    }\n  }\n\n  .ui.dropdown.navbar-avatar.active {\n    .menu-trigger {\n      color: ", ";\n    }\n  }\n\n  .ui.dropdown.navbar-avatar img,\n  .ui.dropdown.navbar-avatar .avatar-initials {\n    margin-right: 10px;\n  }\n\n  .ui.dropdown.navbar-avatar .avatar-initials {\n    padding: 9px;\n    font-size: 12px;\n  }\n\n  .ui.dropdown.right-link {\n    a {\n      text-decoration: none;\n      color: ", ";\n    }\n    &:hover {\n      a {\n        color: ", ";\n      }\n    }\n  }\n"]);

  _templateObject4$9 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$g() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1 0 auto;\n  margin: auto;\n  max-width: ", ";\n"]);

  _templateObject3$g = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$r() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex; //to center inner image\n  overflow: hidden;\n  max-width: 300px;\n  max-height: 40px;\n\n  img {\n    display: block;\n    max-width: 100%;\n    max-height: 40px;\n    height: auto;\n    width: auto;\n  }\n"]);

  _templateObject2$r = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$M() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-left: 32px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-right: 32px;\n"]);

  _templateObject$M = function _templateObject() {
    return data;
  };

  return data;
}

var NAVBAR_HEIGHT_DESKTOP = 52;
var BrandLogo = styled.div(_templateObject$M());
var BrandLogoLink = styled.a(_templateObject2$r());
var WidthControl = styled.div(_templateObject3$g(), function (props) {
  return props.constrained ? BREAKPOINTS.WIDE_VIEW_LIMIT : "";
});
var StyledNavbarDesktop = styled.div(_templateObject4$9(), COLORS.GRAY_COLORS.GRAY_18, COLORS.GRAY_COLORS.GRAY_18, COLORS.ACTION_COLORS.BLUE_MAIN, COLORS.WHITE, COLORS.WHITE, function (props) {
  return props.theme.primaryFontColor || COLORS.WHITE;
}, COLORS.ACTION_COLORS.ONELOGIN_BLUE, COLORS.WHITE, NAVBAR_HEIGHT_DESKTOP, function (props) {
  return props.theme.primaryColor || COLORS.ONELOGIN_GRAY_COLORS.ONELOGIN_BLACK;
}, COLORS.WHITE, COLORS.WHITE, COLORS.WHITE, function (props) {
  return props.theme.primaryFontColor || COLORS.WHITE;
}, COLORS.WHITE, COLORS.WHITE, function (props) {
  return props.theme.primaryFontColor || COLORS.WHITE;
}, COLORS.WHITE);

var DropdownMenuLinks = function DropdownMenuLinks(_ref) {
  var links = _ref.links;
  return links.map(function (link, index) {
    return React.createElement("div", {
      key: index
    }, link.divider && React.createElement(MenuDivider, null), !link.divider && React.createElement(Dropdown.Item, {
      as: "a",
      href: link.href,
      key: index
    }, link.title));
  });
};

var RightLinkWrapper = styled.div(_templateObject5$6(), function (props) {
  return props.showBorder ? "1px solid rgb(255, 255, 255, 0.3)" : "";
});

var RightLink = function RightLink(_ref2) {
  var link = _ref2.link,
      showBorder = _ref2.showBorder;
  return React.createElement(RightLinkWrapper, {
    className: "ui dropdown item right-link",
    showBorder: showBorder
  }, React.createElement("a", {
    href: link.href,
    className: "ui text"
  }, link.title));
};

var NavbarLinks = function NavbarLinks(_ref3) {
  var onLeftMenuLinkClick = _ref3.onLeftMenuLinkClick,
      mouseEnter = _ref3.mouseEnter,
      lastActiveTabId = _ref3.lastActiveTabId,
      simple = _ref3.simple,
      tabClass = _ref3.tabClass,
      tabs = _ref3.tabs;
  return tabs.map(function (tab) {
    return React.createElement(Dropdown, {
      item: true,
      key: tab.title,
      text: tab.title,
      icon: null,
      simple: simple,
      open: simple && lastActiveTabId === tab.id,
      onClick: onLeftMenuLinkClick,
      onMouseEnter: function onMouseEnter() {
        return mouseEnter(tab);
      },
      className: tabClass(tab)
    }, React.createElement(Dropdown.Menu, null, React.createElement(DropdownMenuLinks, {
      links: tab.links
    })));
  });
};

var NavbarAvatarDropdown = function NavbarAvatarDropdown(_ref4) {
  var onRightMenuLinkClick = _ref4.onRightMenuLinkClick,
      navbarAvatar = _ref4.navbarAvatar,
      userLinks = _ref4.userLinks;
  return React.createElement(Dropdown, {
    icon: navbarAvatar,
    inline: true,
    item: true,
    key: "userLinks",
    onClick: onRightMenuLinkClick,
    className: "navbar-avatar"
  }, React.createElement(Dropdown.Menu, null, React.createElement(DropdownMenuLinks, {
    links: userLinks
  })));
};

var UserNameWithCompanyWrapper = styled.div(_templateObject6$5());
var CompanyName = styled.div(_templateObject7$3());

var UserNameWithCompany = function UserNameWithCompany(_ref5) {
  var userName = _ref5.userName,
      companyName = _ref5.companyName;
  return React.createElement(UserNameWithCompanyWrapper, null, React.createElement("div", null, userName), React.createElement(CompanyName, null, companyName));
};

var NavbarDesktop =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(NavbarDesktop, _Component);

  function NavbarDesktop(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleMouseEnter = function (tab) {
      _this.setState({
        lastActiveTabId: tab.id
      });
    };

    _this.state = {
      lastActiveTabId: null
    };
    return _this;
  }

  var _proto = NavbarDesktop.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        constrained = _this$props.constrained,
        brandLogo = _this$props.brandLogo,
        onLeftMenuLinkClick = _this$props.onLeftMenuLinkClick,
        onRightMenuLinkClick = _this$props.onRightMenuLinkClick,
        rightLink = _this$props.rightLink,
        _this$props$theme = _this$props.theme,
        theme = _this$props$theme === void 0 ? {} : _this$props$theme,
        simpleNavbarDropdowns = _this$props.simpleNavbarDropdowns,
        tabClass = _this$props.tabClass,
        tabs = _this$props.tabs,
        userMenu = _this$props.userMenu;
    var navbarAvatar = React.createElement("div", {
      className: "menu-trigger"
    }, React.createElement(NavbarUserAvatar, {
      initials: userMenu.initials,
      picture: userMenu.picture
    }), userMenu.companyName ? React.createElement(UserNameWithCompany, {
      userName: userMenu.name,
      companyName: userMenu.companyName
    }) : userMenu.name);
    return React.createElement(StyledNavbarDesktop, {
      "data-testid": "navbar-desktop",
      theme: theme
    }, React.createElement("div", {
      className: "ui borderless inverted fixed menu",
      "data-testid": "navbar-desktop-inverted-menu"
    }, React.createElement(WidthControl, {
      constrained: constrained
    }, React.createElement(BrandLogo, {
      className: "item",
      constrained: constrained
    }, React.createElement(BrandLogoLink, {
      href: brandLogo.link,
      onClick: brandLogo.onClick,
      "data-testid": "brand-logo"
    }, React.createElement("img", {
      src: theme.logoUrl || oneloginLogoUrl,
      alt: "brand-logo"
    }))), React.createElement(NavbarLinks, {
      lastActiveTabId: this.state.lastActiveTabId,
      mouseEnter: this.handleMouseEnter,
      onLeftMenuLinkClick: onLeftMenuLinkClick,
      simple: simpleNavbarDropdowns,
      tabClass: tabClass,
      tabs: tabs
    }), React.createElement("div", {
      className: "menu right"
    }, rightLink && React.createElement(RightLink, {
      link: rightLink,
      showBorder: tabs && tabs.length > 0
    }), React.createElement(NavbarAvatarDropdown, {
      onRightMenuLinkClick: onRightMenuLinkClick,
      navbarAvatar: navbarAvatar,
      userLinks: userMenu.links
    })))));
  };

  return NavbarDesktop;
}(Component);

NavbarDesktop.propTypes = {
  brandLogo: PropTypes.shape({
    onClick: PropTypes.func,
    link: PropTypes.string
  }).isRequired,
  constrained: PropTypes.bool,
  onLeftMenuLinkClick: PropTypes.func.isRequired,
  onRightMenuLinkClick: PropTypes.func.isRequired,
  rightLink: PropTypes.shape({
    href: PropTypes.string,
    title: PropTypes.string
  }),
  theme: PropTypes.object,
  simpleNavbarDropdowns: PropTypes.bool,
  tabClass: PropTypes.func.isRequired,
  //?
  tabs: PropTypes.array.isRequired,
  userMenu: PropTypes.shape({
    links: PropTypes.array,
    initials: PropTypes.string,
    picture: PropTypes.string,
    name: PropTypes.string,
    companyName: PropTypes.string
  })
};

function _templateObject5$7() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 16px;\n"]);

  _templateObject5$7 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$a() {
  var data = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  margin: 1rem 0rem;\n"]);

  _templateObject4$a = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$h() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex; //to center inner image\n  justify-content: center;\n  flex-direction: column;\n  overflow: hidden;\n  max-width: 240px;\n  max-height: 32px;\n\n  img {\n    display: block;\n    max-width: 100%;\n    max-height: 32px;\n    height: auto;\n    width: auto;\n  }\n"]);

  _templateObject3$h = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$s() {
  var data = _taggedTemplateLiteralLoose(["\n  // padding-left: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"]);

  _templateObject2$s = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$N() {
  var data = _taggedTemplateLiteralLoose(["\n  /*!\n   * # Semantic UI 2.3.1 - Transition\n   */\n  .transition {\n    animation-iteration-count: 1;\n    animation-duration: 300ms;\n    animation-timing-function: ease;\n    animation-fill-mode: both;\n  }\n\n  .animating.transition {\n    backface-visibility: hidden;\n    visibility: visible;\n  }\n\n  .hidden.transition {\n    display: none;\n    visibility: hidden;\n  }\n\n  .visible.transition {\n    display: block;\n    visibility: visible;\n\n    /*  backface-visibility: @backfaceVisibility;\n    transform: @use3DAcceleration;*/\n  }\n\n  .disabled.transition {\n    animation-play-state: paused;\n  }\n\n  .transition.fade.in {\n    animation-name: fadeIn;\n  }\n  .transition.fade.out {\n    animation-name: fadeOut;\n  }\n\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n\n  @keyframes fadeOut {\n    0% {\n      opacity: 1;\n    }\n    100% {\n      opacity: 0;\n    }\n  }\n\n  /*\n   * # Semantic UI - Menu\n\n   styles changed:\n   - background color according to Props\n   - z-index on .ui.attached.menu to allow Notifications to hide behind navbar\n   - max-height on .ui.attached.menu to enforce height regardless of img\n   */\n\n  .ui.menu {\n    display: flex;\n    margin: 1rem 0em;\n    background-color: ", ";\n    font-weight: normal;\n    border: 1px solid rgba(34, 36, 38, 0.15);\n    box-shadow: 0px 1px 2px 0 rgba(34, 36, 38, 0.15);\n    border-radius: 0.28571429rem;\n    min-height: 2.85714286em;\n  }\n  .ui.menu:after {\n    content: \"\";\n    display: block;\n    height: 0px;\n    clear: both;\n    visibility: hidden;\n  }\n  .ui.menu:first-child {\n    margin-top: 0rem;\n  }\n  .ui.menu:last-child {\n    margin-bottom: 0rem;\n  }\n\n  .ui.menu:not(.vertical) .item {\n    display: flex;\n    align-items: center;\n  }\n  .ui.menu .item {\n    position: relative;\n    vertical-align: middle;\n    line-height: 1;\n    text-decoration: none;\n    flex: 0 0 auto;\n    user-select: none;\n    background: none;\n    padding: 0.92857143em 1.14285714em;\n    text-transform: none;\n    color: rgba(0, 0, 0, 0.87);\n    font-weight: normal;\n    transition: background 0.1s ease, box-shadow 0.1s ease, color 0.1s ease;\n  }\n  .ui.menu > .item:first-child {\n    border-radius: 0.28571429rem 0px 0px 0.28571429rem;\n  }\n\n  /* Show vertical dividers below last */\n  .ui.vertical.sidebar.menu > .item:first-child:before {\n    display: block;\n  }\n  .ui.vertical.sidebar.menu > .item::before {\n    top: auto;\n    bottom: 0px;\n  }\n\n  .ui.link.menu .item:hover,\n  .ui.menu .dropdown.item:hover,\n  .ui.menu .link.item:hover,\n  .ui.menu a.item:hover {\n    cursor: pointer;\n    background: rgba(0, 0, 0, 0.03);\n    color: rgba(0, 0, 0, 0.95);\n  }\n\n  .ui.link.menu .item:active,\n  .ui.menu .link.item:active,\n  .ui.menu a.item:active {\n    background: rgba(0, 0, 0, 0.03);\n    color: rgba(0, 0, 0, 0.95);\n  }\n\n  .ui.menu .active.item {\n    background: rgba(0, 0, 0, 0.05);\n    color: rgba(0, 0, 0, 0.95);\n    font-weight: normal;\n    box-shadow: none;\n  }\n  .ui.menu .active.item > i.icon {\n    opacity: 1;\n  }\n\n  .ui.vertical.menu {\n    display: block;\n    flex-direction: column;\n    background-color: ", ";\n    box-shadow: 0px 1px 2px 0 rgba(34, 36, 38, 0.15);\n  }\n\n  .ui.vertical.menu .item {\n    display: block;\n    background: none;\n    border-top: none;\n    border-right: none;\n  }\n  .ui.vertical.menu > .item:first-child {\n    border-radius: 0.28571429rem 0.28571429rem 0px 0px;\n  }\n  .ui.vertical.menu > .item:last-child {\n    border-radius: 0px 0px 0.28571429rem 0.28571429rem;\n  }\n\n  .ui.inverted.menu {\n    border: 0px solid transparent;\n    background-color: ", ";\n    box-shadow: none;\n  }\n\n  .ui.inverted.menu .item,\n  .ui.inverted.menu .item > a:not(.ui) {\n    background: transparent;\n    color: rgba(255, 255, 255, 0.9);\n  }\n  .ui.inverted.menu .item.menu {\n    background: transparent;\n  }\n\n  .ui.link.inverted.menu .item:hover,\n  .ui.inverted.menu .dropdown.item:hover,\n  .ui.inverted.menu .link.item:hover,\n  .ui.inverted.menu a.item:hover {\n    background: rgba(255, 255, 255, 0.08);\n    color: #ffffff;\n  }\n  .ui.vertical.inverted.menu .item .menu a.item:hover,\n  .ui.vertical.inverted.menu .item .menu .link.item:hover {\n    background: transparent;\n    color: #ffffff;\n  }\n\n  .ui.borderless.menu .item:before,\n  .ui.borderless.menu .item .menu .item:before,\n  .ui.menu .borderless.item:before {\n    background: none;\n  }\n\n  .ui.attached.menu {\n    top: 0px;\n    bottom: 0px;\n    border-radius: 0px;\n    margin: 0em -1px;\n    width: calc(100% + 2px);\n    max-width: calc(100% + 2px);\n    box-shadow: none;\n    z-index: 100; /* so that notifications hide */\n    position: relative;\n    height: ", "px;\n    max-height: ", "px;\n  }\n\n  /*!\n   * # Semantic UI 2.3.1 - Sidebar\n   */\n\n  /* Sidebar Menu */\n  .ui.sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    backface-visibility: hidden;\n    transition: none;\n    will-change: transform;\n    transform: translate3d(0, 0, 0);\n    visibility: hidden;\n    height: 100%;\n    max-height: 100%;\n    border-radius: 0em;\n    margin: 0em;\n    overflow-y: auto;\n    z-index: 102;\n  }\n\n  .ui.sidebar.inverted.menu {\n    background-color: ", ";\n  }\n\n  /* GPU Layers for Child Elements */\n  .ui.sidebar > * {\n    backface-visibility: hidden;\n  }\n\n  /*--------------\n     Direction\n  ---------------*/\n\n  .ui.left.sidebar {\n    right: auto;\n    left: 0px;\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  .pushable {\n    height: 100%;\n    min-height: 100vh;\n    overflow-x: hidden;\n    padding: 0em;\n  }\n\n  /* Page Context */\n  .pushable:not(body) {\n    transform: translate3d(0, 0, 0);\n  }\n  .pushable:not(body) > .ui.sidebar,\n  .pushable:not(body) > .fixed,\n  .pushable:not(body) > .pusher:after {\n    position: absolute;\n  }\n\n  .pushable > .pusher {\n    position: relative;\n    backface-visibility: hidden;\n    overflow: hidden;\n    min-height: 100%;\n    transition: transform 500ms ease;\n    z-index: 2;\n    background: inherit;\n  }\n\n  .ui.sidebar.menu .item {\n    border-radius: 0em;\n    word-wrap: break-word;\n  }\n\n  .ui.animating.sidebar {\n    visibility: visible;\n  }\n\n  .ui.visible.sidebar {\n    visibility: visible;\n    transform: translate3d(0, 0, 0);\n  }\n\n  .ui.left.visible.sidebar {\n    box-shadow: 0px 0px 20px rgba(34, 36, 38, 0.15);\n  }\n\n  /* Visible On Load */\n  .ui.visible.left.sidebar ~ .fixed,\n  .ui.visible.left.sidebar ~ .pusher {\n    transform: translate3d(260px, 0, 0);\n  }\n\n  /* opposite sides visible forces content overlay */\n  .ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .fixed,\n  .ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .pusher,\n  .ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .fixed,\n  .ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .pusher {\n    transform: translate3d(0, 0, 0);\n  }\n\n  .ui.left.sidebar,\n  .ui.right.sidebar {\n    width: 260px;\n  }\n\n  .ui.overlay.sidebar {\n    z-index: 102;\n  }\n\n  .ui.push.sidebar {\n    transition: transform 500ms ease;\n    z-index: 102;\n  }\n\n  .ui.left.push.sidebar {\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  .ui.visible.push.sidebar {\n    transform: translate3d(0%, 0, 0);\n  }\n\n  /* CUSTOM OVERRIDES */\n\n  &.ui.inverted.menu .link.item:active,\n  &.ui.inverted.menu a.item:active,\n  &.ui.inverted.menu a.item:hover {\n    background-color: initial;\n  }\n\n  .sidebar {\n    &.menu .item {\n      padding: 14px 24px;\n    }\n\n    .navbar-sidebar-icon {\n      float: right;\n      cursor: pointer;\n    }\n\n    &.navbar-item-active {\n      background-color: rgba(255, 255, 255, 0.05);\n      &:before {\n        top: 14px;\n        left: 12px;\n        height: 16px;\n        border-left: 2px solid ", ";\n        border-left: 2px solid ", ";\n      }\n    }\n\n    .item img.avatar {\n      margin-right: 8px;\n      margin-top: -2px;\n    }\n\n    &.ui.menu.inverted .header.item {\n      display: flex;\n      align-items: center;\n      height: ", "px;\n      box-sizing: border-box;\n\n      color: ", ";\n      font-size: 19px;\n      font-weight: 500;\n\n      + .divider-fitted {\n        margin-top: 0;\n      }\n    }\n  }\n\n  .pushable > .pusher {\n    .item {\n      padding: 14px 20px;\n    }\n  }\n\n  .header.item .navbar-sidebar-back-icon {\n    position: absolute;\n    left: 24px;\n    top: 18px;\n  }\n"]);

  _templateObject$N = function _templateObject() {
    return data;
  };

  return data;
}

var NAVBAR_HEIGHT_MOBILE = 52;
var StyledNavbarMobile = styled.div(_templateObject$N(), COLORS.GRAY_COLORS.ONELOGIN_BLACK, COLORS.GRAY_COLORS.GRAY_18, function (props) {
  return props.theme.primaryColor || COLORS.ONELOGIN_GRAY_COLORS.ONELOGIN_BLACK;
}, NAVBAR_HEIGHT_MOBILE, NAVBAR_HEIGHT_MOBILE, COLORS.GRAY_COLORS.GRAY_18, COLORS.ACTION_COLORS.ONELOGIN_BLUE, COLORS.ACTION_COLORS.ONELOGIN_BLUE, NAVBAR_HEIGHT_MOBILE, COLORS.ACTION_COLORS.ONELOGIN_BLUE);
var BrandLogo$1 = styled.div(_templateObject2$s());
var BrandLogoLink$1 = styled.a(_templateObject3$h());
var Divider = styled.div(_templateObject4$a());
var Spacer = styled.div(_templateObject5$7());

var NavbarMobileAvatar = function NavbarMobileAvatar(_ref) {
  var navbarAvatar = _ref.navbarAvatar,
      onSubmenuLinkClick = _ref.onSubmenuLinkClick,
      tabClass = _ref.tabClass,
      userLinks = _ref.userLinks;
  return React.createElement(Menu.Item, {
    key: "userLinks",
    as: "a",
    onClick: function onClick() {
      return onSubmenuLinkClick(userLinks);
    }
  }, userLinks && userLinks.length > 0 && React.createElement(Icon, {
    className: "ui navbar-sidebar-icon",
    icon: "Chevron_right-12-white",
    size: "15px"
  }), navbarAvatar);
};

var NavbarMobileLinks = function NavbarMobileLinks(_ref2) {
  var onSubmenuLinkClick = _ref2.onSubmenuLinkClick,
      tabClass = _ref2.tabClass,
      tabs = _ref2.tabs;
  return tabs.map(function (tab, index) {
    return React.createElement("div", {
      key: index
    }, tab.divider && React.createElement(Divider, null), !tab.divider && React.createElement(Menu.Item, {
      key: index,
      as: "a",
      href: tab.href,
      className: tabClass(tab),
      onClick: function onClick() {
        return onSubmenuLinkClick(tab.links);
      }
    }, tab.links && tab.links.length > 0 && React.createElement(Icon, {
      className: "navbar-sidebar-icon",
      icon: "Chevron_right-12-white",
      size: "15px"
    }), tab.title));
  });
};

var PrimarySidebar = function PrimarySidebar(_ref3) {
  var navbarAvatar = _ref3.navbarAvatar,
      onSubmenuLinkClick = _ref3.onSubmenuLinkClick,
      tabClass = _ref3.tabClass,
      tabs = _ref3.tabs,
      userLinks = _ref3.userLinks,
      visible = _ref3.visible,
      rightLink = _ref3.rightLink;
  return React.createElement(Sidebar, {
    as: Menu,
    animation: "push",
    borderless: true,
    inverted: true,
    vertical: true,
    visible: visible
  }, React.createElement(Spacer, null), React.createElement(NavbarMobileLinks, {
    onSubmenuLinkClick: onSubmenuLinkClick,
    tabClass: tabClass,
    tabs: tabs
  }), React.createElement(Divider, null), rightLink && React.createElement(Menu.Item, {
    as: "a",
    href: rightLink.href
  }, rightLink.title), userLinks && React.createElement(NavbarMobileAvatar, {
    navbarAvatar: navbarAvatar,
    onSubmenuLinkClick: onSubmenuLinkClick,
    tabClass: tabClass,
    userLinks: userLinks
  }));
};

var SecondarySidebarTabs = function SecondarySidebarTabs(_ref4) {
  var tabs = _ref4.tabs;
  return tabs.map(function (tab) {
    return React.createElement("div", {
      key: tab.title
    }, tab.divider && React.createElement(Divider, null), !tab.divider && React.createElement(Menu.Item, {
      key: tab.title,
      as: "a",
      href: tab.href
    }, tab.title));
  });
};

var SecondarySidebar = function SecondarySidebar(_ref5) {
  var onHeaderBackClick = _ref5.onHeaderBackClick,
      tabs = _ref5.tabs,
      visible = _ref5.visible;
  return React.createElement(Sidebar, {
    as: Menu,
    animation: "push",
    borderless: true,
    inverted: true,
    vertical: true,
    visible: visible
  }, React.createElement(Menu.Item, {
    header: true,
    onClick: onHeaderBackClick
  }, React.createElement(Icon, {
    icon: "Chevron_left-12-white",
    className: "navbar-sidebar-back-icon",
    size: "16px"
  })), React.createElement(Divider, {
    className: "divider-fitted"
  }), React.createElement(SecondarySidebarTabs, {
    tabs: tabs
  }));
};

var NavbarMobile =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(NavbarMobile, _Component);

  function NavbarMobile(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.onPusherClick = function () {
      var sidebarPrimaryVisible = _this.state.sidebarPrimaryVisible;

      if (sidebarPrimaryVisible) {
        _this.setState({
          sidebarPrimaryVisible: false,
          sidebarSecondaryVisible: false
        });
      }
    };

    _this.onSubmenuLinkClick = function (tabLinks) {
      var atSubmenuNode = tabLinks === undefined || tabLinks.length === 0;
      if (atSubmenuNode) return;

      _this.setState({
        secondaryTabs: tabLinks,
        sidebarPrimaryVisible: true,
        sidebarSecondaryVisible: true
      });
    };

    _this.onHeaderBackClick = function () {
      _this.setState({
        sidebarSecondaryVisible: false
      });
    };

    _this.onToggle = function () {
      _this.setState({
        sidebarPrimaryVisible: !_this.state.sidebarPrimaryVisible
      });
    };

    _this.state = {
      secondaryTabs: [],
      sidebarPrimaryVisible: false,
      sidebarSecondaryVisible: false
    };
    return _this;
  }

  var _proto = NavbarMobile.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        _this$props$theme = _this$props.theme,
        theme = _this$props$theme === void 0 ? {} : _this$props$theme,
        rightLink = _this$props.rightLink,
        brandLogo = _this$props.brandLogo,
        tabClass = _this$props.tabClass,
        tabs = _this$props.tabs,
        userMenu = _this$props.userMenu;
    var _this$state = this.state,
        sidebarPrimaryVisible = _this$state.sidebarPrimaryVisible,
        sidebarSecondaryVisible = _this$state.sidebarSecondaryVisible,
        secondaryTabs = _this$state.secondaryTabs;
    var brandLogoUrl = theme.logoUrl || oneloginLogoUrl;
    var logoImg = React.createElement(Transition, {
      visible: !sidebarPrimaryVisible,
      onHide: function onHide() {
        //transition visible=false makes inner element css:visible="hidden". So it's parent has defined width and height. So <a> element is still clickable, which is unwanted
        if (_this2.anchor) {
          _this2.anchor.style.display = "none";
        }
      },
      onShow: function onShow() {
        if (_this2.anchor) {
          _this2.anchor.style.display = "flex";
        }
      }
    }, React.createElement("img", {
      src: brandLogoUrl,
      className: "ui tiny image",
      alt: "brand-logo"
    }));
    var navbarAvatar = React.createElement("div", {
      className: "menu-trigger"
    }, React.createElement(NavbarUserAvatar, {
      initials: userMenu.initials,
      picture: userMenu.picture
    }), userMenu.name);
    var noTabs = tabs.length === 0;
    return React.createElement(StyledNavbarMobile, {
      "data-testid": "navbar-mobile",
      theme: theme
    }, React.createElement(Sidebar.Pushable, null, React.createElement(PrimarySidebar, {
      navbarAvatar: navbarAvatar,
      onSubmenuLinkClick: this.onSubmenuLinkClick,
      tabClass: tabClass,
      tabs: noTabs && userMenu ? userMenu.links : tabs,
      userLinks: !noTabs && userMenu && userMenu.links,
      visible: sidebarPrimaryVisible,
      rightLink: rightLink
    }), React.createElement(SecondarySidebar, {
      onHeaderBackClick: this.onHeaderBackClick,
      tabs: secondaryTabs,
      visible: sidebarSecondaryVisible
    }), React.createElement(Sidebar.Pusher, {
      onClick: this.onPusherClick
    }, React.createElement(Menu, {
      attached: true,
      inverted: true,
      borderless: true
    }, React.createElement(Menu.Item, {
      onClick: this.onToggle
    }, React.createElement(Icon, {
      icon: "Menu-24"
    })), React.createElement(BrandLogo$1, null, React.createElement(BrandLogoLink$1, {
      href: brandLogo.link,
      onClick: brandLogo.onClick,
      "data-testid": "brand-logo",
      ref: function ref(anchor) {
        return _this2.anchor = anchor;
      }
    }, logoImg))), children)));
  };

  return NavbarMobile;
}(Component);

NavbarMobile.propTypes = {
  brandLogo: PropTypes.shape({
    onClick: PropTypes.func,
    link: PropTypes.string
  }).isRequired,
  constrained: PropTypes.bool,
  rightLink: PropTypes.shape({
    href: PropTypes.string,
    title: PropTypes.string
  }),
  theme: PropTypes.object,
  tabClass: PropTypes.func.isRequired,
  tabs: PropTypes.array.isRequired,
  userMenu: PropTypes.shape({
    links: PropTypes.array,
    initials: PropTypes.string,
    picture: PropTypes.string,
    name: PropTypes.string,
    companyName: PropTypes.string
  })
};

function _templateObject$O() {
  var data = _taggedTemplateLiteralLoose(["\n  @media (min-width: 768px) {\n    .main-content {\n      margin-top: 52px;\n      min-height: 100vh;\n    }\n  }\n"]);

  _templateObject$O = function _templateObject() {
    return data;
  };

  return data;
}

var StyledNavbar = styled.div(_templateObject$O());

var Navbar =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Navbar, _Component);

  function Navbar(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleNavbarStandaloneLinkClick = function () {
      _this.setState({
        simpleNavbarDropdowns: false
      });
    };

    _this.handleNavbarDesktopLinkClick = function () {
      _this.setState(function (prevState) {
        return {
          simpleNavbarDropdowns: !prevState.simpleNavbarDropdowns
        };
      });
    };

    _this.handleResponsiveAreaClick = function () {
      _this.setState({
        simpleNavbarDropdowns: false
      });
    };

    _this.tabClass = function (tab) {
      var pathname = window.location.pathname.split("/")[1];
      if (pathname === tab.id) return "navbar-item-active";
    };

    _this.state = {
      simpleNavbarDropdowns: false
    };
    return _this;
  }

  var _proto = Navbar.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        brandLogo = _this$props.brandLogo,
        constrained = _this$props.constrained,
        rightLink = _this$props.rightLink,
        theme = _this$props.theme,
        userMenu = _this$props.userMenu,
        tabs = _this$props.tabs;
    var simpleNavbarDropdowns = this.state.simpleNavbarDropdowns;
    return React.createElement(StyledNavbar, null, React.createElement(Responsive, Responsive.onlyMobile, React.createElement(NavbarMobile, {
      brandLogo: brandLogo,
      rightLink: rightLink,
      tabClass: this.tabClass,
      tabs: tabs,
      theme: theme,
      userMenu: userMenu
    }, React.createElement("div", {
      className: "main-content"
    }, children))), React.createElement(Responsive, {
      minWidth: Responsive.onlyTablet.minWidth,
      onClick: this.handleResponsiveAreaClick
    }, React.createElement(NavbarDesktop, {
      brandLogo: brandLogo,
      constrained: constrained,
      onRightMenuLinkClick: this.handleNavbarStandaloneLinkClick,
      onLeftMenuLinkClick: this.handleNavbarDesktopLinkClick,
      rightLink: rightLink,
      simpleNavbarDropdowns: simpleNavbarDropdowns,
      tabClass: this.tabClass,
      tabs: tabs,
      theme: theme,
      userMenu: userMenu
    }), React.createElement("div", {
      className: "main-content"
    }, children)));
  };

  return Navbar;
}(Component);

var NavbarNotifications = function NavbarNotifications(props) {
  return React.createElement(Notifications, _extends({}, props, {
    offsets: {
      mobile: NAVBAR_HEIGHT_MOBILE,
      desktop: NAVBAR_HEIGHT_DESKTOP
    }
  }));
};

Navbar.Notifications = NavbarNotifications;
Navbar.propTypes = {
  brandLogo: PropTypes.shape({
    onClick: PropTypes.func,
    link: PropTypes.string
  }).isRequired,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    }))
  })).isRequired,
  rightLink: PropTypes.shape({
    title: PropTypes.string,
    href: PropTypes.string
  }),
  userMenu: PropTypes.shape({
    initials: PropTypes.string,
    picture: PropTypes.string,
    name: PropTypes.string,
    companyName: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.node,
      href: PropTypes.string
    }))
  }).isRequired,
  constrained: PropTypes.bool
};
var Navbar$1 = withTheme(Navbar);

function _templateObject$P() {
  var data = _taggedTemplateLiteralLoose(["\n  color: white;\n  border-radius: 16px;\n  background: ", ";\n  font-size: 13px;\n  line-height: 14px;\n  padding: 8px 12px;\n  font-family: ", ";\n}"]);

  _templateObject$P = function _templateObject() {
    return data;
  };

  return data;
}

var StyledTag = styled.span(_templateObject$P(), COLORS.ACTION_COLORS.BLUE_DARKER, FONTS.FONT_FAMILY.DEFAULT);

var Tag =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Tag, _Component);

  function Tag(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Tag.prototype;

  _proto.handleClose = function handleClose() {
    var _this$props = this.props,
        text = _this$props.text,
        id = _this$props.id,
        onClick = _this$props.onClick;
    onClick(text, id || null);
  };

  _proto.renderIcon = function renderIcon() {
    return React.createElement("span", {
      onClick: this.handleClose
    }, "x");
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        style = _this$props2.style,
        icon = _this$props2.icon,
        color = _this$props2.color,
        children = _this$props2.children,
        text = _this$props2.text,
        className = _this$props2.className,
        id = _this$props2.id;
    var colorStyle = {
      backgroundColor: color
    };
    var newStyle = Object.assign({}, style, colorStyle);
    return React.createElement(StyledTag, {
      id: id,
      style: newStyle
    }, text || children, this.renderIcon());
  };

  return Tag;
}(Component);

Tag.propTypes = {
  id: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  icon: PropTypes.string,
  color: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};
Tag.defaultProps = {
  onClick: function onClick() {},
  color: COLORS.ACTION_COLORS.BLUE_DARKER
};

function _templateObject3$i() {
  var data = _taggedTemplateLiteralLoose(["\n  /*margin: 5px;*/\n  display: inline-block;\n  position: relative;\n  padding-left: 26px;\n  line-height: 20px;\n  opacity: ", ";\n}"]);

  _templateObject3$i = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$t() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 18px;\n  height: 18px;\n  margin: 0;\n  -webkit-appearance: none;\n\n  position: relative;\n  background-color: #ffffff;\n  border: solid 1px ", ";\n  border-radius: 2px;\n  cursor: pointer;\n  padding: 1px;\n  position: absolute;\n  left: 0;\n  top: 5px;\n\n  &:checked:after {\n    content: url( ", ");\n    \n    background-color: ", ";\n    border: solid 1px ", ";\n    position: absolute;\n    top: -1px;\n    right: -1px;\n    left: -1px;\n    bottom: -1px;\n    border-radius: 2px;\n  }\n\n  &:checked:focus:after {\n    //for some reason input's outline is 1px higher than the checkbox itself. \n    //This hack makes the checkbox 1px higher in case it is focused, so there's no 1px white line\n    bottom: -2px; \n  }\n}"]);

  _templateObject2$t = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$Q() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-family: ", ";\n  display: flex;\n  align-items: center;\n  padding: 4px 0;\n  position: relative;\n}"]);

  _templateObject$Q = function _templateObject() {
    return data;
  };

  return data;
}

var StyledCheckbox = styled.div(_templateObject$Q(), COLORS.GRAY_COLORS.GRAY_25, FONTS.FONT_FAMILY.DEFAULT);
var StyledInput = styled.input(_templateObject2$t(), COLORS.GRAY_COLORS.GRAY_84, svgList["Checkmark-checkbox"], COLORS.ACTION_COLORS.ONELOGIN_BLUE, COLORS.ACTION_COLORS.ONELOGIN_BLUE);
var StyledLabel = styled.label(_templateObject3$i(), function (props) {
  return props.disabled ? 0.3 : 1;
});

var Checkbox = function Checkbox(_ref) {
  var label = _ref.label,
      id = _ref.id,
      value = _ref.value,
      onChange = _ref.onChange,
      checked = _ref.checked,
      disabled = _ref.disabled;

  var handleChange = function handleChange() {
    !disabled && onChange(id);
  };

  return React.createElement(StyledCheckbox, null, React.createElement(StyledInput, {
    onChange: handleChange,
    id: id,
    value: value,
    type: "checkbox",
    checked: checked,
    disabled: disabled
  }), React.createElement(StyledLabel, {
    htmlFor: id,
    disabled: disabled
  }, React.createElement("span", null, label)));
};

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string.isRequired,
  label: PropTypes.node,
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool
};
Checkbox.defaultProps = {
  onChange: function onChange() {}
};
var AvatarImage$1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8ZGVmcz4KICAgICAgICA8Y2lyY2xlIGlkPSJhIiBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiLz4KICAgICAgICA8cGF0aCBpZD0iYyIgZD0iTTUuMzkyIDExYzEuMDU0LjYzNSAyLjI4OCAxIDMuNjA4IDEgMS4zMiAwIDIuNTU0LS4zNjUgMy42MDgtMUgxM2E1IDUgMCAwIDEgNSA1djJIMHYtMmE1IDUgMCAwIDEgNS01aC4zOTJ6TTkgMTBBNSA1IDAgMSAxIDkgMGE1IDUgMCAwIDEgMCAxMHoiLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjYSIvPgogICAgICAgIDwvbWFzaz4KICAgICAgICA8dXNlIGZpbGw9IiNGM0YzRjQiIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgPGcgbWFzaz0idXJsKCNiKSI+CiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgNikiPgogICAgICAgICAgICAgICAgPG1hc2sgaWQ9ImQiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2MiLz4KICAgICAgICAgICAgICAgIDwvbWFzaz4KICAgICAgICAgICAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2MiLz4KICAgICAgICAgICAgICAgIDxnIG1hc2s9InVybCgjZCkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiM4QjhDOEMiIGQ9Ik0tMzktNDJoOTZ2OTZoLTk2eiIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";

function _templateObject$R() {
  var data = _taggedTemplateLiteralLoose(["\n    background-image: url(", ");\n    width: ", ";\n    height: ", ";\n    background-size: cover;\n    background-position: top center;\n    border-radius: 50%;\n  "]);

  _templateObject$R = function _templateObject() {
    return data;
  };

  return data;
}

var Avatar = function Avatar(_ref) {
  var image = _ref.image,
      size = _ref.size;
  var StyledAvatar = styled.div(_templateObject$R(), image || AvatarImage$1, size, size);
  StyledAvatar.displayName = "StyledAvatar";
  return React.createElement(StyledAvatar, null);
};

Avatar.propTypes = {
  image: PropTypes.string,
  size: PropTypes.string
};
Avatar.defaultProps = {
  image: "",
  size: "36px"
};

function _templateObject4$b() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  content: '';\n  ", "\n  transform: translate", "(-50%);\n  ", "\n"]);

  _templateObject4$b = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$j() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  border-radius: 3px;\n  background-color: white;\n  pointer-events: auto;\n\n  ", "\n\n  ", "\n  box-shadow: 0 0 25px ", ";\n"]);

  _templateObject3$j = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$u() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  pointer-events: none;\n"]);

  _templateObject2$u = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$S() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  outline: none;\n"]);

  _templateObject$S = function _templateObject() {
    return data;
  };

  return data;
}
/** Tooltip Component **
 *
 * This component allows any other component to have a tooltip with customizable location. Accepts these props:
 *
 * - Child (React node): This object is always rendered, and is what the tooltip is rendered relative to
 * - tooltip - (() -> React node): The object to be rendered inside the tooltip area (what effectively IS the tooltip)
 * - open (bool): Determines whether the tooltip is open or not. This component does not maintain its own state, it's
 * -    up to a parent component to manage that.
 * - onFocusLeave (func): When the tooltip is opened, it is also considered focused. When focus leaves the tooltip,
 * -    like when clicking elsewhere on the page, this function is called. Useful for signaling to the parent
 * -    that the tooltip should close
 * - dir ('top' | 'bottom' | 'left' | 'right'): Signals where the tooltip should be rendered relative to the child
 * -    (default is 'bottom')
 * - lean ('up' | 'down' | 'left' | 'right'): This allows the tooltip to be offset, rather than centered. 'left' and
 * -    'right' can only be used when dir is 'top' or 'bottom', and 'up' and 'down' can only be used when dir is
 * -    'left' or 'right'
 * -    (not providing this prop assumes a centered position)
 */


var TRIANGLE_WIDTH = "8px";
var TOOLTIP_MARGIN = "16px";

var getOpposite = function getOpposite(dir) {
  switch (dir) {
    case "left":
      return "right";

    case "right":
      return "left";

    case "up":
    case "top":
      return "bottom";

    case "down":
    case "bottom":
      return "top";

    default:
      return null;
  }
};

var perpendicular = function perpendicular(dir) {
  switch (dir) {
    case "top":
    case "bottom":
      return "left";

    case "left":
    case "right":
      return "top";

    default:
      return null;
  }
};

var getLean = function getLean(_ref) {
  var lean = _ref.lean,
      perp = _ref.perp,
      axis = _ref.axis;

  if (lean !== "center") {
    return getOpposite(lean) + ": 0;";
  }

  return perp + ": 50%; transform: translate" + axis + "(-50%);";
};

var getMarginProps = function getMarginProps(opposite, margin) {
  return opposite + ": 100%; margin-" + opposite + ": " + margin + ";";
};

var getBorderProps = function getBorderProps(perp, dir) {
  return "border-" + perp + ": " + TRIANGLE_WIDTH + " solid transparent; \n   border-" + getOpposite(perp) + ": " + TRIANGLE_WIDTH + " solid transparent;\n   border-" + dir + ": " + TRIANGLE_WIDTH + " solid white;\n   " + perp + ": 50%;";
};

var getOppositeProp = function getOppositeProp(opposite) {
  return opposite + ": calc(100% + " + TOOLTIP_MARGIN + " - " + TRIANGLE_WIDTH + ")";
};

var TooltipWrapper = styled.div(_templateObject$S());
var TooltipSpacer = styled.div(_templateObject2$u());
var TooltipBubble = styled.div(_templateObject3$j(), function (props) {
  return getMarginProps(props.opposite, TOOLTIP_MARGIN);
}, getLean, COLORS.GRAY_COLORS.GRAY_68);
var Tip = styled.div(_templateObject4$b(), function (props) {
  return getBorderProps(props.perp, props.dir);
}, function (props) {
  return props.axis;
}, function (props) {
  return getOppositeProp(props.opposite);
});

var Tooltip =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Tooltip, _Component);

  function Tooltip(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleBodyClick = function (event) {
      var current = _this.tooltipWrapper.current;
      var onFocusLeave = _this.props.onFocusLeave;

      if (onFocusLeave && current && !current.contains(event.target)) {
        onFocusLeave();
      }
    };

    _this.render = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          open = _this$props.open,
          tooltip = _this$props.tooltip,
          dir = _this$props.dir,
          lean = _this$props.lean;
      var opposite = getOpposite(dir);
      var perp = perpendicular(dir);
      var axis = perp === "left" ? "X" : "Y";

      if (!open) {
        return children;
      }

      return React.createElement(TooltipWrapper, {
        ref: _this.tooltipWrapper
      }, children, React.createElement(TooltipSpacer, null, React.createElement(TooltipBubble, {
        dir: dir,
        lean: lean,
        perp: perp,
        opposite: opposite,
        axis: axis
      }, tooltip()), React.createElement(Tip, {
        dir: dir,
        perp: perp,
        opposite: opposite,
        axis: axis
      })));
    };

    _this.tooltipWrapper = createRef();
    return _this;
  }

  var _proto = Tooltip.prototype;

  _proto.componentDidMount = function componentDidMount() {
    document.body.addEventListener("click", this.handleBodyClick, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.body.removeEventListener("click", this.handleBodyClick, false);
  };

  return Tooltip;
}(Component);

Tooltip.propTypes = {
  open: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
  tooltip: PropTypes.func.isRequired,
  onFocusLeave: PropTypes.func,
  dir: PropTypes.string,
  lean: PropTypes.string
};
Tooltip.defaultProps = {
  dir: "top",
  lean: "center"
};
var calling = "Volání";
var cancel = "cancel";
var closeDialog = "Zavřít dialog";
var confirm = "confirm";
var downloadOnAppStore = "Stahování v app store";
var getOnGooglePlay = "Získat na Google Play";
var linkToAppStore = "Odkaz do obchodu App Store";
var linkToGooglePlay = "Odkaz na Google Play";
var revert = "revert";
var csCZ = {
  "198705281": "Vložte kód, který jste dostali SMSkou.",
  "374233718": "Můžete to zkusit znovu za {secLeft, number} {secLeft, plural, one {second} other {seconds}}",
  "437305782": "Nyní se ověřují vaše autentikátory WebAuthn.",
  "505702857": "Kouzelný odkaz",
  "519412053": "Změnit faktor ověření",
  "655462232": "Stáhněte si a nainstalujte OneLogin Protect na vašem zařízení",
  "662924178": "Vypadá to, že dnešek není váš den.",
  "694278426": "Zadejte kód zařízení {deviceName}",
  "694920552": "První bezpečností kód",
  "737192390": "Otevřít {appName}",
  "740457555": "Druhý kód",
  "744377571": "Minimálně {length} znaků",
  "751710530": "Potvrdit",
  "916760408": "Vložte uživatelské jméno a bezpečnostní kód z vašeho zařízení.",
  "921093870": "Neobdrželi jste kód?",
  "1068496829": "Vyberte bezpečnostní otázku {current}/{total}",
  "1079852660": "Vložte dva po sobě jdoucí bezpečnostní kódy",
  "1080736814": "Vložte {fieldName} z aplikace Symantec VIP Access",
  "1136625613": "Proces byl zrušen. Zkuste to znovu nebo použijte jiný faktor ověření.",
  "1242107845": "Zobrazit",
  "1254879564": "Nové heslo",
  "1359200231": "Odeslat",
  "1433651550": "Vložte kód z OneLogin SMS.",
  "1477893598": "Konfigurovat",
  "1536965459": "Stáhněte si a nainstalujte OneLogin Protect na vašem zařízení",
  "1624184662": "Abyste si nastavili OneLogin SMS, pošleme vám aktivační kód SMSkou. Tento aktivační kód budete potřebovat k dokončení registrace zařízení.",
  "1654624862": "Bezpečnostní kód",
  "1833121415": "Vepsat odpověď {current}/{total}",
  "1919587067": "Znovu poslat kód",
  "1935535842": "Vyžadováno",
  "1963245695": "1 velké písmeno",
  "2018264248": "Zkuste to znovu",
  "2091874550": "První kód",
  "2097632732": "Naskenujte místo toho čárový kód",
  "2104438124": "Vložte {fieldName} a dva po sobě jdoucí bezpečnostní kódy ze Symantec VIP Access.",
  "2124363772": "Vložte své uživatelské jméno a bezpečnostní kód ze svého SecurID tokenu.",
  "2229754167": "Zadejte telefonní číslo",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "Skrýt",
  "2606375562": "Vložte váš YubiKey do USB portu a zmáčkněte tlačítko",
  "2663586870": "Uživatelské jméno",
  "2792137744": "1 číslo",
  "2815222727": "Naskenujte tento čárový kód",
  "2859281487": "K zabezpečení vašeho účtu je vyžadováno 2faktorové ověření.",
  "2942752129": "Druhý bezpečnostní kód",
  "3060896801": "Narazili jste na problém?",
  "3286567409": "1 speciální znak",
  "3294346597": "Zkusit znovu",
  "3327626662": "Zadejte potvrzovací kód",
  "3374226769": "Klikněte na Spárovat pomocí manuálního přístupu",
  "3469481929": "Kód nejde naskenovat?",
  "3528672691": "Zrušit",
  "3640052215": "Pokračovat",
  "3645029425": "Naskenujte QR kód níže",
  "3645116517": "Tento kód zadejte, jakmile obdržíte hovor:",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "Další",
  "3737470122": "Další informace vám sdělí správce.",
  "3781468762": "Váš prohlížeč nepodporuje WebAuthn",
  "3827227259": "Potvrzovací kód byl odeslán na",
  "3855542277": "Vložte tento kód do aplikace",
  "3865193889": "Aktivovat",
  "3877285238": "1 malé písmeno",
  "4000449233": "Volá se níže uvedené telefonní číslo:",
  "4072532148": "Znovu odeslat SMS kód",
  "4151518079": "Vybrat bezpečnostní otázku {current} / {total}",
  "4227081527": "Poté, co bude aplikace nainstalována, jděte znovu na tuto obrazovku a klikněte na {action}",
  calling: calling,
  cancel: cancel,
  closeDialog: closeDialog,
  confirm: confirm,
  downloadOnAppStore: downloadOnAppStore,
  getOnGooglePlay: getOnGooglePlay,
  linkToAppStore: linkToAppStore,
  linkToGooglePlay: linkToGooglePlay,
  revert: revert
};
var calling$1 = "Ringer";
var cancel$1 = "cancel";
var closeDialog$1 = "Luk samtale";
var confirm$1 = "confirm";
var downloadOnAppStore$1 = "Download i app-butikken";
var getOnGooglePlay$1 = "Få den på Google Play";
var linkToAppStore$1 = "Link til App Store";
var linkToGooglePlay$1 = "Link til Google Play";
var revert$1 = "revert";
var da = {
  "198705281": "Indtast den kode du modtog på SMS.",
  "374233718": "Du kan prøve igen om {secLeft, number} {secLeft, plural, one {second} other {seconds}}",
  "437305782": "Bekræft dine WebAuthn godkendere nu.",
  "505702857": "Magisk link",
  "519412053": "Skift godkendelsesfaktor",
  "655462232": "Hent og installer OneLogin Protect på din enhed",
  "662924178": "Det ser ud til at det ikke er vores dag i dag.",
  "694278426": "Indtast din {deviceName} kode",
  "694920552": "Første sikkerhedskode",
  "737192390": "Åbn {appName}",
  "740457555": "Anden kode",
  "744377571": "Minimum antal {length} tegn",
  "751710530": "Indsend",
  "916760408": "Indtast et brugernavn og en sikkerhedskode fra din enhed.",
  "921093870": "Har du ikke modtaget koden?",
  "1068496829": "Vælg sikkerhedsspørgsmål {current}/{total}",
  "1079852660": "Indtast to sikkerhedskoder efter hinanden",
  "1080736814": "Indtast {fieldName} fra Symantec VIP Access-appen",
  "1136625613": "Handlingen blev annulleret. Prøv venligst igen eller brug en anden godkendelsesfaktor.",
  "1242107845": "Vis",
  "1254879564": "Ny adgangskode",
  "1359200231": "Send",
  "1433651550": "Indtast koden fra OneLogin SMS.",
  "1477893598": "Konfigurer",
  "1536965459": "Hent og installer OneLogin Protect på din enhed",
  "1624184662": "For at indstille OneLogin SMS vil vi sende dig en aktiveringskode via SMS. Du skal bruge denne aktiveringskode til at fuldføre enhedsregistreringen.",
  "1654624862": "Sikkerhedskode",
  "1833121415": "Oplys svar {current}/{total}",
  "1919587067": "Gensend kode",
  "1935535842": "Påkrævet",
  "1963245695": "1 stort bogstav",
  "2018264248": "Prøv igen",
  "2091874550": "Første kode",
  "2097632732": "Scan stregkode i stedet",
  "2104438124": "Indtast {fieldName} og to sikkerhedskoder efter hinanden fra Symantec VIP Access.",
  "2124363772": "Indtast dit brugernavn og din sikkerhedskode fra dit SecurID-token.",
  "2229754167": "Indtast dit telefonnummer",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "Skjul",
  "2606375562": "Indsæt din YubiKey i USB-porten og tryk på knappen",
  "2663586870": "Brugernavn",
  "2792137744": "1 tal",
  "2815222727": "Scan denne stregkode",
  "2859281487": "2-faktor-godkendelse er påkrævet for at sikre din konto.",
  "2942752129": "Anden sikkerhedskode",
  "3060896801": "Har du problemer?",
  "3286567409": "1 specialtegn",
  "3294346597": "Prøv igen",
  "3327626662": "Indtast din bekræftelseskode",
  "3374226769": "Klik på Par hvis du bruger manuel indtastning",
  "3469481929": "Kan du ikke scanne koden?",
  "3528672691": "Annuller",
  "3640052215": "Fortsæt",
  "3645029425": "Scan nedenstående QR-kode",
  "3645116517": "Indtast denne kode, når du modtager opkaldet:",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "Næste",
  "3737470122": "Kontakt venligst admin for flere detaljer.",
  "3781468762": "Din browser understøtter ikke WebAuthn",
  "3827227259": "En bekræftelseskode er blevet sendt til",
  "3855542277": "Indtast denne kode i appen",
  "3865193889": "Aktiver",
  "3877285238": "1 lille bogstav",
  "4000449233": "Ringer til nedenstående telefonnummer:",
  "4072532148": "Gensend SMS-kode",
  "4151518079": "Vælg sikkerhedsspørgsmål {current} / {total}",
  "4227081527": "Når appen er installeret, skal du komme tilbage til denne skærm og klikke på {action}",
  calling: calling$1,
  cancel: cancel$1,
  closeDialog: closeDialog$1,
  confirm: confirm$1,
  downloadOnAppStore: downloadOnAppStore$1,
  getOnGooglePlay: getOnGooglePlay$1,
  linkToAppStore: linkToAppStore$1,
  linkToGooglePlay: linkToGooglePlay$1,
  revert: revert$1
};
var calling$2 = "Ruft an";
var cancel$2 = "cancel";
var closeDialog$2 = "Dialog schließen";
var confirm$2 = "confirm";
var downloadOnAppStore$2 = "Im App Store herunterladen";
var getOnGooglePlay$2 = "Bei Google Play erhalten";
var linkToAppStore$2 = "Link zum App Store";
var linkToGooglePlay$2 = "Link zu Google Play";
var revert$2 = "revert";
var de = {
  "198705281": "Geben Sie den Code ein, den Sie per SMS erhalten haben.",
  "374233718": "Sie können es in {secLeft, number} {secLeft, plural, one {second} other {seconds}} erneut versuchen",
  "437305782": "Ihre WebAuthn-Authentifikatoren werden jetzt überprüft.",
  "505702857": "Magischer Link",
  "519412053": "Authentifizierungsfaktor ändern",
  "655462232": "Laden Sie OneLogin Protect auf Ihr Gerät herunter und installieren Sie es.",
  "662924178": "Heute scheint nicht Ihr Tag zu sein.",
  "694278426": "Geben Sie Ihren {deviceName}-Code ein",
  "694920552": "Erster Sicherheitscode",
  "737192390": "{appName} starten",
  "740457555": "Zweiter Code",
  "744377571": "Mindestens {length} Zeichen",
  "751710530": "Absenden",
  "916760408": "Geben Sie einen Benutzernamen und einen Sicherheitscode von Ihrem Gerät ein.",
  "921093870": "Sie haben den Code nicht erhalten?",
  "1068496829": "Sicherheitsfrage {current}/{total} auswählen",
  "1079852660": "Geben Sie zwei aufeinanderfolgende Sicherheitscodes ein",
  "1080736814": "Geben Sie {fieldName} aus der App „Symantec VIP Access” ein",
  "1136625613": "Der Vorgang wurde abgebrochen. Bitte versuchen Sie es erneut oder verwenden Sie einen anderen Authentifizierungsfaktor.",
  "1242107845": "Zeigen",
  "1254879564": "Neues Passwort",
  "1359200231": "Senden",
  "1433651550": "Geben Sie den Code von OneLogin SMS ein.",
  "1477893598": "Konfigurieren",
  "1536965459": "Laden Sie OneLogin Protect auf Ihr Gerät herunter und installieren Sie es.",
  "1624184662": "Wir schicken Ihnen zum Einrichten von OneLogin SMS eine SMS mit einem Aktivierungscode. Diesen Aktivierungscode brauchen Sie, um die Registrierung des Gerätes abzuschließen.",
  "1654624862": "Sicherheitscode",
  "1833121415": "Antwort {current}/{total} eingeben",
  "1919587067": "Code erneut senden",
  "1935535842": "Erforderlich",
  "1963245695": "1 Großbuchstabe",
  "2018264248": "Erneut versuchen",
  "2091874550": "Erster Code",
  "2097632732": "Stattdessen Barcode scannen",
  "2104438124": "Geben Sie {fieldName} und zwei aufeinanderfolgende Sicherheitscodes aus Symantec VIP Access ein.",
  "2124363772": "Geben Sie Ihren Benutzernamen und Sicherheitscode aus Ihrem SecurID-Token ein.",
  "2229754167": "Geben Sie Ihre Telefonnummer ein",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "Ausblenden",
  "2606375562": "Stecken Sie Ihren YubiKey in den USB-Anschluss und drücken Sie die Taste",
  "2663586870": "Benutzername",
  "2792137744": "1 Zahl",
  "2815222727": "Diesen Barcode scannen",
  "2859281487": "Zum Sichern Ihres Kontos ist die Zwei-Faktor-Authentifizierung erforderlich.",
  "2942752129": "Zweiter Sicherheitscode",
  "3060896801": "Haben Sie Schwierigkeiten?",
  "3286567409": "1 Sonderzeichen",
  "3294346597": "Erneut versuchen",
  "3327626662": "Geben Sie Ihren Bestätigungscode ein",
  "3374226769": "Klicken Sie per manueller Eingabe auf „Koppeln”.",
  "3469481929": "Sie können den Code nicht scannen?",
  "3528672691": "Abbrechen",
  "3640052215": "Fortfahren",
  "3645029425": "Scannen Sie den untenstehenden QR-Code",
  "3645116517": "Geben Sie diesen Code ein, wenn Sie den Anruf erhalten:",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "Weiter",
  "3737470122": "Bitte wenden Sie sich für weitere Informationen an den Administrator.",
  "3781468762": "Ihr Browser unterstützt WebAuthn nicht",
  "3827227259": "Ein Bestätigungscode wurde gesendet an",
  "3855542277": "Geben Sie diesen Code in die App ein",
  "3865193889": "Aktivieren",
  "3877285238": "1 Kleinbuchstabe",
  "4000449233": "Die folgende Telefonnummer wird angerufen:",
  "4072532148": "SMS-Code erneut senden",
  "4151518079": "Sicherheitsfrage {current} / {total} auswählen",
  "4227081527": "Kehren Sie zu diesem Bildschirm zurück, wenn die App installiert ist, und klicken Sie auf {action}.",
  calling: calling$2,
  cancel: cancel$2,
  closeDialog: closeDialog$2,
  confirm: confirm$2,
  downloadOnAppStore: downloadOnAppStore$2,
  getOnGooglePlay: getOnGooglePlay$2,
  linkToAppStore: linkToAppStore$2,
  linkToGooglePlay: linkToGooglePlay$2,
  revert: revert$2
};
var calling$3 = "Calling";
var cancel$3 = "cancel";
var closeDialog$3 = "Close dialog";
var confirm$3 = "confirm";
var downloadOnAppStore$3 = "Download on the app store";
var getOnGooglePlay$3 = "Get it on Google Play";
var linkToAppStore$3 = "Link to App Store";
var linkToGooglePlay$3 = "Link to Google Play";
var revert$3 = "revert";
var en = {
  "198705281": "Enter the code you received in SMS.",
  "374233718": "You can try again in {secLeft, number} {secLeft, plural, one {second} other {seconds}}",
  "437305782": "Verifying your WebAuthn authenticators now.",
  "505702857": "Magic Link",
  "519412053": "Change Authentication Factor",
  "655462232": "Download and instal OneLogin Protect on you device",
  "662924178": "Looks like today isn’t our day.",
  "694278426": "Enter your {deviceName} code",
  "694920552": "First Security Code",
  "737192390": "Open {appName}",
  "740457555": "Second Code",
  "744377571": "Minimum {length} characters",
  "751710530": "Submit",
  "916760408": "Enter a username and security code from your device.",
  "921093870": "Haven't recieved the code?",
  "1068496829": "Select Security Question {current}/{total}",
  "1079852660": "Enter two consecutive Security Codes",
  "1080736814": "Enter {fieldName} from the Symantec VIP Access app",
  "1136625613": "The process was cancelled. Please try again or use another authentication factor.",
  "1242107845": "Show",
  "1254879564": "New Password",
  "1359200231": "Send",
  "1433651550": "Enter the code from OneLogin SMS.",
  "1477893598": "Configure",
  "1536965459": "Download and install OneLogin Protect on your device",
  "1624184662": "To setup OneLogin SMS we are going to send you an activation code via SMS. You will need this activation code to complete device registration.",
  "1654624862": "Security Code",
  "1833121415": "Provide Answer {current}/{total}",
  "1919587067": "Resend code",
  "1935535842": "Required",
  "1963245695": "1 Uppercase",
  "2018264248": "Try Again",
  "2091874550": "First Code",
  "2097632732": "Scan barcode instead",
  "2104438124": "Enter {fieldName} and two consecutive Security Codes from Symantec VIP Access.",
  "2124363772": "Enter your username and security code from your SecurID token.",
  "2229754167": "Enter your phone number",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "Hide",
  "2606375562": "Insert your YubiKey in the USB port and press the button",
  "2663586870": "Username",
  "2792137744": "1 number",
  "2815222727": "Scan this barcode",
  "2859281487": "2-factor authentication is required to secure your account.",
  "2942752129": "Second Security Code",
  "3060896801": "Having trouble?",
  "3286567409": "1 special character",
  "3294346597": "Try again",
  "3327626662": "Enter your confirmation code",
  "3374226769": "Click Pair using manual entry",
  "3469481929": "Can't scan the code?",
  "3528672691": "Cancel",
  "3640052215": "Continue",
  "3645029425": "Scan below QR Code",
  "3645116517": "Enter this code when receiving the call:",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "Next",
  "3737470122": "Please contact admin for more information.",
  "3781468762": "Your browser doesn't support WebAuthn",
  "3827227259": "A confirmation code was sent to",
  "3855542277": "Enter this code into the app",
  "3865193889": "Activate",
  "3877285238": "1 lowercase",
  "4000449233": "Calling the below phone number:",
  "4072532148": "Resend SMS code",
  "4151518079": "Select Security Question {current} / {total}",
  "4227081527": "When the app is installed, come back to this screen and click {action}",
  calling: calling$3,
  cancel: cancel$3,
  closeDialog: closeDialog$3,
  confirm: confirm$3,
  downloadOnAppStore: downloadOnAppStore$3,
  getOnGooglePlay: getOnGooglePlay$3,
  linkToAppStore: linkToAppStore$3,
  linkToGooglePlay: linkToGooglePlay$3,
  revert: revert$3
};
var calling$4 = "Llamando";
var cancel$4 = "cancel";
var closeDialog$4 = "Cerrar diálogo";
var confirm$4 = "confirm";
var downloadOnAppStore$4 = "Descargar en la tienda de aplicaciones";
var getOnGooglePlay$4 = "Consígala en Google Play";
var linkToAppStore$4 = "Enlace a App Store";
var linkToGooglePlay$4 = "Enlace a Google Play";
var revert$4 = "revert";
var es = {
  "198705281": "Escribe el código que recibiste por SMS.",
  "374233718": "Puede intentar de nuevo en {secLeft, number} {secLeft, plural, one {second} other {seconds}}",
  "437305782": "Verificando sus autenticadores WebAuthn en este momento.",
  "505702857": "Enlace mágico",
  "519412053": "Cambiar factor de autenticación",
  "655462232": "Descarga e instala OneLogin Protect en tu dispositivo",
  "662924178": "Parece que hoy no es nuestro día.",
  "694278426": "Ingrese el código de su {deviceName}",
  "694920552": "Primer código de seguridad",
  "737192390": "Abrir {appName}",
  "740457555": "Segundo código",
  "744377571": "Mínimo {length} caracteres",
  "751710530": "Enviar",
  "916760408": "Ingresa un nombre de usuario y código de seguridad desde tu dispositivo.",
  "921093870": "¿No has recibido el código?",
  "1068496829": "Elige una pregunta de seguridad {current}/{total}",
  "1079852660": "Ingresa dos códigos de seguridad consecutivos",
  "1080736814": "Ingresa {fieldName} desde la aplicación de Acceso VIP de Symantec",
  "1136625613": "El proceso fue cancelado. Por favor inténtelo de nuevo o utilice otro factor de autenticación.",
  "1242107845": "Mostrar",
  "1254879564": "Nueva contraseña",
  "1359200231": "Enviar",
  "1433651550": "Ingresa el código desde el SMS de OneLogin",
  "1477893598": "Configurar",
  "1536965459": "Descarga e instala OneLogin Protect en tu dispositivo",
  "1624184662": "Para instalar OneLogin SMS te enviaremos un código de activación vía SMS. Necesitarás este código de activación para completar el registro del dispositivo.",
  "1654624862": "Código de seguridad",
  "1833121415": "Responder {current}/{total}",
  "1919587067": "Reenviar código",
  "1935535842": "Requerido",
  "1963245695": "1 mayúscula",
  "2018264248": "Intentar de nuevo",
  "2091874550": "Primer código",
  "2097632732": "Prefiero escanear código de barras",
  "2104438124": "Ingresa {fieldName} y dos códigos de seguridad consecutivos desde el Acceso VIP de Symantec.",
  "2124363772": "Ingresa tu nombre de usuario y código de seguridad desde tu autentificador SecurID.",
  "2229754167": "Ingrese su número de teléfono",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "Ocultar",
  "2606375562": "Inserta tu YubiKey en el puerto USB y oprime el botón",
  "2663586870": "Nombre de usuario",
  "2792137744": "1 número",
  "2815222727": "Escanear este código de barras",
  "2859281487": "Se requiere de autenticación de 2 factores para proteger tu cuenta.",
  "2942752129": "Segundo código de seguridad",
  "3060896801": "¿Estás teniendo problemas?",
  "3286567409": "1 caracter especial",
  "3294346597": "Intentar de nuevo",
  "3327626662": "Ingrese su código de confirmación",
  "3374226769": "Haz clic en Emparejar usando la entrada manual",
  "3469481929": "¿No puedes escanear el código?",
  "3528672691": "Cancelar",
  "3640052215": "Continuar",
  "3645029425": "Escanea el código QR de abajo",
  "3645116517": "Ingrese este código al recibir la llamada:",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "Siguiente",
  "3737470122": "Por favor contacte al administrador para más información.",
  "3781468762": "Su navegador no soporta WebAuthn",
  "3827227259": "Un código de autenticación fue enviado a",
  "3855542277": "Ingresa este código en la aplicación",
  "3865193889": "Activar",
  "3877285238": "1 minúscula",
  "4000449233": "Llamando al siguiente número:",
  "4072532148": "Reenviar código SMS",
  "4151518079": "Elige una pregunta de seguridad {current} / {total}",
  "4227081527": "Cuando la aplicación esté instalada, regresa a esta pantalla y haz clic {action}",
  calling: calling$4,
  cancel: cancel$4,
  closeDialog: closeDialog$4,
  confirm: confirm$4,
  downloadOnAppStore: downloadOnAppStore$4,
  getOnGooglePlay: getOnGooglePlay$4,
  linkToAppStore: linkToAppStore$4,
  linkToGooglePlay: linkToGooglePlay$4,
  revert: revert$4
};
var calling$5 = "Appel en cours";
var cancel$5 = "cancel";
var closeDialog$5 = "Fermer la boîte de dialogue";
var confirm$5 = "confirm";
var downloadOnAppStore$5 = "Télécharger dans l'App Store";
var getOnGooglePlay$5 = "Disponible sur Google Play";
var linkToAppStore$5 = "Lien vers l'App Store";
var linkToGooglePlay$5 = "Lien vers Google Play";
var revert$5 = "revert";
var fr = {
  "198705281": "Entrez le code que vous avez reçu par SMS.",
  "374233718": "Vous pourrez réessayer dans {secondes restantes, nombre} {secondes restantes, pluriel, une {seconde} autrement {secondes}}",
  "437305782": "Vérification de vos authentificateurs WebAuthn en cours.",
  "505702857": "Lien magique",
  "519412053": "Modifier le facteur d'authentification",
  "655462232": "Téléchargez et installez OneLogin Protect sur votre appareil.",
  "662924178": "On dirait qu'aujourd'hui n'est pas notre jour.",
  "694278426": "Veuillez saisir votre code {nom de l'appareil}",
  "694920552": "Premier code de sécurité",
  "737192390": "Ouvrir {appName}",
  "740457555": "Second code",
  "744377571": "{length} minimum de caractères",
  "751710530": "Soumettre",
  "916760408": "Entrez un nom d'utilisateur et un code de sécurité depuis votre appareil.",
  "921093870": "Vous n'avez pas reçu le code ?",
  "1068496829": "Sélectionnez la Question de sécurité {current}/{total}.",
  "1079852660": "Entrez deux codes de sécurité consécutifs",
  "1080736814": "Entrez {fieldName} depuis l'application Symantec VIP Access.",
  "1136625613": "Le processus a été annulé. Veuillez réessayer ou utiliser un autre facteur d'authentification.",
  "1242107845": "Afficher",
  "1254879564": "Nouveau mot de passe",
  "1359200231": "Envoyer",
  "1433651550": "Entrez le code depuis OneLogin SMS.",
  "1477893598": "Configurer",
  "1536965459": "Téléchargez et installez OneLogin Protect sur votre appareil.",
  "1624184662": "Pour configurer OneLogin SMS, nous allons vous envoyer un code d'activation par SMS. Vous aurez besoin de ce code d'activation pour compléter l'enregistrement de l'appareil.",
  "1654624862": "Code de sécurité",
  "1833121415": "Fournir la réponse {current}/{total}.",
  "1919587067": "Renvoyer le code",
  "1935535842": "Requis",
  "1963245695": "1 majuscule",
  "2018264248": "Réessayer",
  "2091874550": "Premier code",
  "2097632732": "Scanner le code-barres à la place",
  "2104438124": "Entrez {fieldName} et deux codes de sécurité consécutifs depuis Symantec VIP Access.",
  "2124363772": "Entrez votre nom d'utilisateur et le code de sécurité de votre jeton SecurID.",
  "2229754167": "Veuillez saisir votre numéro de téléphone",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "Cacher",
  "2606375562": "Insérez votre YubiKey dans le port USB et appuyez sur le bouton.",
  "2663586870": "Nom d'utilisateur",
  "2792137744": "1 numéro",
  "2815222727": "Scanner ce code-barres",
  "2859281487": "Une authentification à 2 facteurs est nécessaire pour sécuriser votre compte.",
  "2942752129": "Second code de sécurité",
  "3060896801": "Vous avez des problèmes ?",
  "3286567409": "1 caractère spécial",
  "3294346597": "Essayer à nouveau",
  "3327626662": "Veuillez saisir votre code de confirmation",
  "3374226769": "Cliquez sur Appairer en utilisant la saisie manuelle.",
  "3469481929": "Vous ne pouvez pas scanner le code ?",
  "3528672691": "Annuler",
  "3640052215": "Continuer",
  "3645029425": "Scanner sous le QR Code",
  "3645116517": "Veuillez saisir le code suivant au moment de recevoir l'appel :",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "Suivant",
  "3737470122": "Veuillez contacter l'administrateur pour plus d'informations.",
  "3781468762": "Votre navigateur ne supporte pas WebAuthn",
  "3827227259": "Un code de confirmation a été envoyé à",
  "3855542277": "Entrez ce code dans l'application",
  "3865193889": "Activer",
  "3877285238": "1 minuscule",
  "4000449233": "Appel du numéro de téléphone suivant en cours :",
  "4072532148": "Renvoyer le code SMS",
  "4151518079": "Sélectionner la question de sécurité {current} / {total}.",
  "4227081527": "Lorsque l'application est installée, revenez à cet écran et cliquez sur {action}.",
  calling: calling$5,
  cancel: cancel$5,
  closeDialog: closeDialog$5,
  confirm: confirm$5,
  downloadOnAppStore: downloadOnAppStore$5,
  getOnGooglePlay: getOnGooglePlay$5,
  linkToAppStore: linkToAppStore$5,
  linkToGooglePlay: linkToGooglePlay$5,
  revert: revert$5
};
var calling$6 = "Hívás";
var cancel$6 = "cancel";
var closeDialog$6 = "Párbeszédablak bezárása";
var confirm$6 = "confirm";
var downloadOnAppStore$6 = "Töltse le az App Store-ból";
var getOnGooglePlay$6 = "Szerezze be Google Play-en";
var linkToAppStore$6 = "Link az App Store-hoz";
var linkToGooglePlay$6 = "Link a Google Play-hez";
var revert$6 = "revert";
var huHU = {
  "198705281": "Írd be az SMS-ben kapott kódot.",
  "374233718": "{secLeft, number} {secLeft, plural, one {second} other {seconds}} múlva újrapróbálhatja",
  "437305782": "Ellenőrizzük a WebAuthn hitelesítőit.",
  "505702857": "Mágikus Hivatkozás",
  "519412053": "Hitelesítési Faktor Változtatása",
  "655462232": "Töltsd le és telepítsd készülékedre a OneLogin Protect-et",
  "662924178": "Ügy tűnik ez nem a te napod.",
  "694278426": "Írja be a(z) {deviceName} kódot",
  "694920552": "Első Biztonsági Kód",
  "737192390": "{appName} megnyitása",
  "740457555": "Második Kód",
  "744377571": "Legkevesebb {length} karakter",
  "751710530": "Beküldés",
  "916760408": "Írj be egy felhasználónevet és biztonsági kódot készülékedről.",
  "921093870": "Nem kaptad meg a kódot?",
  "1068496829": "Válassz Biztonsági Kérdést {current}/{total}",
  "1079852660": "Írj be 2 egymást követő Biztonsági Kódot",
  "1080736814": "Írd be a {fieldName} mezőt a Symantec VIP Access alkalmazásból",
  "1136625613": "A folyamat megszakadt. Kérjük, próbálja újra, vagy használjon másik hitelesítési tényezőt.",
  "1242107845": "Mutat",
  "1254879564": "Új Jelszó",
  "1359200231": "Küldés",
  "1433651550": "Írd be a kódot a OneLogin SMS-ből.",
  "1477893598": "Konfigurálás",
  "1536965459": "Töltsd le és telepítsd készülékedre a OneLogin Protect-et",
  "1624184662": "A OneLogin SMS beállításához egy aktiváló kódot küldünk neked SMS-ben. A készülék regisztrációjához szükséged lesz erre a kódra.",
  "1654624862": "Biztonsági Kód",
  "1833121415": "Válaszolj  {current}/{total}",
  "1919587067": "Kód újraküldése",
  "1935535842": "Kötelező",
  "1963245695": "1 Nagybetű",
  "2018264248": "Próbálja újból",
  "2091874550": "Első Kód",
  "2097632732": "Olvasd be a vonalkódot helyette",
  "2104438124": "Írd be a {fieldName} mezőt és két egymást követő Biztonsági Kódot a Symantec VIP Access-ből.",
  "2124363772": "Írd be a felhasználónevedet és biztonsági kódodat a SecureID token-ből.",
  "2229754167": "Írja be telefonszámát",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "Elrejt",
  "2606375562": "Helyezd a YubiKey-t az USB portba és nyomd meg a gombot.",
  "2663586870": "Felhasználónév",
  "2792137744": "1 szám",
  "2815222727": "Olvasd be ezt a vonalkódot",
  "2859281487": "Kétfaktoros hitelesítésre van szükség a fiókod megvédéséhez.",
  "2942752129": "Második Biztonsági Kód",
  "3060896801": "Problémád akadt?",
  "3286567409": "1 speciális karakter",
  "3294346597": "Próbáld újra",
  "3327626662": "Írja be a megerősítő kódot",
  "3374226769": "Kattints a Párosítás manuális beírással- ra",
  "3469481929": "Nem tudod beolvasni a kódot?",
  "3528672691": "Mégse",
  "3640052215": "Folytatás",
  "3645029425": "Olvasd be alább a QR-kódot",
  "3645116517": "A hívás fogadásakor írja be ezt a kódot:",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "Következő",
  "3737470122": "További információért forduljon a rendszergazdához.",
  "3781468762": "A böngészője nem támogatja a WebAuthn szolgáltatást",
  "3827227259": "Megerősítő kódot küldtünk a következő címre:",
  "3855542277": "Add meg ezt a kódot az alkalmazásban",
  "3865193889": "Aktiválás",
  "3877285238": "1 kisbetű",
  "4000449233": "Az alábbi telefonszám hívása:",
  "4072532148": "SMS kód újraküldése",
  "4151518079": "Válassz Biztonsági Kérdést {current}/{total}",
  "4227081527": "Amikor telepítetted az alkalmazást, térj vissza erre a képernyőre, és kattints a {action} műveletre.",
  calling: calling$6,
  cancel: cancel$6,
  closeDialog: closeDialog$6,
  confirm: confirm$6,
  downloadOnAppStore: downloadOnAppStore$6,
  getOnGooglePlay: getOnGooglePlay$6,
  linkToAppStore: linkToAppStore$6,
  linkToGooglePlay: linkToGooglePlay$6,
  revert: revert$6
};
var calling$7 = "Sta chiamando";
var cancel$7 = "cancel";
var closeDialog$7 = "Chiudere dialogo";
var confirm$7 = "confirm";
var downloadOnAppStore$7 = "Scarica dall'App Store";
var getOnGooglePlay$7 = "Ottienilo su Google Play";
var linkToAppStore$7 = "Link di App Store";
var linkToGooglePlay$7 = "Link di Google Play";
var revert$7 = "revert";
var it = {
  "198705281": "Inserisci il codice ricevuto tramite SMS.",
  "374233718": "Puoi ritentare fra {secLeft, number} {secLeft, plural, one {second} altri {seconds}}",
  "437305782": "Sta verificando i tuoi autenticatori WebAuthn.",
  "505702857": "Link Magico",
  "519412053": "Cambia Fattore di Autenticazione",
  "655462232": "Scarica e Installa OneLogin Protect sul tuo dispositivo",
  "662924178": "Sembra che oggi non sia la nostra giornata.",
  "694278426": "Inserisci il codice del {deviceName}",
  "694920552": "Primo Codice di Sicurezza",
  "737192390": "Apri {appName}",
  "740457555": "Secondo Codice",
  "744377571": "Almeno {length} caratteri",
  "751710530": "Invia",
  "916760408": "Inserisci un nome utente e un codice di sicurezza dal tuo dispositivo.",
  "921093870": "Non hai ricevuto il codice?",
  "1068496829": "Scegli una Domanda di Sicurezza {current}/{total}",
  "1079852660": "Inserisci due Codici di Sicurezza consecutivi",
  "1080736814": "Inserisci {fieldName} dall'app di Accesso Symantec VIP",
  "1136625613": "L'operazione è stata annullata. Ritenta o utilizza un altro fattore di autenticazione.",
  "1242107845": "Mostra",
  "1254879564": "Nuova Password",
  "1359200231": "Invia",
  "1433651550": "Inserisci il codice dell'SMS OneLogin .",
  "1477893598": "Configura",
  "1536965459": "Scarica e Installa OneLogin Protect sul tuo dispositivo",
  "1624184662": "Per impostare OneLogin SMS ti invieremo un codice di attivazione tramite SMS. Questo codice di attivazione ti servirà per completare la registrazione del dispositivo.",
  "1654624862": "Codice di Sicurezza",
  "1833121415": "Fornisci una Risposta {current}/{total}",
  "1919587067": "Invia nuovamente il Codice",
  "1935535842": "Richiesto",
  "1963245695": "1 Maiuscola",
  "2018264248": "Ritenta",
  "2091874550": "Primo Codice",
  "2097632732": "Opta per la scansione del codice a barre",
  "2104438124": "Inserisci {fieldName} e due Codici di Sicurezza consecutivi dall'Accesso Symantec VIP.",
  "2124363772": "Inserisci il tuo nome utente e il tuo codice di sicurezza dal tuo voucher SecurID.",
  "2229754167": "Inserisci il tuo numero di telefono",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "Nascondi",
  "2606375562": "Inserisci la tua YubiKey nella porta USB e premi il tasto",
  "2663586870": "Nome Utente",
  "2792137744": "1 numero",
  "2815222727": "Scansiona questo codice a barre",
  "2859281487": "Si richiede un'autenticazione a 2 fattori per mettere il tuo account in sicurezza.",
  "2942752129": "Secondo Codice di Sicurezza",
  "3060896801": "Stai avendo problemi?",
  "3286567409": "1 carattere speciale",
  "3294346597": "Riprova",
  "3327626662": "Inserisci il tuo codice di conferma",
  "3374226769": "Clicca Paio usando l'inserimento manuale",
  "3469481929": "Non riesci a scansionare il codice?",
  "3528672691": "Annulla",
  "3640052215": "Continua",
  "3645029425": "Scansiona il Codice QR in basso",
  "3645116517": "Inserisci questo codice quando ricevi la chiamata:",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "Prossimo",
  "3737470122": "Contatta l'amministratore per ulteriori informazioni.",
  "3781468762": "Il tuo browser non supporta WebAuthn",
  "3827227259": "È stato inviato un codice di conferma a",
  "3855542277": "Inserisci questo codice nell'app",
  "3865193889": "Attiva",
  "3877285238": "1 minuscola",
  "4000449233": "Sta chiamando il numero di telefono qui sotto:",
  "4072532148": "Invia nuovamente il codice SMS",
  "4151518079": "Scegli Domanda di Sicurezza {current} / {total}",
  "4227081527": "Una volta installata l'app, ritorna su questa schermata e clicca {action}",
  calling: calling$7,
  cancel: cancel$7,
  closeDialog: closeDialog$7,
  confirm: confirm$7,
  downloadOnAppStore: downloadOnAppStore$7,
  getOnGooglePlay: getOnGooglePlay$7,
  linkToAppStore: linkToAppStore$7,
  linkToGooglePlay: linkToGooglePlay$7,
  revert: revert$7
};
var calling$8 = "呼び出し中";
var cancel$8 = "cancel";
var closeDialog$8 = "ダイアログを閉じる";
var confirm$8 = "confirm";
var downloadOnAppStore$8 = "app storeでダウンロード";
var getOnGooglePlay$8 = "Google Playで入手";
var linkToAppStore$8 = "App Storeへのリンク";
var linkToGooglePlay$8 = "Google Playへのリンク";
var revert$8 = "revert";
var ja = {
  "198705281": "SMSに届いたコードを入力して下さい",
  "374233718": "{secLeft, number} {secLeft, plural, one {second} other {seconds}}で再試行できます",
  "437305782": "WebAuthn認証コードを確認しています。",
  "505702857": "マジックリンク",
  "519412053": "認証要素の変更",
  "655462232": "OneLogin Protectをあなたのデバイスに、ダウンロードしてインストールしましょう",
  "662924178": "何か問題が発生しているようです。",
  "694278426": "{deviceName}コードを入力してください",
  "694920552": "最初のセキュリティーコード",
  "737192390": "{appName}を開く",
  "740457555": "セカンドコード",
  "744377571": "最低 {length} 文字",
  "751710530": "提出",
  "916760408": "あなたのデバイスから、ユーザーネームとセキュリティーコードを入力してください",
  "921093870": "コードが届いていませんか？",
  "1068496829": "セキュリティーの質問を選択{current}/{total}",
  "1079852660": "2つの連続するセキュリティーコードを入力してください",
  "1080736814": "Symantec VIP Accessアプリから、 {fieldName}を入力してください",
  "1136625613": "このプロセスはキャンセルされました。再試行するか、別の認証要素を使用してください。",
  "1242107845": "表示",
  "1254879564": "新しいパスワード",
  "1359200231": "送信",
  "1433651550": "OneLogin SMSからコードを入力してください。",
  "1477893598": "設定",
  "1536965459": "あなたのデバイスに、OneLogin Protectをダウンロードしてインストールしてください",
  "1624184662": "OneLogin SMSを設定するために、SMSでアクティベーションコードを送信します。 デバイスの登録を完了するには、このアクティベーションコードが必要です。",
  "1654624862": "セキュリティーコード",
  "1833121415": "答えを入力 {current}/{total}",
  "1919587067": "コードを再送信",
  "1935535842": "必要な",
  "1963245695": "大文字1つ",
  "2018264248": "再試行する",
  "2091874550": "最初のコード",
  "2097632732": "代わりにバーコードをスキャン",
  "2104438124": "Symantec VIP Accessから、{fieldName}と、2つの連続するセキュリティコードを入力してください。",
  "2124363772": "SecurIDトークンから、ユーザーネームとセキュリティーコードを入力してください",
  "2229754167": "電話番号を入力してください",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "隠す",
  "2606375562": "USBポートにYubiKeyを挿入し、ボタンを押してください",
  "2663586870": "ユーザーネーム",
  "2792137744": "数字1つ",
  "2815222727": "このバーコードをスキャン",
  "2859281487": "アカウントを保護するために、2要素認証が必要です。",
  "2942752129": "2つ目のセキュリティーコード",
  "3060896801": "問題が生じていますか？",
  "3286567409": "特殊文字1つ",
  "3294346597": "もう一度試す",
  "3327626662": "確認コードを入力してください",
  "3374226769": "マニュアル入力で「ペアリング」をクリック",
  "3469481929": "コードがスキャンできませんか？",
  "3528672691": "キャンセル",
  "3640052215": "続行",
  "3645029425": "下のQRコードをスキャン",
  "3645116517": "着信時に次のコードを入力してください：",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "次",
  "3737470122": "詳細については、管理者にお問い合わせください。",
  "3781468762": "お使いのブラウザはWebAuthnをサポートしていません",
  "3827227259": "確認コードの送信先",
  "3855542277": "アプリにこのコードを入力してください",
  "3865193889": "アクティブにする",
  "3877285238": "小文字1つ",
  "4000449233": "下記の電話番号に電話しています：",
  "4072532148": "SMSコードを再送信",
  "4151518079": "セキュリティーの質問を選択{current} / {total}",
  "4227081527": "アプリがインストールされたら、この画面に戻り、{action}をクリックしてください。",
  calling: calling$8,
  cancel: cancel$8,
  closeDialog: closeDialog$8,
  confirm: confirm$8,
  downloadOnAppStore: downloadOnAppStore$8,
  getOnGooglePlay: getOnGooglePlay$8,
  linkToAppStore: linkToAppStore$8,
  linkToGooglePlay: linkToGooglePlay$8,
  revert: revert$8
};
var calling$9 = "전화하기";
var cancel$9 = "cancel";
var closeDialog$9 = "대화 닫기";
var confirm$9 = "confirm";
var downloadOnAppStore$9 = "앱 스토어에서 다운로드";
var getOnGooglePlay$9 = "Google Play에서 받기";
var linkToAppStore$9 = "앱 스토어로 연결";
var linkToGooglePlay$9 = "Google Play로 연결";
var revert$9 = "revert";
var ko = {
  "198705281": "SMS에서 받으신 코드를 입력하십시오.",
  "374233718": "{secLeft, number} {secLeft, plural, one {second} other {seconds}}에서 다시 시도할 수 있습니다",
  "437305782": "지금 WebAuthn 인증 부호 확인 중입니다.",
  "505702857": "매직 링크",
  "519412053": "인증 요인 변경",
  "655462232": "OneLogin Protect를 장치에 다운로드후 설치하십시오.",
  "662924178": "오늘은 운좋은 날 같진 않군요.",
  "694278426": "{deviceName} 코드를 입력하세요",
  "694920552": "첫번째 보안 코드",
  "737192390": "열기 {appName}",
  "740457555": "두번째 코드",
  "744377571": "최소 {length} 글자",
  "751710530": "제출하기",
  "916760408": "사명자명과 장치에서 받은 보안 코드를 입력하십시오.",
  "921093870": "코드 못 받으셨나요?",
  "1068496829": "보안 질문을 선택하세요 {current}/{total}",
  "1079852660": "두개의 연속된 보안 코드를 입력하세요",
  "1080736814": "Symantec VIP Access 앱에서 {fieldName} 를 입력하세요",
  "1136625613": "해당 과정이 취소되었습니다. 다시 시도하시거나 다른 인증 요소를 사용하세요.",
  "1242107845": "보이기",
  "1254879564": "새로운 비밀번호",
  "1359200231": "보내기",
  "1433651550": "OneLogin SMS에서 받은 코드를 입력하세요.",
  "1477893598": "환경 설정",
  "1536965459": "OneLogin Protect를 장치에 다운로드하고 설치하기",
  "1624184662": "OneLogin SMS를 설정을 위해 SMS를 통해 활성화코드를 보내드립니다. 장치 등록을 완성하시려면 이 활성화 코드가 필요합니다.",
  "1654624862": "보안 코드",
  "1833121415": "답변 제공하기 {current}/{total}",
  "1919587067": "코드 다시 보내기",
  "1935535842": "필수",
  "1963245695": "1개의 대문자",
  "2018264248": "다시 시도하세요",
  "2091874550": "첫번째 코드",
  "2097632732": "대신 바코드 스캔하기",
  "2104438124": "{fieldName}와 Symantec VIP Access에 있는 두개의 연속 보안카드를 입력하십시오.",
  "2124363772": "사용자명과 SecurID 토큰에서의 보안 코드를 입력하십시오.",
  "2229754167": "전화번호를 입력하세요",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "숨기기",
  "2606375562": "USB 포트에 YubiKey를 삽입하시고 버튼을 누르십시오",
  "2663586870": "사용자명",
  "2792137744": "1개의 숫자",
  "2815222727": "이 바코드를 스캔하기",
  "2859281487": "계정 보안을 위해 이중(2-factor) 인증이 필요합니다.",
  "2942752129": "두번째 보안 코드",
  "3060896801": "문제가 있으신가요?",
  "3286567409": "1개의 특수문자",
  "3294346597": "다시 시도하세요",
  "3327626662": "확인 코드를 입력하세요",
  "3374226769": "수동 입력을 사용한 페어(Pair) 클릭하기",
  "3469481929": "코드 스캔이 안되세요?",
  "3528672691": "취소하기",
  "3640052215": "계속하기",
  "3645029425": "아래의 QR 코드를 스캔하십시오",
  "3645116517": "해당 전화를 받을 때 이 코드를 입력하세요:",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "다음",
  "3737470122": "더 자세한 내용은 관리자에게 문의해 주세요.",
  "3781468762": "귀하의 브라우저가 WebAuthn을 지원하지 않습니다",
  "3827227259": "확인 코드를 다음으로 전송함:",
  "3855542277": "이 코드를 앱에 입력하기",
  "3865193889": "활성화히기",
  "3877285238": "1개의 소문자",
  "4000449233": "아래 전화번호로 전화하기:",
  "4072532148": "SMS 코드 다시 보내기",
  "4151518079": "보안 질문 {current} / {total} 선택하기",
  "4227081527": "앱이 설치되면 이 화면으로 돌아와 {action} 클릭하세요",
  calling: calling$9,
  cancel: cancel$9,
  closeDialog: closeDialog$9,
  confirm: confirm$9,
  downloadOnAppStore: downloadOnAppStore$9,
  getOnGooglePlay: getOnGooglePlay$9,
  linkToAppStore: linkToAppStore$9,
  linkToGooglePlay: linkToGooglePlay$9,
  revert: revert$9
};
var calling$a = "Memanggil";
var cancel$a = "cancel";
var closeDialog$a = "Tutup dialog";
var confirm$a = "confirm";
var downloadOnAppStore$a = "Muat turun di app store";
var getOnGooglePlay$a = "Dapatkannya di Google Play";
var linkToAppStore$a = "Pautan kepada App Store";
var linkToGooglePlay$a = "Pautan kepada Google Play";
var revert$a = "revert";
var msMY = {
  "198705281": "Masukkan kod yang anda terima dalam SMS",
  "374233718": "Anda boleh cuba semula dalam {secLeft, number} {secLeft, plural, one second} lain-lain {seconds}}",
  "437305782": "Mengesahkan pengesah WebAuthn anda sekarang.",
  "505702857": "Pautan Ajaib",
  "519412053": "Tukar Faktor Pengesahan",
  "655462232": "Muat turun dan pasang OneLogin Protect pada peranti anda",
  "662924178": "Nampaknya, hari ini bukan hari kita.",
  "694278426": "Masukkan kod {deviceName} anda",
  "694920552": "Kod Keselamatan Pertama",
  "737192390": "Buka {appName}",
  "740457555": "Kod Kedua",
  "744377571": "Minimum {length} aksara",
  "751710530": "Serah",
  "916760408": "Masukkan nama pengguna dan kod keselamatan dari peranti anda.",
  "921093870": "Masih tidak menerima kod?",
  "1068496829": "Pilih Soalan Keselamatan {current}/{total}",
  "1079852660": "Masukkan dua Kod Keselamatan berurutan",
  "1080736814": "Masukkan {fieldName} dari aplikasi Symantec VIP Access",
  "1136625613": "Proses dibatalkan. Sila cuba semula menggunakan faktor pengesahan lain.",
  "1242107845": "Tunjukkan",
  "1254879564": "Kata Laluan Baharu",
  "1359200231": "Hantar",
  "1433651550": "Masukkan kod dari OneLogin SMS.",
  "1477893598": "Buat konfigurasi",
  "1536965459": "Muat turan dan pasang OneLogin Protect pada peranti anda",
  "1624184662": "Untuk menyediakan OneLogin SMS, kami akan menghantar kod pengaktifan kepada anda melalui SMS. Anda memerlukan kod pengaktifan ini untuk melengkapkan pendaftaran peranti.",
  "1654624862": "Kod Keselamatan",
  "1833121415": "Berikan Jawapan {current}/{total}",
  "1919587067": "Hantar semula kod",
  "1935535842": "Diperlukan",
  "1963245695": "1 Huruf Besar",
  "2018264248": "Cuba Semula",
  "2091874550": "Kod Pertama",
  "2097632732": "Sebaliknya imbas kod bar",
  "2104438124": "Masukkan {fieldName} dan dua Kod Keselamatan berurutan dari Symantec VIP Access.",
  "2124363772": "Masukkan nama pengguna dan kod keselamatan anda dari token SecurID anda.",
  "2229754167": "Masukkan nombor telefon anda",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "Sembunyikan",
  "2606375562": "Masukkan YubiKey anda ke dalam port USB dan tekan butang",
  "2663586870": "Nama pengguna",
  "2792137744": "1 nombor",
  "2815222727": "Imbas kod bar ini",
  "2859281487": "Pengesahan 2 faktor diperlukan untuk menjadikan akaun anda selamat.",
  "2942752129": "Kod Keselamatan Kedua",
  "3060896801": "Bermasalah?",
  "3286567409": "1 aksara khas",
  "3294346597": "Cuba lagi",
  "3327626662": "Masukkan kod pengesahan anda",
  "3374226769": "Klik Pair dengan menggunakan masukan manual",
  "3469481929": "Tidak boleh mengimbas kod?",
  "3528672691": "Batal",
  "3640052215": "Teruskan",
  "3645029425": "Imbas Kod QR di bawah",
  "3645116517": "MAsukkan kod ini apabila menerima panggilan:",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "Berikut",
  "3737470122": "Sila hubungi pentadbir untuk maklumat lanjut",
  "3781468762": "Pelayar anda tidak menyokong WebAuthn",
  "3827227259": "Kod pengesahan telah dihantar kepada",
  "3855542277": "Masukkan kod ini dalam aplikasi",
  "3865193889": "Aktifkan",
  "3877285238": "1 huruf kecil",
  "4000449233": "Memanggil nombor telefon di bawah:",
  "4072532148": "Hantar semula kod SMS",
  "4151518079": "Pilih Soalan Keselamatan {current} / {total}",
  "4227081527": "Apabila aplikasi dipasang, kembali ke skrin ini dan klik {action}",
  calling: calling$a,
  cancel: cancel$a,
  closeDialog: closeDialog$a,
  confirm: confirm$a,
  downloadOnAppStore: downloadOnAppStore$a,
  getOnGooglePlay: getOnGooglePlay$a,
  linkToAppStore: linkToAppStore$a,
  linkToGooglePlay: linkToGooglePlay$a,
  revert: revert$a
};
var calling$b = "Aan het bellen";
var cancel$b = "cancel";
var closeDialog$b = "Venster sluiten";
var confirm$b = "confirm";
var downloadOnAppStore$b = "Downloaden via de App Store";
var getOnGooglePlay$b = "Downloaden via Google Play";
var linkToAppStore$b = "Link naar de App Store";
var linkToGooglePlay$b = "Link naar Google Play";
var revert$b = "revert";
var nl = {
  "198705281": "Voer de code in die u ontving per SMS.",
  "374233718": "U kunt het in {secLeft, number} {secLeft, plural, one {second} other {seconds}} opnieuw proberen",
  "437305782": "Uw WebAuthn-authenticators worden nu geverifieerd.",
  "505702857": "Magische link",
  "519412053": "Wijzig de verificatiefactor",
  "655462232": "Download en installeer OneLogin Protect op uw apparaat",
  "662924178": "Het lijkt erop dat het niet onze dag is.",
  "694278426": "Voer uw {deviceName}-code in",
  "694920552": "Eerste veiligheidscode",
  "737192390": "Open  {appName}",
  "740457555": "Tweede code",
  "744377571": "Minimum {length} leestekens",
  "751710530": "Indienen",
  "916760408": "Voer een gebruikersnaam en veiligheidscode van uw apparaat in.",
  "921093870": "De code niet ontvangen?",
  "1068496829": "Selecteer een veiligheidsvraag {current}/{total}",
  "1079852660": "Voer twee opeenvolgende veiligheidscodes in",
  "1080736814": "Voer {fieldName} van de Symantec VIP Access-app in",
  "1136625613": "Het proces werd beëindigd. Probeer het opnieuw of gebruik een andere authenticatiefactor.",
  "1242107845": "Tonen",
  "1254879564": "Nieuw wachtwoord",
  "1359200231": "Versturen",
  "1433651550": "Voer de code in van OneLogin SMS.",
  "1477893598": "Configureren",
  "1536965459": "Download en installeer OneLogin Protect op uw apparaat",
  "1624184662": "Om OneLogin SMS in te stellen, sturen we u een activeringscode via SMS. U hebt deze activeringscode nodig om de apparaatregistratie te voltooien.",
  "1654624862": "Veiligheidscode",
  "1833121415": "Geef een antwoord {current}/{total}",
  "1919587067": "Code nogmaals versturen",
  "1935535842": "Vereist",
  "1963245695": "1 hoofdletter",
  "2018264248": "Probeer het opnieuw",
  "2091874550": "Eerste code",
  "2097632732": "Scan in plaats daarvan de barcode",
  "2104438124": "Voer {fieldName} en twee opeenvolgende veiligheidscodes in van Symantec VIP Access.",
  "2124363772": "Voer uw gebruikersnaam en veiligheidscode in met uw SecurID-token.",
  "2229754167": "Voer uw telefoonnummer in",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "Verbergen",
  "2606375562": "Steek uw YubiKey in de USB-poort en druk op de knop",
  "2663586870": "Gebruikersnaam",
  "2792137744": "1 nummer",
  "2815222727": "Scan deze barcode",
  "2859281487": "Authenticatie met 2 factoren is vereist om uw account te beveiligen.",
  "2942752129": "Tweede veiligheidscode",
  "3060896801": "Hebt u problemen?",
  "3286567409": "1 speciaal leesteken",
  "3294346597": "Probeer het opnieuw",
  "3327626662": "Voer uw bevestigingscode in",
  "3374226769": "Klik op Paren door de handmatige invoer te gebruiken",
  "3469481929": "U kunt de code niet scannen?",
  "3528672691": "Annuleren",
  "3640052215": "Doorgaan",
  "3645029425": "Scan de onderstaande QR-code",
  "3645116517": "Voer deze code in zodra u de oproep ontvangt:",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "Volgende",
  "3737470122": "Neem voor meer informatie contact op met de beheerder",
  "3781468762": "Uw browser ondersteunt geen WebAuthn",
  "3827227259": "Een bevestigingscode is verstuurd naar",
  "3855542277": "Voer deze code in de app in",
  "3865193889": "Activeren",
  "3877285238": "1 kleine letter",
  "4000449233": "Het onderstaande nummer wordt gebeld:",
  "4072532148": "SMS-code opnieuw versturen",
  "4151518079": "Selecteer een veiligheidsvraag {current} / {total}",
  "4227081527": "Wanneer de app is geïnstalleerd, keer terug naar dit scherm en klik op {action}",
  calling: calling$b,
  cancel: cancel$b,
  closeDialog: closeDialog$b,
  confirm: confirm$b,
  downloadOnAppStore: downloadOnAppStore$b,
  getOnGooglePlay: getOnGooglePlay$b,
  linkToAppStore: linkToAppStore$b,
  linkToGooglePlay: linkToGooglePlay$b,
  revert: revert$b
};
var calling$c = "Dzwonię";
var cancel$c = "cancel";
var closeDialog$c = "Zamknij okno dialogowe";
var confirm$c = "confirm";
var downloadOnAppStore$c = "Pobierz w sklepie z aplikacjami";
var getOnGooglePlay$c = "Pobierz z Google Play";
var linkToAppStore$c = "Linkuj do App Store";
var linkToGooglePlay$c = "Linkuj do Google Play";
var revert$c = "revert";
var plPL = {
  "198705281": "Wpisz kod otrzymany w wiadomości SMS.",
  "374233718": "Możesz spróbować ponownie za {secLeft, number} {secLeft, plural, one {second} other {seconds}}",
  "437305782": "Weryfikuję teraz Twoje wartości uwierzytelniające WebAuthn.",
  "505702857": "Magiczny odnośnik",
  "519412053": "Zmień składnik uwierzytelnienia",
  "655462232": "Pobierz i zainstaluj program OneLogin Protect na swoim urządzeniu.",
  "662924178": "Wygląda na to, że dziś nie jest nasz dzień.",
  "694278426": "Wprowadź kod {deviceName}",
  "694920552": "Pierwszy kod bezpieczeństwa",
  "737192390": "Otwórz {appName}",
  "740457555": "Drugi kod",
  "744377571": "Minimalna {length} znaków",
  "751710530": "Prześlij",
  "916760408": "Wpisz nazwę użytkownika i kod bezpieczeństwa ze swojego urządzenia.",
  "921093870": "Nie otrzymałeś(aś) kodu?",
  "1068496829": "Wybierz pytanie bezpieczeństwa {current}/{total}",
  "1079852660": "Wpisz dwa kolejne kody bezpieczeństwa",
  "1080736814": "Wpisz {fieldName} z aplikacji Symantec VIP Access",
  "1136625613": "Proces został anulowany. Spróbuj ponownie lub użyj innego składnika uwierzytelniania.",
  "1242107845": "Pokaż",
  "1254879564": "Nowe hasło",
  "1359200231": "Wyślij",
  "1433651550": "Wpisz kod z programu OneLogin SMS.",
  "1477893598": "Skonfiguruj",
  "1536965459": "Pobierz i zainstaluj program OneLogin Protect na swoim urządzeniu.",
  "1624184662": "W celu skonfigurowania aplikacji OneLogin SMS, prześlemy Ci kod aktywacyjny przez SMS. Będziesz go potrzebować do zakończenia rejestracji urządzenia.",
  "1654624862": "Kod bezpieczeństwa",
  "1833121415": "Podaj odpowiedź {current}/{total}",
  "1919587067": "Wyślij kod ponownie",
  "1935535842": "Wymagane",
  "1963245695": "1 wielka litera",
  "2018264248": "Spróbuj ponownie",
  "2091874550": "Pierwszy kod",
  "2097632732": "Zamiast tego zeskanuj kod kreskowy",
  "2104438124": "Wpisz {fieldName} i dwa kolejne kody bezpieczeństwa z programu Symantec VIP Access.",
  "2124363772": "Wpisz swoją nazwę użytkownika i kod bezpieczeństwa ze swojego tokenu SecurID.",
  "2229754167": "Wprowadź swój numer telefonu",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "Ukryj",
  "2606375562": "Wsuń swój YubiKey do portu USB i naciśnij przycisk",
  "2663586870": "Nazwa użytkownika",
  "2792137744": "1 cyfra",
  "2815222727": "Zeskanuj ten kod kreskowy",
  "2859281487": "Do zabezpieczenia Twojego konta potrzebne jest uwierzytelnianie dwuskładnikowe.",
  "2942752129": "Drugi kod bezpieczeństwa",
  "3060896801": "Masz kłopot?",
  "3286567409": "1 znak specjalny",
  "3294346597": "Spróbuj ponownie",
  "3327626662": "Wprowadź swój kod potwierdzający",
  "3374226769": "Kliknij parę przy użyciu wpisu ręcznego",
  "3469481929": "Nie można zeskanować kodu?",
  "3528672691": "Anuluj",
  "3640052215": "Kontynuuj",
  "3645029425": "Zeskanuj poniższy kod QR",
  "3645116517": "Wprowadź ten kod, kiedy odbierasz połączenie:",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "Dalej",
  "3737470122": "Skontaktuj się z administratorem, aby dowiedzieć się więcej.",
  "3781468762": "Twoja przeglądarka nie obsługuje WebAuthn",
  "3827227259": "Kod potwierdzający został wysłany do",
  "3855542277": "Wpisz ten kod do aplikacji",
  "3865193889": "Aktywuj",
  "3877285238": "1 mała litera",
  "4000449233": "Dzwonię na poniższy numer telefonu:",
  "4072532148": "Wyślij ponownie kod SMS",
  "4151518079": "Wybierz pytanie bezpieczeństwa {current} / {total}",
  "4227081527": "Kiedy aplikacja jest zainstalowana, powróć do tego ekranu i kliknij {action}",
  calling: calling$c,
  cancel: cancel$c,
  closeDialog: closeDialog$c,
  confirm: confirm$c,
  downloadOnAppStore: downloadOnAppStore$c,
  getOnGooglePlay: getOnGooglePlay$c,
  linkToAppStore: linkToAppStore$c,
  linkToGooglePlay: linkToGooglePlay$c,
  revert: revert$c
};
var calling$d = "A ligar";
var cancel$d = "cancel";
var closeDialog$d = "Fechar diálogo";
var confirm$d = "confirm";
var downloadOnAppStore$d = "Descarregar na App Store";
var getOnGooglePlay$d = "Obter no Google Play";
var linkToAppStore$d = "Hiperligação para a App Store";
var linkToGooglePlay$d = "Hiperligação para o Google Play";
var revert$d = "revert";
var pt = {
  "198705281": "Insira o código que recebeu por SMS.",
  "374233718": "Pode tentar novamente dentro de {secLeft, number} {secLeft, plural, one {second} {seconds}}",
  "437305782": "A verificar os seus autenticadores WebAuthn.",
  "505702857": "Ligação Mágica",
  "519412053": "Alterar Fator de Autenticação",
  "655462232": "Faça download e instale o OneLogin Protect no seu dispositivo",
  "662924178": "Parece que hoje não é o nosso dia.",
  "694278426": "Insira o seu código {deviceName}",
  "694920552": "Primeiro Código de Segurança",
  "737192390": "Abrir {appName}",
  "740457555": "Segundo Código",
  "744377571": "Mínimo de {length} caracteres",
  "751710530": "Enviar",
  "916760408": "Insira um nome de utilizador e código de segurança do seu dispositivo.",
  "921093870": "Não recebeu o código?",
  "1068496829": "Selecionar Pergunta de Segurança {current}/{total}",
  "1079852660": "Insira dois Códigos de Segurança consecutivos",
  "1080736814": "Insira {fieldName} da aplicação Symantec VIP Access",
  "1136625613": "O processo foi cancelado. Tente novamente ou utilize outro fator de autenticação.",
  "1242107845": "Mostrar",
  "1254879564": "Nova Palavra-passe",
  "1359200231": "Enviar",
  "1433651550": "Insira o código do OneLogin SMS.",
  "1477893598": "Configurar",
  "1536965459": "Faça download e instale o OneLogin Protect no seu dispositivo",
  "1624184662": "Para configurar o OneLogin SMS, iremos enviá-lo um código de ativação por SMS. Precisará deste código de ativação para concluir o registo do dispositivo.",
  "1654624862": "Código de Segurança",
  "1833121415": "Fornecer Resposta {current}/{total}",
  "1919587067": "Reenviar código",
  "1935535842": "Obrigatório",
  "1963245695": "1 letra maiúscula",
  "2018264248": "Tentar Novamente",
  "2091874550": "Primeiro Código",
  "2097632732": "Digitalizar antes código de barra",
  "2104438124": "Insira {fieldName} e dois Códigos de Segurança consecutivos do Symantec VIP Access.",
  "2124363772": "Insira o seu nome de utilizador e o código de segurança do seu token SecurID.",
  "2229754167": "Insira o seu número de telefone",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "Ocultar",
  "2606375562": "Insira o seu YubiKey na porta USB e pressione o botão",
  "2663586870": "Nome de utilizador",
  "2792137744": "1 número",
  "2815222727": "Digitalize este código de barras",
  "2859281487": "A autenticação de dois fatores é necessária para proteger a sua conta.",
  "2942752129": "Segundo Código de Segurança",
  "3060896801": "Está com problemas?",
  "3286567409": "1 símbolo especial",
  "3294346597": "Tentar novamente",
  "3327626662": "Insira o seu código de confirmação",
  "3374226769": "Clique em Emparelhar usando entrada manual",
  "3469481929": "Não consegue digitalizar o código?",
  "3528672691": "Cancelar",
  "3640052215": "Continuar",
  "3645029425": "Digitalize o Código QR abaixo",
  "3645116517": "Insira este código quando receber a chamada:",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "Seguinte",
  "3737470122": "Para mais informações, contacte o administrador.",
  "3781468762": "O WebAuthn não funciona no seu navegador",
  "3827227259": "Foi enviado um código de confirmação para",
  "3855542277": "Insira este código na aplicação",
  "3865193889": "Ativar",
  "3877285238": "1 letra minúscula",
  "4000449233": "A ligar para o número de telefone abaixo:",
  "4072532148": "Reenviar código por SMS",
  "4151518079": "Selecionar Pergunta de Segurança {current} / {total}",
  "4227081527": "Quando a aplicação estiver instalada, volte a este ecrã e clique em {action}",
  calling: calling$d,
  cancel: cancel$d,
  closeDialog: closeDialog$d,
  confirm: confirm$d,
  downloadOnAppStore: downloadOnAppStore$d,
  getOnGooglePlay: getOnGooglePlay$d,
  linkToAppStore: linkToAppStore$d,
  linkToGooglePlay: linkToGooglePlay$d,
  revert: revert$d
};
var calling$e = "Идет звонок";
var cancel$e = "cancel";
var closeDialog$e = "Закрыть диалог";
var confirm$e = "confirm";
var downloadOnAppStore$e = "Скачать в App Store";
var getOnGooglePlay$e = "Скачать в Google Play";
var linkToAppStore$e = "Ссылка на App Store";
var linkToGooglePlay$e = "Ссылка на Google Play";
var revert$e = "revert";
var ruRU = {
  "198705281": "Введите код, который вы получили в SMS-сообщении.",
  "374233718": "Вы сможете повторить попытку через {secLeft, number} {secLeft, plural, one {сек.} other {сек.}}",
  "437305782": "Идет проверка ваших аутентификаторов WebAuthn.",
  "505702857": "Волшебная ссылка",
  "519412053": "Изменить фактор аутентификации",
  "655462232": "Загрузите и установите на вашем устройстве OneLogin Protect",
  "662924178": "Похоже, что сегодня не ваш день.",
  "694278426": "Укажите свой код {deviceName}",
  "694920552": "Первый Код безопасности",
  "737192390": "Откройте {appName}",
  "740457555": "Второй код",
  "744377571": "Минимум {length} символов",
  "751710530": "Отправить",
  "916760408": "Введите имя пользователя и код безопасности с вашего устройства.",
  "921093870": "Не получили код?",
  "1068496829": "Выберите контрольный вопрос {current}/{total}",
  "1079852660": "Введите два последовательных Кода безопасности",
  "1080736814": "Введите {fieldName} из приложения Symantec VIP Access",
  "1136625613": "Процесс был отменен. Пожалуйста, повторите попытку или используйте другой фактор аутентификации.",
  "1242107845": "Показать",
  "1254879564": "Новый пароль",
  "1359200231": "Отправить",
  "1433651550": "Введите код из OneLogin SMS.",
  "1477893598": "Настроить",
  "1536965459": "Загрузите и установите OneLogin Protect на вашем устройстве",
  "1624184662": "Для настройки OneLogin SMS мы отправим вам SMS-сообщением код активации. Вам понадобится этот код активации для завершения регистрации устройства.",
  "1654624862": "Код безопасности",
  "1833121415": "Укажите ответ {current}/{total}",
  "1919587067": "Отправить код повторно",
  "1935535842": "Необходимо",
  "1963245695": "1 прописная буква",
  "2018264248": "Еще раз",
  "2091874550": "Первый код",
  "2097632732": "Вместо этого сканировать штрих-код",
  "2104438124": "Введите {fieldName} и два последовательных Кода безопасности из Symantec VIP Access.",
  "2124363772": "Введите ваше имя пользователя и код безопасности из вашего токена SecurID.",
  "2229754167": "Укажите свой номер телефона",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "Скрыть",
  "2606375562": "Вставьте ваш YubiKey в USB-порт и нажмите кнопку",
  "2663586870": "Имя пользователя",
  "2792137744": "1 цифра",
  "2815222727": "Сканировать этот штрих-код",
  "2859281487": "Для обеспечения безопасности вашей учетной записи требуется 2-факторная аутентификация.",
  "2942752129": "Второй Код безопасности",
  "3060896801": "Возникли затруднения?",
  "3286567409": "1 специальный символ",
  "3294346597": "Повторите попытку",
  "3327626662": "Укажите свой код подтверждения",
  "3374226769": "Нажмите Pair, используя ручной ввод",
  "3469481929": "Не можете отсканировать код?",
  "3528672691": "Отменить",
  "3640052215": "Продолжить",
  "3645029425": "Отсканируйте ниже QR-код",
  "3645116517": "Укажите этот код, когда вы примете звонок:",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "Далее",
  "3737470122": "Пожалуйста, свяжитесь с администратором для получения дополнительной информации.",
  "3781468762": "Ваш браузер не поддерживает WebAuthn",
  "3827227259": "Код подтверждения был отправлен на",
  "3855542277": "Введите этот код в приложении",
  "3865193889": "Активировать",
  "3877285238": "1 строчная буква",
  "4000449233": "Звонок по указанному ниже номеру телефона:",
  "4072532148": "Отправить SMS-код повторно",
  "4151518079": "Выберите контрольный вопрос {current} / {total}",
  "4227081527": "Когда приложение установлено, вернитесь в это меню и нажмите {action}",
  calling: calling$e,
  cancel: cancel$e,
  closeDialog: closeDialog$e,
  confirm: confirm$e,
  downloadOnAppStore: downloadOnAppStore$e,
  getOnGooglePlay: getOnGooglePlay$e,
  linkToAppStore: linkToAppStore$e,
  linkToGooglePlay: linkToGooglePlay$e,
  revert: revert$e
};
var calling$f = "Volá";
var cancel$f = "cancel";
var closeDialog$f = "Zatvoriť dialóg";
var confirm$f = "confirm";
var downloadOnAppStore$f = "Stiahnuť z obchodu s aplikáciami";
var getOnGooglePlay$f = "Získať z Google Play";
var linkToAppStore$f = "Odkaz na obchod s aplikáciami";
var linkToGooglePlay$f = "Odkaz na Google Play";
var revert$f = "revert";
var skSK = {
  "198705281": "Zadajte kód, ktorý ste obdržali v SMS správe.",
  "374233718": "Môžete to skúsiť znova o {secLeft, number} {secLeft, plural, 1 sekundu {second} {seconds}}",
  "437305782": "Teraz overujeme vaše autentifikačné faktory WebAuthn.",
  "505702857": "Magický odkaz",
  "519412053": "Zmeniť zložku overenia pravosti",
  "655462232": "Stiahnite a nainštalujte si do svojho zariadenia OneLogin Protect",
  "662924178": "Zdá sa, že dnes nemáme svoj deň.",
  "694278426": "Zadajte váš kód {deviceName}",
  "694920552": "Prvý bezpečnostný kód",
  "737192390": "Otvoriť {appName}",
  "740457555": "Druhý kód",
  "744377571": "Minimálny počet {length} znakov",
  "751710530": "Odovzdať",
  "916760408": "Zadajte užívateľské meno a bezpečnostný kód zo svojho zariadenia.",
  "921093870": "Nedostali ste kód?",
  "1068496829": "Vyberte si bezpečnostnú otázku {current}/{total}",
  "1079852660": "Zadajte dva po sebe idúce bezpečnostné kódy",
  "1080736814": "Zadajte {fieldName} z aplikácie Symantec VIP Access",
  "1136625613": "Proces bol zrušený. Prosím, skúste to znova alebo použite iný autentifikačný faktor.",
  "1242107845": "Ukázať",
  "1254879564": "Nové heslo",
  "1359200231": "Odoslať",
  "1433651550": "Zadajte kód SMS správy OneLogin.",
  "1477893598": "Konfigurovať",
  "1536965459": "Stiahnite a nainštalujte si do svojho zariadenia OneLogin Protect",
  "1624184662": "Pre nastavenie OneLogin SMS vám v SMS správe pošleme aktivačný kód. Tento aktivačný kód budete potrebovať pre dokončenie registrácie zariadenia.",
  "1654624862": "Bezpečnostný kód",
  "1833121415": "Poskytnúť odpoveď {current}/{total}",
  "1919587067": "Znova odoslať kód",
  "1935535842": "Povinný",
  "1963245695": "1 veľké písmeno",
  "2018264248": "Skúste to znovu",
  "2091874550": "Prvý kód",
  "2097632732": "Namiesto toho naskenujte čiarový kód",
  "2104438124": "Zadajte {fieldName} a dva po sebe idúce bezpečnostné kódy zo Symantec VIP Access.",
  "2124363772": "Zadajte svoje užívateľské meno a bezpečnostný kód zo svojho kupónu SecurID.",
  "2229754167": "Zadajte vaše telefónne číslo",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "Skryť",
  "2606375562": "Vložte svoj YubiKey do USB portu a stlačte tlačidlo",
  "2663586870": "Užívateľské meno",
  "2792137744": "1 číslo",
  "2815222727": "Naskenujte tento čiarový kód",
  "2859281487": "Na zabezpečenie vášho účtu je nutné 2-zložkové overenie pravosti.",
  "2942752129": "Druhý bezpečnostný kód",
  "3060896801": "Máte problém?",
  "3286567409": "1 špeciálny znak",
  "3294346597": "Skúsiť znovu",
  "3327626662": "Zadajte potvrdzujúci kód",
  "3374226769": "Pre manuálny vstup kliknite na Pair",
  "3469481929": "Kód sa nedá naskenovať?",
  "3528672691": "Zrušiť",
  "3640052215": "Pokračovať",
  "3645029425": "Naskenujte QR kód uvedený nižšie",
  "3645116517": "Pri prijatí hovoru zadajte tento kód:",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "Ďalší",
  "3737470122": "Pre viac informácii kontaktujte administrátora",
  "3781468762": "Váš prehliadač nepodporuje WebAuthn",
  "3827227259": "Potvrdzujúci kód bol poslaný na adresu",
  "3855542277": "Zadajte tento kód do aplikácie",
  "3865193889": "Aktivovať",
  "3877285238": "1 malé písmeno",
  "4000449233": "Voláte na nižšie uvedené telefónne číslo:",
  "4072532148": "Znovu odoslať SMS kód",
  "4151518079": "Vyberte si bezpečnostnú otázku {current}/{total}",
  "4227081527": "Keď sa aplikácia nainštaluje, vráťte sa na túto obrazovku a kliknite {action}",
  calling: calling$f,
  cancel: cancel$f,
  closeDialog: closeDialog$f,
  confirm: confirm$f,
  downloadOnAppStore: downloadOnAppStore$f,
  getOnGooglePlay: getOnGooglePlay$f,
  linkToAppStore: linkToAppStore$f,
  linkToGooglePlay: linkToGooglePlay$f,
  revert: revert$f
};
var calling$g = "กำลังโทร";
var cancel$g = "cancel";
var closeDialog$g = "ปิดไดอาล็อก";
var confirm$g = "confirm";
var downloadOnAppStore$g = "ดาวน์โหลดใน App Store";
var getOnGooglePlay$g = "ดาวน์โหลดบน Google Play";
var linkToAppStore$g = "ลิงก์ไปยัง App Store";
var linkToGooglePlay$g = "ลิงก์ไปยัง Google Play";
var revert$g = "revert";
var thTH = {
  "198705281": "ป้อนรหัสที่คุณได้รับทาง SMS",
  "374233718": "คุณจะลองใหม่ได้ในอีก {secLeft, number} {secLeft, plural, one {second} other {seconds}}",
  "437305782": "กำลังตรวจสอบการยืนยันตัวตนผ่านทาง WebAuthn",
  "505702857": "เมจิกลิงก์",
  "519412053": "เปลี่ยนปัจจัยการตรวจสอบ",
  "655462232": "ดาวน์โหลดและติดตั้ง  OneLogin Protect บนอุปกรณ์ของคุณ",
  "662924178": "ดูเหมือนนี่จะไม่ใช่วันของเรา",
  "694278426": "ป้อนโค้ดจาก {deviceName} ของคุณ",
  "694920552": "รหัสความปลอดภัยรหัสแรก",
  "737192390": "เปิด {appName}",
  "740457555": "รหัสที่สอง",
  "744377571": "ตัวอักษรขั้นต่ำ {length} ตัวอักษร",
  "751710530": "ส่ง",
  "916760408": "ป้อนชื่อผู้ใช้และรหัสความปลอดภัยจากอุปกรณ์ของคุณ",
  "921093870": "ยังไม่ได้รับรหัสหรือ?",
  "1068496829": "เลือกคำถามความปลอดภัย {current}/{total}",
  "1079852660": "ป้อน 2 รหัสความปลอดภัยติดต่อกัน",
  "1080736814": "ป้อน {fieldName} จากแอป Symantec VIP Access",
  "1136625613": "ขั้นตอนถูกยกเลิก โปรดลองใหม่หรือใช้ปัจจัยอื่นในการยืนยันตัวตน",
  "1242107845": "แสดง",
  "1254879564": "รหัสผ่านใหม่",
  "1359200231": "ส่ง",
  "1433651550": "ป้อนรหัสจาก SMS ของ OneLogin",
  "1477893598": "กำหนดค่า",
  "1536965459": "ดาวน์โหลดและติดตั้ง OneLogin Protect บนอุปกรณ์ของคุณ",
  "1624184662": "เพื่อที่จะตั้งค่า OneLogin SMS ทางเราจะส่งรหัสการเปิดใช้งานให้คุณทาง SMS คุณต้องใช้รหัสการเปิดใช้งานนี้เพื่อให้การลงทะเบียนอุปกรณ์เสร็จสมบูรณ์",
  "1654624862": "รหัสความปลอดภัย",
  "1833121415": "คำตอบที่มีให้ {current}/{total}",
  "1919587067": "ส่งรหัสอีกครั้ง",
  "1935535842": "จำเป็นต้องมี",
  "1963245695": "1 ตัวพิมพ์ใหญ่",
  "2018264248": "ลองใหม่",
  "2091874550": "รหัสแรก",
  "2097632732": "สแกนบาร์โคดแทน",
  "2104438124": "ป้อน {fieldName} และรหัสความปลอดภัย 2 รหัสติดต่อกัน จาก Symantec VIP Access",
  "2124363772": "ป้อนชื่อผู้ใช้ของคุณและรหัสความปลอดภัยจากโทเค็น SecurID",
  "2229754167": "ป้อนหมายเลขโทรศัพท์ของคุณ",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "ซ่อน",
  "2606375562": "ใส่ YubiKey ของคุณในพอร์ท USB แล้วกดปุ่ม",
  "2663586870": "ชื่อผู้ใช้",
  "2792137744": "1 หมายเลข",
  "2815222727": "สแกนบาร์โคดนี้",
  "2859281487": "จำเป็นต้องมีการตรวจสอบความถูกต้อง 2 ปัจจัยเพื่อความปลอดภัยในบัญชีของคุณ",
  "2942752129": "รหัสความปลอดภัยที่สอง",
  "3060896801": "มีปัญหาหรือ?",
  "3286567409": "1 อักขระพิเศษ",
  "3294346597": "ลองอีกครั้ง",
  "3327626662": "ป้อนรหัสยืนยันของคุณ",
  "3374226769": "คลิก Pair โดยป้อนด้วยตนเอง",
  "3469481929": "ไม่สามารถสแกนรหัส?",
  "3528672691": "ยกเลิก",
  "3640052215": "ดำเนินการต่อ",
  "3645029425": "สแกนใต้รหัส QR Code",
  "3645116517": "ป้อนโค้ดนี้เมื่อได้รับสายเรียกเข้า:",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "ต่อไป",
  "3737470122": "โปรดติดต่อผู้ดูแลเพื่อขอข้อมูลเพิ่มเติม",
  "3781468762": "เบราว์เซอร์ของคุณไม่รองรับ WebAuthn",
  "3827227259": "ระบบได้ส่งโค้ดยืนยันไปยัง",
  "3855542277": "ป้อนรหัสนี้ลงในแอป",
  "3865193889": "เปิดใช้งาน",
  "3877285238": "1 ตัวพิมพ์เล็ก",
  "4000449233": "กำลังโทรติดต่อหมายเลขโทรศัพท์ด้านล่างนี้:",
  "4072532148": "ส่งรหัส SMS อีกครั้ง",
  "4151518079": "เลือกคำถามความปลอดภัย {current} / {total}",
  "4227081527": "เมื่อติดตั้งแอปแล้ว กลับมาที่หน้าจอนี้และคลิก {action}",
  calling: calling$g,
  cancel: cancel$g,
  closeDialog: closeDialog$g,
  confirm: confirm$g,
  downloadOnAppStore: downloadOnAppStore$g,
  getOnGooglePlay: getOnGooglePlay$g,
  linkToAppStore: linkToAppStore$g,
  linkToGooglePlay: linkToGooglePlay$g,
  revert: revert$g
};
var calling$h = "Aranıyor";
var cancel$h = "cancel";
var closeDialog$h = "Diyaloğu kapat";
var confirm$h = "confirm";
var downloadOnAppStore$h = "App store'dan indir";
var getOnGooglePlay$h = "Google Play'den Al";
var linkToAppStore$h = "App Store bağlantısı";
var linkToGooglePlay$h = "Google Play bağlantısı";
var revert$h = "revert";
var trTR = {
  "198705281": "SMS'le aldığınız kodu girin.",
  "374233718": "{secLeft, number} {secLeft, plural, one {second} other {seconds}} içinde tekrar deneyebilirsiniz",
  "437305782": "Şu anda WebAuthn kimlik belirleyiciniz doğrulanıyor.",
  "505702857": "Sihirli Bağlantı",
  "519412053": "Kimlik Doğrulama Etmenini Değiştirin",
  "655462232": "Cihazınıza OneLogin Protect'i indirip kurun",
  "662924178": "Görünüşe bakılırsa bugün bizim günümüz değil.",
  "694278426": "{deviceName} kodunuzu girin",
  "694920552": "İlk Güvenlik Kodu",
  "737192390": "{appName} Uygulamasını Aç",
  "740457555": "İkinci Kod",
  "744377571": "Asgari {length} karakter",
  "751710530": "Gönder",
  "916760408": "Bir kullanıcı adı ve cihazınızdan bir güvenlik kodu girin.",
  "921093870": "Kodu almadınız mı?",
  "1068496829": "Güvenlik Sorusu Seçin {current}/{total}",
  "1079852660": "İki ardışık Güvenlik Kodu girin",
  "1080736814": "Symantec VIP Access uygulamasından {fieldName} alanını girin",
  "1136625613": "Süreç iptal edildi. Lütfen tekrar deneyin veya başka bir kimlik belirleyici faktör kullanın.",
  "1242107845": "Göster",
  "1254879564": "Yeni Şifre",
  "1359200231": "Gönder",
  "1433651550": "OneLogin SMS'ten kodu girin.",
  "1477893598": "Yapılandır",
  "1536965459": "OneLogin Protect'i cihazınıza indirip yükleyin",
  "1624184662": "OneLogin SMS'i kurmak için size SMS yoluyla bir aktivasyon kodu göndereceğiz. Cihaz kaydını tamamlamak için bu aktivasyon koduna ihtiyacınız olacak.",
  "1654624862": "Güvenlik Kodu",
  "1833121415": "Yanıt Verin {current}/{total}",
  "1919587067": "Kodu tekrar gönder",
  "1935535842": "Gerekli",
  "1963245695": "1 büyük harf",
  "2018264248": "Tekrar Deneyin",
  "2091874550": "İlk Kod",
  "2097632732": "Bunun yerine barkodu taratın",
  "2104438124": "{fieldName} alanını ve Symantec VIP Access'ten iki ardışık Güvenlik Kodunu girin.",
  "2124363772": "Kullanıcı adınızı ve SecurID belirtecinizden güvenlik kodunuzu girin.",
  "2229754167": "Telefon numaranızı girin",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "Gizle",
  "2606375562": "YubiKey'inizi USB bağlantı noktasına takın ve tuşa basın",
  "2663586870": "Kullanıcı Adı",
  "2792137744": "1 rakam",
  "2815222727": "Bu barkodu taratın",
  "2859281487": "Hesabınızı güvenceye almak için 2 etmenli kimlik doğrulama gerekli.",
  "2942752129": "İkinci Güvenlik Kodu",
  "3060896801": "Sorun mu yaşıyorsunuz?",
  "3286567409": "1 özel karakter",
  "3294346597": "Tekrar deneyin",
  "3327626662": "Onay kodunuzu girin",
  "3374226769": "Elle giriş kullanarak Eşleştir'e tıklayın",
  "3469481929": "Kodu taratamıyor musunuz?",
  "3528672691": "İptal Et",
  "3640052215": "Devam Et",
  "3645029425": "Aşağıdaki QR Kodunu Taratın",
  "3645116517": "Bu kodu aramayı aldığınızda girin",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "Sonraki",
  "3737470122": "Daha fazla bilgi için lütfen yönetici ile iletişime geçin.",
  "3781468762": "Tarayıcınız WebAuthn'u desteklemiyor",
  "3827227259": "Şuraya bir onay kodu gönderildi:",
  "3855542277": "Bu kodu uygulamaya girin",
  "3865193889": "Aktive Et",
  "3877285238": "1 küçük harf",
  "4000449233": "Aşağıdaki telefon numarası aranıyor:",
  "4072532148": "SMS kodunu tekrar gönder",
  "4151518079": "Güvenlik Sorusu Seçin {current} / {total}",
  "4227081527": "Uygulama yüklenince bu ekrana geri gelip {action} tuşuna tıklayın",
  calling: calling$h,
  cancel: cancel$h,
  closeDialog: closeDialog$h,
  confirm: confirm$h,
  downloadOnAppStore: downloadOnAppStore$h,
  getOnGooglePlay: getOnGooglePlay$h,
  linkToAppStore: linkToAppStore$h,
  linkToGooglePlay: linkToGooglePlay$h,
  revert: revert$h
};
var calling$i = "Đang gọi";
var cancel$i = "cancel";
var closeDialog$i = "Đóng hộp thoại";
var confirm$i = "confirm";
var downloadOnAppStore$i = "Tải về trên app store";
var getOnGooglePlay$i = "Tải về trên Google Play";
var linkToAppStore$i = "Liên kết đến App Store";
var linkToGooglePlay$i = "Liên kết đến Google Play";
var revert$i = "revert";
var viVN = {
  "198705281": "Nhập mã bạn đã nhận được qua SMS.",
  "374233718": "Bạn có thể thử lại trong {secLeft, number} {secLeft, plural, one {giây} other {giây}}",
  "437305782": "Xác minh trình tạo mã xác thực WebAuthn của bạn ngay.",
  "505702857": "Liên kết Kỳ diệu",
  "519412053": "Thay đổi Yếu tố Xác thực",
  "655462232": "Tải xuống và cài đặt OneLogin Protec trên thiết bị của bạn",
  "662924178": "Có vẻ hôm nay không phải ngày của chúng ta.",
  "694278426": "Nhập mã {deviceName} của bạn",
  "694920552": "Mã Bảo mật Đầu tiên",
  "737192390": "Mở {appName}",
  "740457555": "Mã thứ hai",
  "744377571": "Tối thiểu {length} ký tự",
  "751710530": "Gửi",
  "916760408": "Nhập tên người dùng và mã bảo mật từ thiết bị của bạn.",
  "921093870": "Bạn chưa nhận được mã?",
  "1068496829": "Chọn Câu hỏi Bảo mật {current}/{total}",
  "1079852660": "Nhập hai Mã Bảo mật liên tiếp",
  "1080736814": "Nhập {fieldName} từ ứng dụng Symantec VIP Access",
  "1136625613": "Tiến trình bị hủy bỏ. Vui lòng thử lại hoặc sử dụng yếu tố xác thực khác.",
  "1242107845": "Hiện",
  "1254879564": "Mật khẩu mới",
  "1359200231": "Gửi",
  "1433651550": "Nhập mã từ OneLogin SMS.",
  "1477893598": "Đặt cấu hình",
  "1536965459": "Tải xuống và cài đặt OneLogin Protect trên thiết bị của bạn",
  "1624184662": "Để cài đặt OneLogin SMS, chúng tôi sẽ gửi cho bạn một mã kích hoạt qua SMS. Bạn sẽ cần mã kích hoạt này để hoàn tất đăng ký thiết bị.",
  "1654624862": "Mã Bảo mật",
  "1833121415": "Đưa ra Câu trả lời {current}/{total}",
  "1919587067": "Gửi lại mã",
  "1935535842": "Bắt buộc",
  "1963245695": "1 chữ hoa",
  "2018264248": "Thử lại",
  "2091874550": "Mã đầu tiên",
  "2097632732": "Quét mã vạch để thay thế",
  "2104438124": "Nhập {fieldName} và hai Mã Bảo mật liên tiếp từ Symantec VIP Access.",
  "2124363772": "Nhập tên người dùng và mã bảo mật từ token SecurID của bạn.",
  "2229754167": "Nhập số điện thoại của bạn",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "Ẩn",
  "2606375562": "Nhét YubiKey của bạn vào cổng USB và bấm nút",
  "2663586870": "Tên người dùng",
  "2792137744": "1 số",
  "2815222727": "Quét mã vạch này",
  "2859281487": "Yêu cầu xác thực 2 yếu tố để bảo mật cho tài khoản của bạn.",
  "2942752129": "Mã Bảo mật Thứ hai",
  "3060896801": "Bạn gặp rắc rối?",
  "3286567409": "1 ký tự đặc biệt",
  "3294346597": "Thử lại",
  "3327626662": "Nhập mã xác nhận của bạn:",
  "3374226769": "Bấm Ghép đôi bằng cách nhập thủ công",
  "3469481929": "Bạn không thể quét mã?",
  "3528672691": "Hủy",
  "3640052215": "Tiếp tục",
  "3645029425": "Quét mã QR bên dưới",
  "3645116517": "Nhập mã này khi nhận cuộc gọi:",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "Tiếp theo",
  "3737470122": "Vui long liên hệ quản trị viên để biết thêm thông tin.",
  "3781468762": "Trình duyệt của bạn không hỗ trợ WebAuthn",
  "3827227259": "Đã gửi mã xác nhận đến",
  "3855542277": "Nhập mã này vào ứng dụng",
  "3865193889": "Kích hoạt",
  "3877285238": "1 chữ thường",
  "4000449233": "Gọi số điện thoại dưới đây:",
  "4072532148": "Gửi lại mã SMS",
  "4151518079": "Chọn Câu hỏi Bảo mật {current} / {total}",
  "4227081527": "Khi ứng dụng được cài đặt, hãy quay lại màn hình này và bấm {action}",
  calling: calling$i,
  cancel: cancel$i,
  closeDialog: closeDialog$i,
  confirm: confirm$i,
  downloadOnAppStore: downloadOnAppStore$i,
  getOnGooglePlay: getOnGooglePlay$i,
  linkToAppStore: linkToAppStore$i,
  linkToGooglePlay: linkToGooglePlay$i,
  revert: revert$i
};
var calling$j = "正在拨号";
var cancel$j = "cancel";
var closeDialog$j = "关闭对话";
var confirm$j = "confirm";
var downloadOnAppStore$j = "去应用商店下载";
var getOnGooglePlay$j = "在 Google Play 上获取";
var linkToAppStore$j = "链接到应用商店";
var linkToGooglePlay$j = "链接至 Google Play";
var revert$j = "revert";
var zh = {
  "198705281": "输入您在短信中收到的代码。",
  "374233718": "您可以在{secLeft, number} {secLeft, plural, one {second} other {seconds}}后重试",
  "437305782": "正在验证您的WebAuthn身份验证器。",
  "505702857": "Magic Link",
  "519412053": "更改验证因素",
  "655462232": "在您的设备上下载并安装 OneLogin Protect",
  "662924178": "看起来今天不是我们的幸运日。",
  "694278426": "输入您的{deviceName}代码",
  "694920552": "第一个安全码",
  "737192390": "打开 {appName}",
  "740457555": "第二个代码",
  "744377571": "最少 {length} 个字符",
  "751710530": "提交",
  "916760408": "输入设备的用户名和安全码。",
  "921093870": "还没有收到代码？",
  "1068496829": "选择安全问题 {current}/{total}",
  "1079852660": "输入两个连续的安全代码",
  "1080736814": "输入 Symantec VIP Access 应用中的 {fieldName}",
  "1136625613": "该过程已取消。请重试或使用其他身份验证因素。",
  "1242107845": "显示",
  "1254879564": "新密码",
  "1359200231": "发送",
  "1433651550": "输入 OneLogin 短信中的代码。",
  "1477893598": "配置",
  "1536965459": "在您的设备上下载并安装 OneLogin Protect",
  "1624184662": "要设置 OneLogin 短信，我们将通过短信向您发送激活码。您需要此激活码才能完成设备注册。",
  "1654624862": "安全码",
  "1833121415": "提供答案 {current}/{total}",
  "1919587067": "重新发送代码",
  "1935535842": "必填的",
  "1963245695": "1 个大写字母",
  "2018264248": "重试",
  "2091874550": "第一个代码",
  "2097632732": "改为扫描条形码",
  "2104438124": "输入 Symantec VIP Access 中的 {fieldName} 和两个连续的安全码。",
  "2124363772": "输入您的用户名和 SecurID 令牌中的安全码。",
  "2229754167": "输入您的电话号码",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "隐藏",
  "2606375562": "将 YubiKey 插入 USB 端口，然后按下按钮",
  "2663586870": "用户名",
  "2792137744": "1 个数字",
  "2815222727": "扫描此条形码",
  "2859281487": "保护您的帐户需要双因素身份验证。",
  "2942752129": "第二个安全码",
  "3060896801": "遇到问题？",
  "3286567409": "1 个特殊字符",
  "3294346597": "再试一次",
  "3327626662": "输入您的确认码",
  "3374226769": "点击“使用手动输入来配对”",
  "3469481929": "无法扫描此码？",
  "3528672691": "取消",
  "3640052215": "继续",
  "3645029425": "在下面扫描二维码",
  "3645116517": "接听电话时输入以下代码：",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "下一步",
  "3737470122": "请联系管理员获取更多信息。",
  "3781468762": "您的浏览器不支持WebAuthn",
  "3827227259": "确认码已发送至",
  "3855542277": "在应用中输入此代码",
  "3865193889": "激活",
  "3877285238": "1 个小写字母",
  "4000449233": "正在拨打以下电话号码：",
  "4072532148": "重新发送短信代码",
  "4151518079": "选择安全问题 {current} / {total}",
  "4227081527": "应用安装完成后，返回此屏幕并点击 {action}",
  calling: calling$j,
  cancel: cancel$j,
  closeDialog: closeDialog$j,
  confirm: confirm$j,
  downloadOnAppStore: downloadOnAppStore$j,
  getOnGooglePlay: getOnGooglePlay$j,
  linkToAppStore: linkToAppStore$j,
  linkToGooglePlay: linkToGooglePlay$j,
  revert: revert$j
};
var calling$k = "正在撥號";
var cancel$k = "cancel";
var closeDialog$k = "關閉對話方塊";
var confirm$k = "confirm";
var downloadOnAppStore$k = "到 App Store 下載";
var getOnGooglePlay$k = "到 Google Play 取得";
var linkToAppStore$k = "連結到 App Store";
var linkToGooglePlay$k = "連結到 Google Play";
var revert$k = "revert";
var zhTW = {
  "198705281": "輸入你在簡訊中收到的代碼。",
  "374233718": "您可以在 {secLeft, number} {secLeft, plural, one {second} other {seconds}} 之後重試",
  "437305782": "正在驗證您的 WebAuthn 驗證器。",
  "505702857": "魔術連結",
  "519412053": "改變認證因素",
  "655462232": "將 OneLogin 保護下載安裝到你的裝置上",
  "662924178": "看來今天我們運氣不佳。",
  "694278426": "輸入您的 {deviceName} 代碼",
  "694920552": "第一安全代碼",
  "737192390": "開啟 {appName}",
  "740457555": "第二代碼",
  "744377571": "最少 {length} 字元",
  "751710530": "提交",
  "916760408": "從你的裝置輸入用戶名稱和安全代碼。",
  "921093870": "還沒收到代碼嗎？",
  "1068496829": "選擇安全問題 {current}/{total}",
  "1079852660": "輸入兩個連續的安全代碼",
  "1080736814": "從 Symantec VIP Access 應用程式輸入 {fieldName}",
  "1136625613": "流程取消了。請再試一次或使用其它驗證因素。",
  "1242107845": "顯示",
  "1254879564": "新密碼",
  "1359200231": "發送",
  "1433651550": "從 OneLogin 簡訊輸入代碼。",
  "1477893598": "配置",
  "1536965459": "將 OneLogin 保護下載安裝到你的裝置上",
  "1624184662": "為設定 OneLogin 簡訊，我們將經由簡訊發送一個啟用代碼給你。你將需要用這個啟用代碼來完成裝置註冊。",
  "1654624862": "安全代碼",
  "1833121415": "提供答案 {current}/{total}",
  "1919587067": "重新發送代碼",
  "1935535842": "需要的",
  "1963245695": "1 大寫體",
  "2018264248": "再試一次",
  "2091874550": "第一代碼",
  "2097632732": "改為掃瞄條碼",
  "2104438124": "從 Symantec VIP Access 應用程式輸入 {fieldName} 和兩個連續安全代碼。",
  "2124363772": "從你的 SecurID 信物輸入你的用戶名稱和安全代碼。",
  "2229754167": "輸入您的電話號碼",
  "2244720377": "An unexpected error seems to have occurred.",
  "2600324508": "隱藏",
  "2606375562": "將你的 YubiKey 插入 USB 埠然後按下按鈕",
  "2663586870": "用戶名稱",
  "2792137744": "1 數字",
  "2815222727": "掃瞄這個條碼",
  "2859281487": "需要有 2 因素認證來鞏固你的帳號。",
  "2942752129": "第二安全代碼",
  "3060896801": "出問題了嗎？",
  "3286567409": "1 特殊字元",
  "3294346597": "再試一次",
  "3327626662": "輸入您的確認碼",
  "3374226769": "用手動輸入來點擊配對",
  "3469481929": "無法掃瞄條碼嗎？",
  "3528672691": "取消",
  "3640052215": "繼續",
  "3645029425": "掃瞄下方的 QR 代碼",
  "3645116517": "接聽來電時輸入此代碼：",
  "3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
  "3673120330": "下一步",
  "3737470122": "請連絡系統管理員來取得詳情。",
  "3781468762": "您的瀏覽器不支援 WebAuthn",
  "3827227259": "確認碼已傳送至",
  "3855542277": "將這個代碼輸入到應用程式中",
  "3865193889": "啟用",
  "3877285238": "1 小寫體",
  "4000449233": "正在打給以下電話號碼：",
  "4072532148": "重新發送簡訊代碼",
  "4151518079": "選擇安全問題 {current} / {total}",
  "4227081527": "當應用程式被安裝時，回到這個螢幕並點擊 {action}",
  calling: calling$k,
  cancel: cancel$k,
  closeDialog: closeDialog$k,
  confirm: confirm$k,
  downloadOnAppStore: downloadOnAppStore$k,
  getOnGooglePlay: getOnGooglePlay$k,
  linkToAppStore: linkToAppStore$k,
  linkToGooglePlay: linkToGooglePlay$k,
  revert: revert$k
};
var LANGUAGES_MAP = {
  "cs-CZ": csCZ,
  da: da,
  de: de,
  en: en,
  es: es,
  fr: fr,
  "hu-HU": huHU,
  it: it,
  ja: ja,
  ko: ko,
  "ms-MY": msMY,
  nl: nl,
  "pl-PL": plPL,
  pt: pt,
  "ru-RU": ruRU,
  "sk-SK": skSK,
  "th-TH": thTH,
  "tr-TR": trTR,
  "vi-VN": viVN,
  zh: zh,
  "zh-TW": zhTW
};

var removeRegionTag = function removeRegionTag(lang) {
  return lang && lang.split("-")[0];
};

var PRIMARY_LANGUAGES_TAGS = keys(LANGUAGES_MAP).map(removeRegionTag); // Terms: language tag, region tag, primary language tag taken from https://tools.ietf.org/html/rfc5646

/**
 * Resolve best language to use based on user and account settings
 *
 * @param {string} userLanguage language set by user/admin or detected language in browser
 * @param {string} defaultLanguage default language (for account)
 * @param {string[]} enabledLanguages languages enabled by admin (for account). Expecting list of primary language tags (tags without region tag, example: no "zh-TW", just "zh")
 */

var resolveBestLanguage = function resolveBestLanguage(_ref) {
  var _ref$userLanguage = _ref.userLanguage,
      userLanguage = _ref$userLanguage === void 0 ? "" : _ref$userLanguage,
      _ref$defaultLanguage = _ref.defaultLanguage,
      defaultLanguage = _ref$defaultLanguage === void 0 ? "en" : _ref$defaultLanguage,
      _ref$enabledLanguages = _ref.enabledLanguages,
      enabledLanguages = _ref$enabledLanguages === void 0 ? PRIMARY_LANGUAGES_TAGS : _ref$enabledLanguages;
  var primaryTag = removeRegionTag(userLanguage);

  if (enabledLanguages.includes(primaryTag)) {
    if (LANGUAGES_MAP[userLanguage]) {
      return {
        languageTag: userLanguage,
        primaryLanguageTag: primaryTag
      };
    } else if (LANGUAGES_MAP[primaryTag]) {
      return {
        languageTag: primaryTag,
        primaryLanguageTag: primaryTag
      };
    } // else could happen only if LANGUAGES_MAP is not in sync with list of languages in monorail

  }

  return {
    languageTag: defaultLanguage,
    primaryLanguageTag: removeRegionTag(defaultLanguage)
  };
};

var translationsProvider = function translationsProvider(language) {
  return LANGUAGES_MAP[language];
}; // screens


var NARROW_VIEW_WIDTH_LIMIT = "652px";
export { NARROW_VIEW_WIDTH_LIMIT, FatalError, NewPassword, PasswordComplexity, ContactAdmin, LoginLoading, EnterRegistrationCode, PhoneNumberInput, EnterPhoneNumber, SelectMFADevice, FactorList, RegistrationRequired, ScanBarCode, PairProtectOrAuthenticator, InstallProtect$1 as InstallProtect, LoginSecurityCode, CopyCodeManually, EnterYubiKey, DuoFrame, RegisterVipAccess, RegisterSecureId, AnswerSecurityQuestions, ShowPinCode$1 as ShowPinCode, WebAuthn, IconProvider, SingleValueForm, MultiValueForm, Notifications, Modal as ModalDialog, Dimmer, DialogFooter, Heading, Content, ContentBlock, LinksList, VerticalList, LinkButton, Button, Input, Label, StyledTextField as TextField, SearchField, PasswordInput, InlineTextEdit$1 as InlineTextEdit, Menu$1 as Menu, MenuItem, MenuDivider, Loading, Navbar$1 as Navbar, ScrollableContent, Tag, Checkbox, Avatar, Icon, ToDoList, Tooltip, COLORS, FONTS, BREAKPOINTS, svgList, translationsProvider as getTranslations, resolveBestLanguage };